import React, {
  useState,
  useEffect,
  componentDidMount,
  useCallback,
  useRef
} from "react";
import { Link, useNavigate, useLocation, redirect } from "react-router-dom";
import axios from "axios";
import "./styles.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import {
  Card,
  Badge,
  Form,
  Col,
  CardBody,
  Row,
  Container,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Toast,
  ToastHeader,
  ToastBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
  Modal,
  InputGroup,
  InputGroupText,
  Input,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  UncontrolledTooltip,
  Toolbar,
  EmojiSuggestions,
  EmojiSelect,
  FormGroup,
  FormFeedback,
  Collapse
} from "reactstrap";

import classnames from "classnames";
//import { loadAuth2 } from 'gapi-script';
import { gapi, loadAuth2 } from "gapi-script";
import gmailApi from "react-gmail";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import avatar_1 from "../../assets/images/users/avatar-1.jpg";
import avatar_2 from "../../assets/images/users/avatar-2.jpg";
import avatar_3 from "../../assets/images/users/avatar-3.jpg";
import avatar_4 from "../../assets/images/users/avatar-4.jpg";
import avatar_5 from "../../assets/images/users/avatar-5.jpg";
import avatar_6 from "../../assets/images/users/avatar-6.jpg";
import avatar_7 from "../../assets/images/users/avatar-7.jpg";
import gmail_icon from "../../assets/images/mail-server-gmail_48.png";
import outlook_icon from "../../assets/images/mail-server-outlook_48.png";
import mail_custom_icon from "../../assets/images/mail-server-custom_48.png";
//import '../../assets/css/icons.min.css';
import "../../assets/css/app.min.css";
import ReadEmailView from "./ReadEmail";
import Editor, { createEditorStateWithText } from "draft-js-plugins-editor";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Client, Account, Databases, Query } from "appwrite";
import { queries } from "@testing-library/react";
import EmailList from "../E-mail/EmailList";
import getFrenchTag from "../../helpers/local_text_helper";

import love from "../../assets/images/love.gif";
import like from "../../assets/images/like.gif";
import hate from "../../assets/images/hate.gif";
import neutral from "../../assets/images/neutral.gif";
// const { ImapFlow } = require('imapflow');
import aiButtonicon from "./../../assets/images/icons8-bot-48.png";
import logo_smartas_1 from "./../../assets/images/companies/img-3.png";
import logo_shopify from "./../../assets/images/logo_shopify.png";
import logo_prestashop from "./../../assets/images/logo_prestashop_white.png";
import getBoxLocalName from "../../helpers/box_local_text_helper";
import { withTranslation } from "react-i18next";
import {
  copyMailPromise,
  createBoxPromise,
  createLog,
  deleteMailPromise,
  getCollections,
  moveMailPromise,
  searchShopifyOrder,
  createAiTextImprovementFunctionExecution,
  updateCompanyTokenUsage,
  createAIResponseExecution,
  sendMailPromise,
  sendMailDirect,
  SMARTAS,
  getLanguageVersion,
  formatDate,
  fetchSingleMail,
  getSentMessages
} from "../../helpers/api_helper";
import {
  fetchMailsRedux,
  apiError,
  fetchFoldersRedux,
  fetchSingleMailRedux,
  searchMailsRedux,
  emptyMailBox
} from "../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import { element } from "prop-types";
import CrossOutlined from "../../assets/images/icons/CrossOutlined";
import CustomToast from "../../components/Common/customToast/CustomToast";
import CheckGestalt from "../../assets/images/icons/CheckGestalt";
import PlusOutlined from "../../assets/images/icons/PlusOutlined";
import ConversationComponent from "./components/EmailListComponent";
import ExternalLinkDuocolor from "../../assets/images/icons/ExternalLinkDuocolor";
import DollarDuocolor from "../../assets/images/icons/DollarDuocolor";
import CheckCircleMono from "../../assets/images/icons/CheckCircleMono";
import TruckFilled from "../../assets/images/icons/TruckFilled";
import { fetchClientInfos } from "../../store/actions";

import maaiaIconInfoPink from "../../assets/images/icons-infos-pink.png";
import maaiaIconInfoPurple from "../../assets/images/icons-infos-purple.png";
import { useMixpanel } from "../../Hooks/useMixpanel";
import "draft-js/dist/Draft.css";

import createToolbarPlugin, { Separator } from "draft-js-static-toolbar-plugin";
import { ItalicButton, BoldButton, UnderlineButton } from "draft-js-buttons";
import createEmojiPlugin from "draft-js-emoji-plugin";
import {
  EditorState,
  convertFromRaw,
  ContentState,
  convertFromHTML,
  Modifier,
  convertToRaw,
  stateToHTML,
  RichUtils
} from "draft-js";
import EmailRedact from "./EmailRedact";
import { useFormik } from "formik";
import * as Yup from "yup";
import { act } from "react";

const CLIENT_ID =
  "505437851076-gumpc4op5af3rq22g8bieipo4ma9ut9q.apps.googleusercontent.com";
const SCOPES = "https://www.googleapis.com/auth/gmail.readonly";

// Define a default theme for the BoldButton
const theme = {
  buttonWrapper: "buttonWrapper",
  button: "button",
  active: "activeButton"
};

const GlobaleInbox = (props) => {
  // document.title = "Boite de réception  | Synibox - Smart Assistant";
  const navigate = useNavigate();

  const { state } = useLocation();

  const dispatch = useDispatch();

  const { mixPanelTrack } = useMixpanel();

  const [isColumnVisible, setColumnVisibility] = useState(true);
  const [btnprimary1, setBtnprimary1] = useState(false);
  const [btnprimary2, setBtnprimary2] = useState(false);

  const [fullMessage, setFullMessage] = useState(undefined);
  const [sentMessage, setSentMessage] = useState(undefined);

  const [folderbtn, setfolderbtn] = useState(false);
  // const [the_folder, setMailBox] = useState("INBOX");
  const [allowedMessages, setAllowedMessages] = useState([]);
  // const [user_prefs, setUserPrefs] = useState(undefined);
  const [tagbtn, settagbtn] = useState(false);
  const [menubtn, setmenubtn] = useState(false);
  const [showDeletionToast, setDeletionToast] = useState(false);
  const [timeCount, setTimeCount] = useState(10);
  const [toastMessage, setToastMessage] = useState("");
  const [isSignedIn, setIsSignedIn] = useState(false);
  // const [messages, setMessages] = useState([]);
  // const [boxes, setBoxes] = useState([]);
  const [messageInfos, setMessageInfos] = useState({});
  const [messagesTagsList, setMessagesTagsList] = useState({});
  const [messagesStateList, setMessagesStateList] = useState({});
  const [messageOrderInfos, setMessageOrderInfos] = useState({});
  // const [error, setError] = useState(undefined);
  // const [loading, setLoading] = useState(false);
  // const [boxes_loading, setBoxesLoading] = useState(false);
  const [request, setRequest] = useState(true);
  // const [client_data, setCompanyInfos] = useState();
  const [modal_backdrop, setModalVisibility] = useState(false);
  const [create_box_modal_visibility, setCreateBoxModalVisibility] =
    useState(false);
  const [modal_dossier, setmodal_dossier] = useState(false);
  const [type, setType] = useState("");
  const [mailActionLoading, setMailActionLoading] = useState(undefined);
  const [emailMoveOrCopyLoading, setEmailMoveOrCopyLoading] = useState(false);
  //const timer = setTimeout(() => { }, 20000);
  const [currentColor, setCurrentColor] = useState("blue");
  const pageSize = 30;
  // const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [totalMails, setTotalMails] = useState(0);
  // const startIndex = (currentPage - 1) * pageSize;
  // const endIndex = startIndex + pageSize;
  const [showReadEmailView, setShowReadEmailView] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(undefined); // État pour stocFexpker le message sélectionné
  const [previousselectedMessage, setPreviousSelectedMessage] =
    useState(undefined);
  const [selectedMessageNext, setSelectedMessageNext] = useState(undefined);
  const [selectedMessageNextIndex, setSelectedMessageNextIndex] =
    useState(undefined);
  const [multiSelectedMessage, setMultiSelectedMessage] = useState([]);
  const [messageToDelete, setMessageToDelete] = useState(undefined); // État pour stocFexpker le message sélectionné
  const [dossierName, setDossierName] = useState("");
  // const [currentEmployee, setCurrentEmployee] = useState(undefined);
  // const [ownerInfos, setOwnerInfos] = useState({});
  // const [getMessages, setGetMessages] = useState([]);
  const [decompte, setDecompte] = useState(10);
  const [startCountdown, setStartCountdown] = useState(false);
  const [actionPerformed, setActionPerformed] = useState(false);
  const [recherche, setRecherche] = useState("");
  const [displaySearchBar, setDisplaySearchBar] = useState(false);
  const [create_message_modal_visibility, setCreateMessageModalVisibility] =
    useState(false);
  const [to_email, setToEmail] = useState(undefined);
  const [no_configured_mailbox, setNoConfiguredMailbox] = useState(false);

  const [instruction_text, setInstructionText] = useState(""); // État pour stocFexpker le message sélectionné
  const [copie, setCopie] = useState("");
  const [objet, setObjet] = useState("");
  const [destinataire, setDestinataire] = useState("");

  //  const [topicList, setTopicList] = useState([]);
  // ...
  const handleChangeColor = (color) => {
    const root = document.documentElement;
    root?.style.setProperty("--bs-blue", color ? color : "red");
    console.log("applyed color");
    // root?.style.setProperty("--text-color", darkTheme ? "#fff" : "#262833");
    //   setCurrentColor(color);
  };

  const emojiPlugin = createEmojiPlugin();
  const { EmojiSuggestions, EmojiSelect } = emojiPlugin;
  const text = "";
  const toolbarPlugin = createToolbarPlugin();
  const { Toolbar } = toolbarPlugin;
  const plugins = [toolbarPlugin, emojiPlugin];

  // modal
  const [moveToModal, setMoveToModal] = useState(false);
  const [moveToIsConfirmed, setMoveToIsConfirmed] = useState(false);
  const [folder, setFolder] = useState();

  const [alertList, setAlertList] = useState({});

  const customOrder = [
    "inbox",
    "sent",
    "treated",
    "untreated",
    "starred",
    "archive",
    "draft",
    "trash"
  ];

  const [completeMessages, setCompleteMessages] = useState({});

  const [aiImprovmentsDisabled, setAiImprovmentsDisabled] = useState({
    value: false,
    reason: ""
  });
  const [aiSuggestionDisabled, setAiSuggestionDisabled] = useState({
    value: false,
    reason: ""
  });
  const [messageTreatmentStatus, setMessageTreatmentStatus] = useState(false);
  const [email_suggested_text, setEmailSuggestedText] = useState("");

  const [ai_action_menu, setAiActionMenu] = useState(false);

  const [instruction_request, setInstructionRequestValue] = useState(false);
  const [send_email_request, setSendEmailRequestValue] = useState(false);

  // New Editor
  const [customEditorState, setCustomEditorState] = useState(
    createEditorStateWithText(text)
  );
  const editorRef = useRef(null);

  const [toast, setToast] = useState(false);

  const focusEditor = () => {
    editorRef.current.focus();
  };

  const onCompleteMessages = (val) => {
    setCompleteMessages(val);
  };

  const handleTopicsUpdate = (topics) => {
    setMessageInfos(topics);
  };

  // Comparaison personnalisée
  const equalityFunction = (prev, next) => {
    return (
      prev.messages === next.messages &&
      prev.error === next.error &&
      prev.loading === next.loading &&
      prev.boxes_loading === next.boxes_loading &&
      prev.boxes === next.boxes &&
      prev.currentPage === next.currentPage &&
      prev.totalPages === next.totalPages &&
      prev.currentBox === next.currentBox &&
      prev.isSearch === next.isSearch &&
      prev.folders_fetchError === next.folders_fetchError
    );
  };

  const equalityFunction2 = (prev, next) => {
    return (
      prev.boxes === next.boxes &&
      prev.folders_fetchError === next.folders_fetchError
    );
  };

  const { client_data, currentEmployee, topicList } = useSelector((state) => {
    const theClientData = state.GeneralStateRedux.client_data;
    let theTopicList = [];
    let theCurrentEmployee;
    if (theClientData) {
      const employees = theClientData.collaborators ?? [];
      var user_id = JSON.parse(localStorage.getItem("authUser")).userId;

      // const employees = employeesList.map((element) => JSON.parse(element));
      const emp = employees.filter((element) => element.id === user_id);
      if (emp && emp.length > 0) {
        // setCurrentEmployee(currentEmployee[0]);
        theCurrentEmployee = emp[0];
      }

      const parsedCompanyData = theClientData.company_data.map((item) => {
        try {
          return JSON.parse(item);
        } catch (error) {
          console.error("Erreur de parsing JSON :", error);
          return null;
        }
      });

      console.log(
        "clientInfos.company_data après le parsing :",
        parsedCompanyData
      );
      theTopicList = parsedCompanyData;
    }

    return {
      client_data: theClientData,
      topicList: theTopicList,
      currentEmployee: theCurrentEmployee
    };
  });

  function findMostCommonDelimiter(folders) {
    console.log("findMostCommonDelimiter", folders);

    let mostCommonDelim = ".";
    if (folders && folders.length > 0) {
      mostCommonDelim = folders[0].delim;
    }
    console.log("findMostCommonDelimiter delim", mostCommonDelim);

    return mostCommonDelim;
  }

  function reorderFolders(the_folders_redux) {
    // Filtrer les dossiers en retirant le dossier parent "SMARTAS"
    const filteredList = the_folders_redux.filter((item) => {
      const name = item.name.toUpperCase();
      return (
        name === "INBOX" ||
        (name !== "SMARTAS" &&
          name !== "INBOX.SMARTAS" &&
          (name.startsWith("SMARTAS") || name.startsWith("INBOX.SMARTAS")))
      );
    });

    // Trier les dossiers : INBOX en premier, puis sous-dossiers SMARTAS, puis le reste
    const sortedList = filteredList.sort((a, b) => {
      const folderA = a.name.toUpperCase();
      const folderB = b.name.toUpperCase();

      // Placer "INBOX" en premier
      if (folderA === "INBOX") return -1;
      if (folderB === "INBOX") return 1;

      // Ensuite les dossiers "SMARTAS", en ignorant le dossier parent "SMARTAS"
      if (folderA.startsWith("SMARTAS")) return -1;
      if (folderB.startsWith("SMARTAS")) return 1;

      return 0; // Maintenir l'ordre pour les autres dossiers
    });

    // Séparer en dossiers de type SMARTAS et autres
    const maiaFolders = sortedList.filter((item) => {
      const name = item.name.toLowerCase();
      return ["inbox", "sent", "treated", "untreated"].some((keyword) =>
        name.includes(keyword)
      );
    });

    const otherFolders = sortedList.filter(
      (item) => !maiaFolders.includes(item)
    );

    // Combiner les dossiers SMARTAS en premier, puis les autres
    const finalSort = [...maiaFolders, ...otherFolders];

    // Ajouter des dossiers par défaut s'ils n'existent pas
    const objectsToAdd = [
      { name: "Sent" },
      { name: "Treated" },
      { name: "Untreated" },
      { name: "Starred" },
      { name: "Archive" },
      { name: "Drafts" },
      { name: "Trash" }
    ];

    objectsToAdd.forEach((newObj) => {
      const isObjectExist = finalSort.some((existingItem) =>
        existingItem.name.includes(newObj.name)
      );
      if (!isObjectExist) {
        finalSort.push(newObj);
      }
    });

    return finalSort;
  }

  const { boxes_loading, boxes } = useSelector((state) => {
    /////////////////////////////////////////// FOLDERS //////////////////////////////////////////
    const theID = state.mails_redux.folders_response?.id;
    // console.log("state.mails_redux is", state.mails_redux);
    // console.log("state.mails_redux.folders_response is", state.mails_redux.folders_response);
    // const folders_redux = state.mails_redux.folders_response?.folders ?? [];
    const folders_redux = {
      [theID]: state.mails_redux.folders_response?.data?.folders ?? []
    };

    // console.log("folders_redux is", folders_redux);

    const oldFolders = localStorage.getItem("boxes");
    let folders_map = {};
    let the_folders_redux = [];

    if (
      folders_redux &&
      theID &&
      folders_redux[theID] &&
      folders_redux[theID].length > 0
    ) {
      the_folders_redux = reorderFolders(folders_redux[theID] ?? []);
      folders_map[theID] = the_folders_redux;
      localStorage.setItem("boxes", JSON.stringify(folders_map));
    } else if (oldFolders !== null) {
      // console.log(`has cached folders`, oldFolders);
      const oldFoldersJson = JSON.parse(oldFolders);
      // console.log("oldFoldersJson is", oldFoldersJson);
      folders_map = oldFoldersJson;
      // console.log("the_folders_redux is", the_folders_redux);
    } else {
      // console.log("No cached folders nore folders_redex", oldFolders);
      // console.log("Using empty folders_redux", folders_redux.length);

      the_folders_redux = reorderFolders(
        theID && folders_redux[theID] ? folders_redux[theID] : []
      );
      folders_map[theID] = the_folders_redux;
      localStorage.setItem("boxes", JSON.stringify(folders_map));
    }

    console.log("folders_map", folders_map);

    return {
      boxes_loading: state.mails_redux.folders_loading,
      boxes: folders_map
    };
  }, equalityFunction2);

  const {
    email_conversations,
    error,
    loading,
    currentPage,
    totalPages,
    currentBox,
    isSearch
  } = useSelector((state) => {
    const theBox = state.mails_redux.response?.currentBox ?? "INBOX";
    console.log("folder is", theBox);

    const serverMessagesMap = {
      [theBox]: state.mails_redux.response?.data.mails ?? undefined
    };
    console.log("STOREEE mess is", serverMessagesMap);
    // onOldMsg(msg);

    let messages_map = {};

    const storedMessagesData = localStorage.getItem(
      `cached_messages_${localStorage.getItem(
        "companyId"
      )}_${localStorage.getItem("selected_mail_box")}`
    );
    let storedMessageMap;

    if (
      storedMessagesData !== null &&
      storedMessagesData !== undefined &&
      storedMessagesData !== "undefined"
    ) {
      console.log("STOREEE storedMessageMap", storedMessagesData, theBox);
      storedMessageMap = JSON.parse(storedMessagesData);
    }

    if (theBox && theBox === getBoxFromUrl()) {
      if (serverMessagesMap && serverMessagesMap[theBox]) {
        console.log(
          "STOREEE ServerMessagesMap",
          serverMessagesMap[theBox].length,
          theBox
        );

        if (storedMessageMap) {
          storedMessageMap[theBox] = serverMessagesMap[theBox];
          messages_map[theBox] = storedMessageMap[theBox];
        } else {
          storedMessageMap = {};
          storedMessageMap[theBox] = serverMessagesMap[theBox];
          messages_map[theBox] = storedMessageMap[theBox];
        }
        if (state.mails_redux.response?.currentPage === 1) {
          console.log("STOREEE Saving to storage", storedMessageMap, theBox);
          localStorage.setItem(
            `cached_messages_${localStorage.getItem(
              "companyId"
            )}_${localStorage.getItem("selected_mail_box")}`,
            JSON.stringify(storedMessageMap)
          );
        } else {
          console.log(
            "STOREEE No Saving to storage",
            state.mails_redux.response?.currentPage,
            theBox
          );
        }
      } else if (storedMessageMap && storedMessageMap[theBox]) {
        console.log(
          "STOREEE NO SERVER DATA but has STORED data",
          storedMessageMap[theBox].length,
          theBox
        );

        // messages_map[getBoxFromUrl()] = messages_mapJSON[getBoxFromUrl()];
        messages_map[theBox] = storedMessageMap[theBox];
      } else {
        console.log(
          "STOREEE no localstorage neither store",
          storedMessagesData,
          theBox
        );
        messages_map[theBox] = [];
      }
    } else {
      console.log("STOREEE  DIFFERENT BOXES", getBoxFromUrl(), theBox);
      if (storedMessageMap) {
        messages_map[getBoxFromUrl()] = storedMessageMap[getBoxFromUrl()];
      } else {
        messages_map[getBoxFromUrl()] = [];
      }
    }

    return {
      email_conversations: messages_map,
      error: state.mails_redux.fetchError,
      loading: state.mails_redux.loading,
      boxes_loading: state.mails_redux.folders_loading,
      currentPage: state.mails_redux.response?.currentPage ?? 1,
      totalPages: state.mails_redux.response?.totalPages ?? 1,
      isSearch: state.mails_redux.response?.isSearch,
      currentBox: theBox
    };
  }, equalityFunction);

  // const onBoxChanged = (value) => {
  //   setMailBox(value);
  // };

  const onFolderChanged = (value) => {
    setFolder(value);
  };

  const onMailActionLoading = (value) => {
    setMailActionLoading(value);
  };

  const onMoveToConfirmed = () => {
    setMoveToIsConfirmed(true);
  };
  function tog_Modal(folder) {
    setMoveToModal(!moveToModal);

    if (folder) {
      setFolder(folder);
    }
  }

  const toggleToast = () => {
    console.log("setToast before: " + toast);
    setToast(true);
    console.log("setToast after: " + toast);

    setTimeout(() => {
      setToast(false);
    }, 3000);
  };

  let timeoutId;
  let seconds = 10;

  async function getAlerts(messageId) {
    try {
      if (!localStorage.getItem("companyId")) {
        return;
      }

      const client = new Client();
      const databases = new Databases(client, "default");
      client
        .setEndpoint(process.env.REACT_APP_DATABASEURL)
        .setProject(process.env.REACT_APP_PROJECTID);

      const response = await databases.listDocuments("default", "alert", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.equal("active", true),
        Query.equal("client_message_id", messageId),
        Query.limit(100),
        Query.orderDesc("$createdAt")
      ]);
      // console.log("getAlert", { messageId, alerts: response.documents });
      return response.documents;
    } catch (error) {
      console.error("Failed to fetch alert data:", error);
      throw error; // Vous pouvez relancer l'erreur ou gérer l'erreur de manière appropriée ici
    }
  }
  async function getMessageInfos(messageID) {
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      // console.log("Fetching message info for " + messageID);
      const response = await databases.listDocuments("default", "message", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.equal("conversation_id", messageID)
      ]);
      // console.log("response.documents.length is ", response.documents.length);
      return response.documents.length > 0 ? response.documents[0] : undefined;
    } catch (error) {
      console.log(error); // Echec
      // console.log("Failed to fetch message info:", error);
      return undefined;
    }
  }

  async function getMessageTags(messageID) {
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    return databases
      .listDocuments("default", "message", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.select(["contact_reasons"]),
        Query.equal("conversation_id", messageID)
      ])
      .then(
        function (response) {
          var tags = [];
          for (let index = 0; index < response.documents.length; index++) {
            const element = response.documents[index];
            tags = [...tags, ...element.contact_reasons];
          }
          return tags;
        },
        function (error) {
          console.log(error); // Echec
          console.log("Failed to fetch message info:", error);
          return [];
        }
      );
  }

  function getFormatedAddress(address) {
    const city =
      address.city && address.city.names ? address.city.names.fr : "";

    const country = address.country ? address.country : "";
    return city + " " + country;
  }

  function getTextForAction(action) {
    switch (action) {
      case "delete":
        return "Deleting";
      case "move":
        return "Moving";
      case "create":
        return "Creating";
      case "copy":
        return "Copying";
      default:
        return "Chargement";
    }
  }

  function changeColor(tag) {
    switch (tag) {
      case "product":
        return "primary";
      case "product_availability":
        return "primary";
      case "product_advice":
        return "primary";
      case "product_problems":
        return "danger";
      case "product_price":
        return "primary";
      case "promotions":
        return "primary";
      case "order":
        return "danger";
      case "order_process":
        return "primary";
      case "payments":
        return "danger";
      case "refunds":
        return "danger";
      case "disputes":
        return "danger";
      case "billing":
        return "warning";
      case "delivery":
        return "danger";
      case "returns":
        return "warning";
      case "customer_account":
        return "info";
      case "password":
        return "info";
      case "security":
        return "info";
      case "privacy":
        return "info";
      case "customer_data":
        return "info";
      case "after_sales":
        return "info";
      case "technical_problems":
        return "primary";
      case "website_feedback":
        return "info";
      case "special_programs":
        return "info";
      case "affiliation":
        return "info";
      case "customer_loyalty":
        return "info";
      case "feedback":
        return "info";
      case "complaints":
        return "warning";
      case "company_information":
        return "info";
      case "ethics_social_responsibility":
        return "info";
      case "subscription_management":
        return "info";
      case "store_services":
        return "info";
      case "influencers":
        return "info";
      case "content_creators":
        return "info";
      case "spam":
        return "warning";
      case "other":
        return "info";
      default:
        return "warning";
    }
  }

  // const customOrder = [
  //   "maia.inbox",
  //   "maia.sent",
  //   "maia.treated",
  //   "maia.untreated",
  //   "maia.starred",
  //   "maia.archive",
  //   "maia.draft",
  //   "maia.trash",
  // ];

  const stringToColour = (str) => {
    let hash = 0;
    str.split("").forEach((char) => {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    });
    let colour = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += value.toString(16).padStart(2, "0");
    }

    // Vérifiez si la couleur générée est dans la plage de jaune
    if (/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(colour)) {
      const hexValue = colour.replace("#", "");
      const r = parseInt(hexValue.slice(0, 2), 16);
      const g = parseInt(hexValue.slice(2, 4), 16);
      const b = parseInt(hexValue.slice(4, 6), 16);

      // YELLOW
      if (r >= 200 && g >= 200 && b < 100) {
        colour = "#FF5733";
      }

      // WHITE
      const whiteThreshold = 200;
      if (r >= whiteThreshold && g >= whiteThreshold && b >= whiteThreshold) {
        colour = "#333333";
      }
    }

    // return colour;
    return "#5E44FE";
  };
  // Fonction de traduction basée sur un switch
  /*
  const translateContactReasons = (reasons) => {
    const translatedReasons = reasons.map((reason) => {
      switch (reason) {
        case "product":
          return "Informations sur le produit";
        case "product_price":
          return "Prix du produit";
        case "refund":
          return "Remboursement";
         default:
          return reason;
      }
    }); 
     settranslatedReasons(translatedReasons);
   };*/

  // const onLoading = (val) => {
  //   setLoading(val);
  // };

  // const onBoxesLoading = (val) => {
  //   setBoxesLoading(val);
  // };
  /*
  const client = new ImapFlow({
    host: 'mail.integracom.fr',
    port: 993,
    secure: true,
    auth: {
        user: 'a.anihouvi@integracom.fr',
        pass: 'KdbgsKCo).taIUGH'
    }
});
*/

  /*
const getIMAPMails = async () => {
  // Wait until client connects and authorizes
  await client.connect();

  // Select and lock a mailbox. Throws if mailbox does not exist
  let lock = await client.getMailboxLock('INBOX');
  try {
      // fetch latest message source
      // client.mailbox includes information about currently selected mailbox
      // "exists" value is also the largest sequence number available in the mailbox
      let message = await client.fetchOne(client.mailbox.exists, { source: true });
      console.log(message.source.toString());

      // list subjects for all messages
      // uid value is always included in FETCH response, envelope strings are in unicode.
      for await (let message of client.fetch('1:*', { envelope: true })) {
          console.log(`${message.uid}: ${message.envelope.subject}`);
      }
  } finally {
      // Make sure lock is released, otherwise next `getMailboxLock()` never returns
      lock.release();
  }

  // log out and close connection
  await client.logout();
};
*/

  /*
  const signOut = async () => {
    var auth2 = gapi.auth2.getAuthInstance();
    await auth2.signOut();
    console.log("User signed out.");
    if (!auth2.isSignedIn.get()) {
      setIsSignedIn(auth2.isSignedIn.get());

      setToastMessage(
        "Vous avez révoqué la synchronisation à votre boite e-mail."
      );
      toggleToast();
    }
  };
  const handleSignIn = async () => {
    try {
      const auth = await loadAuth2(gapi, CLIENT_ID, SCOPES);
      // const auth2 = await loadAuth2(gapi, process.env.REACT_APP_CLIENT_ID, '')

      if (!auth.isSignedIn.get()) {
        await auth.signIn();
      }
      setIsSignedIn(auth.isSignedIn.get());
      // Si l'utilisateur est connecté, obtenez l'accès à l'API Gmail.
      if (auth.isSignedIn.get()) {
        const googleUser = auth.currentUser.get();
        const accessToken = googleUser.getAuthResponse().access_token;
        // Utilisez `accessToken` pour accéder à l'API Gmail.
        console.log(`Access token: ${accessToken}`);
        getMessages();
      }
    } catch (error) {
      console.error(error);
    }
  };


  const loadGmailEmailsIfConnected = async () => {
    try {
      const auth = await loadAuth2(gapi, CLIENT_ID, SCOPES);
      // const auth2 = await loadAuth2(gapi, process.env.REACT_APP_CLIENT_ID, '')

      setIsSignedIn(auth.isSignedIn.get());
      // Si l'utilisateur est connecté, obtenez l'accès à l'API Gmail.
      if (auth.isSignedIn.get()) {
        const googleUser = auth.currentUser.get();
        const accessToken = googleUser.getAuthResponse().access_token;
        // Utilisez `accessToken` pour accéder à l'API Gmail.
        console.log(`Access token: ${accessToken}`);
        getMessages();
      }
    } catch (error) {
      console.error(error);
    }
  };

    const getMessages = async () => {
    setTimeout(async () => {
      const res = await gmailApi.getMessages(false, 15);
      var data = gmailApi.normalizeData(res);
      setMessages(data);
      // var body = gmailApi.getBody(res);
      //  console.log("body is");
      //  console.log(body);
    }, 2000);
  };
  */

  /*
  const onUserPrefsChange = (val) => {
    setUserPrefs(val);
  };
  */

  const handleThemeChange = () => {
    console.log(`them color changed`);
    document.documentElement.style.setProperty("--bs-blue", "red");
  };

  // async function getClientData() {
  //   setRequest(true);

  //   const client = new Client();

  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   const promise = databases.getDocument("default", "client_infos", localStorage.getItem("companyId"));

  //   promise.then(
  //     async function (response) {
  //       var data = response;
  //       console.log({ CompanyInfos: response });
  //       setCompanyInfos(data);
  //       setRequest(false);

  //       const employees = response.collaborators ?? [];
  //       var user_id = JSON.parse(localStorage.getItem("authUser")).userId;

  //       // const employees = employeesList.map((element) => JSON.parse(element));
  //       const currentEmployee = employees.filter((element) => element.id === user_id);
  //       if (currentEmployee && currentEmployee.length > 0) {
  //         setCurrentEmployee(currentEmployee[0]);
  //       }

  //       const parsedCompanyData = data.company_data.map((item) => {
  //         try {
  //           return JSON.parse(item);
  //         } catch (error) {
  //           console.error("Erreur de parsing JSON :", error);
  //           return null;
  //         }
  //       });

  //       setTopicList(parsedCompanyData);

  //       console.log("clientInfos.company_data après le parsing :", parsedCompanyData);
  //     },
  //     function (error) {
  //       console.log(error); // Failure
  //       setRequest(false);
  //     }
  //   );
  // }

  const { freeTranslationLimit, userPlan } = useSelector((state) => ({
    userPlan: state.subscription.userPlan,

    freeTranslationLimit: state.subscription.freeTranslationLimit
  }));

  async function incrementAttr() {
    if (!client_data) {
      return;
    }

    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    let promise;
    if (client_data.free_translation_count < freeTranslationLimit) {
      promise = databases.updateDocument(
        "default",
        "client_infos",
        localStorage.getItem("companyId"),
        {
          free_translation_count:
            (client_data.free_translation_count || 0) +
            SMARTAS.MAIL_COST[userPlan]
        }
      );
    } else {
      promise = databases.updateDocument(
        "default",
        "client_infos",
        localStorage.getItem("companyId"),
        {
          consumed_email_count:
            (client_data.consumed_email_count || 0) +
            SMARTAS.MAIL_COST[userPlan] / 4
        }
      );
    }

    promise.then(
      async function (response) {
        var data = response;
        console.log({ CompanyInfos: response });
        dispatch(fetchClientInfos());
        // setCompanyInfos(data);
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        let logData = {
          eventCreatedAt: Date.now(),
          author_id: user_id,
          company_id: client_data.$id,
          reason: "Text translation"
        };
        let payload = {
          event: "credit_consumed",
          author_id: user_id,
          company_id: client_data.$id,
          log_data: JSON.stringify(logData)
        };
        createLog(payload, mixPanelTrack);
        dispatch(fetchClientInfos());
      },
      function (error) {
        console.log(error); // Failure
      }
    );
  }

  async function incrementAttrByValue(value, reason) {
    if (!client_data) {
      return;
    }

    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      {
        consumed_email_count: (client_data.consumed_email_count || 0) + value
      }
    );

    promise.then(
      async function (response) {
        var data = response;
        console.log({ CompanyInfos: response });
        dispatch(fetchClientInfos());
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        let logData = {
          eventCreatedAt: Date.now(),
          author_id: user_id,
          company_id: client_data.$id,
          reason
        };
        let payload = {
          event: "credit_consumed",
          author_id: user_id,
          company_id: client_data.$id,
          log_data: JSON.stringify(logData)
        };
        createLog(payload, mixPanelTrack);
        dispatch(fetchClientInfos());
      },
      function (error) {
        console.log(error); // Failure
      }
    );
  }

  function togModalVisibility() {
    setModalVisibility(!modal_backdrop);
  }
  function togModalDossierVisibility() {
    setmodal_dossier(!modal_dossier);
  }

  // Méthode contenant l'alert
  function showAlert(text) {
    alert("Raccourci clavier Ctrl (ou Command) + A pressé !");
  }

  const handleKeyPressForSearch = (event) => {
    if (event.key === "Enter") {
      // Si la touche "Entrée" est pressée, lancez la recherche
      if (recherche.length > 0) {
        closeMessageView();
        searchMails(client_data);
      }
    }
  };
  const clearSearch = (event) => {
    setRecherche("");
    // onLoading(true);

    if (!loading) {
      dispatch(
        fetchMailsRedux(
          localStorage.getItem("companyId"),
          getBoxFromUrl(),
          1,
          pageSize,
          []
        )
      );
    }
    // fetchMails(localStorage.getItem('companyId'), the_folder);
  };

  function handleKeyPress(event) {
    if (event.key === "c" && (event.ctrlKey || event.metaKey)) {
      //setType("copy");
      //togModalDossierVisibility();
    }

    if (event.key === "x" && (event.ctrlKey || event.metaKey)) {
      // setType("move");
      // togModalDossierVisibility();
    }

    if (event.key === "Delete" || event.key === "Backspace") {
      // moveMail(selectedMessage.messageId, the_folder, "Trash");
      // closeMessageView();
    }
  }
  // Ajoutez un écouteur d'événement pour la touche "A"
  document.addEventListener("keydown", handleKeyPress);

  const searchMails = async function (client_data) {
    // onLoading(true);

    // Helper function for making the API request
    const makeApiRequest = async function (apiUrl, folder) {
      axios
        .get(apiUrl, {
          params: {
            search: recherche,
            company_id: client_data.$id,
            folder,
            page: currentPage,
            limit: pageSize,
            day_since: 30
          }
        })
        .then(async (response) => {
          console.log("makeApiRequest response is", response);
          // TODO setMessages(response.mails);
          setTotalPage(response.totalPages);
          setTotalMails(response.totalMails);
        })
        .catch((error) => {
          // Handle the error
          // onLoading(false);
          console.log("Error for makeApiRequest is ", error);

          console.log(JSON.stringify(error));
          // TODO setError(JSON.stringify(error));
        });
    };

    const apiUrl = "https://mailbox.semecloud.tech/search-mails";
    // const apiUrl = "http://localhost:55000/get-threads";
    await makeApiRequest(apiUrl, getBoxFromUrl() ? getBoxFromUrl() : "INBOX");
  };

  async function fetchMessageTags(messageId, the_message) {
    const tags =
      messageInfos[messageId] && messageInfos[messageId].contact_reasons
        ? messageInfos[messageId].contact_reasons
        : [];
    if (tags.length > 0) {
      const updatedTags = messagesTagsList[the_message.directMessageId] || [];

      for (let index = 0; index < tags.length; index++) {
        if (!updatedTags.includes(tags[index])) {
          updatedTags.push(tags[index]);
        }
      }
      setMessagesTagsList((prevState) => ({
        ...prevState,
        [the_message.directMessageId]: updatedTags
      }));
    }
  }

  const countDownForDeletion = async () => {
    if (decompte <= 1 && startCountdown === true) {
      setStartCountdown(false); // Arrête le décompte lorsque le décompte atteint 0
      setDecompte(10);
      if (messageToDelete) {
        if (getBoxFromUrl() !== "Trash") {
          const movePromises = messageToDelete.map((id) =>
            moveMail(id, getBoxFromUrl(), "Trash", true)
          );

          try {
            // Attendre que toutes les promesses soient résolues
            await Promise.all(movePromises);
            deleteMailFromCache();
            dispatch(
              fetchMailsRedux(
                localStorage.getItem("companyId"),
                getBoxFromUrl(),
                pageSize,
                []
              )
            );
            console.log("Tous les mails ont été supprimés avec succès.");
          } catch (error) {
            console.error(
              "Une erreur est survenue lors de la suppression des mails:",
              error
            );
          }
        } else {
          const deletePromises = messageToDelete.map((id) =>
            deleteMail(id, getBoxFromUrl())
          );

          try {
            // Attendre que toutes les promesses soient résolues
            await Promise.all(deletePromises);
            deleteMailFromCache();
            dispatch(
              fetchMailsRedux(
                localStorage.getItem("companyId"),
                getBoxFromUrl()
              )
            );
            console.log("Tous les mails ont été supprimés avec succès.");
          } catch (error) {
            console.error(
              "Une erreur est survenue lors de la suppression des mails:",
              error
            );
          }
        }
      }
    }
  };

  const stopDeletionCountdown = () => {
    setStartCountdown(false); // Arrête le décompte lorsque le décompte atteint 0
    setDecompte(10);
    setMessageToDelete(null);
  };

  async function triggerTimeout() {
    await new Promise((resolve) => setTimeout(resolve, 5000));
    setActionPerformed(false);
  }

  useEffect(() => {
    let interval;

    if (startCountdown) {
      interval = setInterval(() => {
        setDecompte((prevDecompte) => prevDecompte - 1);
      }, 1000);
    }

    return () => clearInterval(interval); // Nettoyer l'intervalle lors du démontage du composant
  }, [startCountdown]);

  useEffect(() => {
    countDownForDeletion();
  }, [decompte]);

  useEffect(() => {
    // onLoading(true);
    if (!localStorage.getItem("selected_mail_box")) {
      if (client_data && client_data.mailBox.length > 0) {
        localStorage.setItem("selected_mail_box", client_data.mailBox[0].email);
      } else {
        setNoConfiguredMailbox(true);
        return;
      }
    }

    setTimeout(() => {
      initData();
    }, 1000);
  }, []);

  useEffect(() => {
    if (parentDivRef.current) {
      const parentDiv = parentDivRef.current;

      const handleScroll = () => {
        // Vérifiez si l'élément div atteint la fin de la liste
        if (
          parentDiv.scrollTop + parentDiv.clientHeight >=
          parentDiv.scrollHeight
        ) {
          // Charger et ajouter plus de données
          // console.log("handleScroll loading", loading);
          console.log("handleScroll messages", email_conversations);
          console.log(
            "handleScroll last message ID",
            email_conversations &&
              email_conversations[getBoxFromUrl()] &&
              email_conversations[getBoxFromUrl()].length > 0
              ? email_conversations[getBoxFromUrl()][
                  email_conversations[getBoxFromUrl()].length - 1
                ]["directMessageId"]
              : undefined
          );
          // console.log("handleScroll getBoxFromUrl()", getBoxFromUrl());
          // console.log("handleScroll totalPages", totalPages);

          if (
            email_conversations[getBoxFromUrl()] &&
            email_conversations[getBoxFromUrl()].length >= pageSize &&
            !loading &&
            currentPage + 1 <= totalPages
          ) {
            console.log("handleScroll Launch next page");
            dispatch(
              fetchMailsRedux(
                localStorage.getItem("companyId"),
                getBoxFromUrl(),
                currentPage + 1,
                pageSize,
                email_conversations[getBoxFromUrl()]
              )
            );
          }
        }
      };

      parentDiv.addEventListener("scroll", handleScroll);

      // Nettoyer l'écouteur d'événement lors du démontage du composant
      return () => {
        parentDiv.removeEventListener("scroll", handleScroll);
      };
    }
  }, [loading, email_conversations]);

  useEffect(() => {
    console.log({ messages_ff: email_conversations[getBoxFromUrl()] });

    if (
      email_conversations[getBoxFromUrl()] &&
      email_conversations[getBoxFromUrl()].length > 0
    ) {
      // fetchAllEmailConversations(email_conversations);
      const firstMessage = email_conversations[getBoxFromUrl()][0];
      if (checkAuthorizations(firstMessage)) {
        if (
          (!selectedMessage && !messageToDelete) ||
          (!selectedMessage &&
            messageToDelete &&
            !messageToDelete.includes(firstMessage.messageId)) ||
          (state && state.id)
        ) {
          goToMessageReadView(firstMessage);
          console.log({ selectedMessage, selectedMessageNext });
          setSelectedMessageNext(email_conversations[getBoxFromUrl()][1]);
          setSelectedMessageNextIndex(1);
        }
      }
    } else if (
      email_conversations[getBoxFromUrl()] &&
      email_conversations[getBoxFromUrl()].length === 0 &&
      showReadEmailView
    ) {
      setShowReadEmailView(false);
      setSelectedMessage(undefined);
    }
  }, [email_conversations]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    console.log("props.alertList", props.alertList);

    // if (message && message.directMessageId !== lastFetchedMessageId.current) {
    //   getSingleMailFull(message, source.token);
    //   lastFetchedMessageId.current = message.directMessageId;
    // }

    if (
      selectedMessage &&
      getBoxFromUrl() !==
        "SMARTAS" +
          findMostCommonDelimiter(boxes[localStorage.getItem("companyId")]) +
          "Sent"
    ) {
      getSentMails(selectedMessage, source.token);
    }

    return () => {
      source.cancel("Requête annulée en raison d'un changement de composant.");
    };
  }, [selectedMessage, showReadEmailView]);

  /*
  const fetchAllEmailConversations = async (email_conv) => {
    console.log("fetchAllEmailConversations");

    let fullMessagesList = localStorage.getItem(
      `cached_full_messages_${localStorage.getItem("companyId")}_${localStorage.getItem("selected_mail_box")}`
    );

    if (!fullMessagesList) {
      fullMessagesList = {};
    } else {
      fullMessagesList = JSON.parse(fullMessagesList);
    }
    // console.log("fetchSingleMail length", Object.keys(fullMessagesList)?.length);

    for (let c_index = 0; c_index < email_conv[getBoxFromUrl()].length; c_index++) {
      const message = email_conv[getBoxFromUrl()][c_index];

      if (fullMessagesList[message.directMessageId] && fullMessagesList[message.directMessageId] !== "failed") {
        //  console.log("fetchSingleMail: mail exist", message.directMessageId, fullMessagesList[message.directMessageId], message.subject);
        setFullMessage(fullMessagesList);
        const fullMsg = fullMessagesList[message.directMessageId];
        fetchMessageOrders(fullMsg.related_messages ? [fullMsg, ...fullMsg.related_messages] : [fullMsg]);
      }

      try {
        const fullMail = await fetchSingleMail(message.directMessageId, client_data.$id, the_folder);
        // if (isCancelled.current) return;

        if (fullMail && fullMail.mails && fullMail.mails.length > 0) {
          console.log("fetchSingleMail Full mail for ===", { sub_1: message.subject, sub_2: fullMail.mails[0].subject });
          const fullMsg = fullMail.mails[0];
          fetchMessageOrders(fullMsg.related_messages ? [fullMsg, ...fullMsg.related_messages] : [fullMsg]);

          fullMessagesList[message.directMessageId] = fullMail.mails[0];
          setFullMessage(fullMessagesList);
          localStorage.setItem(
            `cached_full_messages_${localStorage.getItem("companyId")}_${localStorage.getItem("selected_mail_box")}`,
            JSON.stringify(fullMessagesList)
          );
        } else {
          fullMessagesList[message.directMessageId] = "failed";
          setFullMessage(fullMessagesList);
        }
      } catch (error) {
        // if (isCancelled.current) return;

        fullMessagesList[message.directMessageId] = "failed";
        setFullMessage(fullMessagesList);
        console.log("catch fetchSingleMail", error);
      }
    }
  };
  */

  const getSentMails = async (message, cancelToken) => {
    // console.log("fetchSingleMail message is", message.subject);

    let sentMessagesList = localStorage.getItem(
      `cached_sent_messages_${localStorage.getItem(
        "companyId"
      )}_${localStorage.getItem("selected_mail_box")}`
    );

    if (!sentMessagesList) {
      sentMessagesList = {};
    } else {
      sentMessagesList = JSON.parse(sentMessagesList);
    }
    // console.log("fetchSingleMail length", Object.keys(fullMessagesList)?.length);

    if (
      sentMessagesList[message.directMessageId] &&
      sentMessagesList[message.directMessageId] !== "failed"
    ) {
      console.log(
        "fetchSingleMail: mail exist",
        message.directMessageId,
        sentMessagesList[message.directMessageId],
        message.subject
      );
      setSentMessage(sentMessagesList);
    }

    try {
      const sentMail = await getSentMessages(
        client_data.$id,
        "SMARTAS" +
          findMostCommonDelimiter(boxes[localStorage.getItem("companyId")]) +
          "Sent",
        message.directMessageId,
        cancelToken
      );
      // if (isCancelled.current) return;

      if (sentMail && !sentMail.detail) {
        console.log("fetchSingleMail Full mail for ===", {
          sub_1: message.subject,
          sentMail
        });

        sentMessagesList[message.directMessageId] = sentMail.mails;
        setSentMessage(sentMessagesList);
        localStorage.setItem(
          `cached_sent_messages_${localStorage.getItem(
            "companyId"
          )}_${localStorage.getItem("selected_mail_box")}`,
          JSON.stringify(sentMessagesList)
        );
      } else {
        sentMessagesList[message.directMessageId] = "failed";
        setSentMessage(sentMessagesList);
      }
    } catch (error) {
      // if (isCancelled.current) return;

      sentMessagesList[message.directMessageId] = "failed";
      setSentMessage(sentMessagesList);
      console.log("catch fetchSingleMail", error);
    }
  };

  /*
  const getSingleMailFull = async (message, cancelToken) => {
    // console.log("fetchSingleMail message is", message.subject);

    let fullMessagesList = localStorage.getItem(
      `cached_full_messages_${localStorage.getItem("companyId")}_${localStorage.getItem("selected_mail_box")}`
    );

    if (!fullMessagesList) {
      fullMessagesList = {};
    } else {
      fullMessagesList = JSON.parse(fullMessagesList);
    }
    // console.log("fetchSingleMail length", Object.keys(fullMessagesList)?.length);

    if (fullMessagesList[message.directMessageId] && fullMessagesList[message.directMessageId] !== "failed") {
      //  console.log("fetchSingleMail: mail exist", message.directMessageId, fullMessagesList[message.directMessageId], message.subject);
      setFullMessage(fullMessagesList);
      const fullMsg = fullMessagesList[message.directMessageId];
      fetchMessageOrders(fullMsg.related_messages ? [fullMsg, ...fullMsg.related_messages] : [fullMsg]);
    }

    try {
      const fullMail = await fetchSingleMail(message.directMessageId, client_data.$id, the_folder, cancelToken);
      // if (isCancelled.current) return;

      if (fullMail && fullMail.mails && fullMail.mails.length > 0) {
        console.log("fetchSingleMail Full mail for ===", { sub_1: message.subject, sub_2: fullMail.mails[0].subject });
        const fullMsg = fullMail.mails[0];
        fetchMessageOrders(fullMsg.related_messages ? [fullMsg, ...fullMsg.related_messages] : [fullMsg]);

        fullMessagesList[message.directMessageId] = fullMail.mails[0];
        setFullMessage(fullMessagesList);
        localStorage.setItem(
          `cached_full_messages_${localStorage.getItem("companyId")}_${localStorage.getItem("selected_mail_box")}`,
          JSON.stringify(fullMessagesList)
        );
      } else {
        fullMessagesList[message.directMessageId] = "failed";
        setFullMessage(fullMessagesList);
      }
    } catch (error) {
      // if (isCancelled.current) return;

      fullMessagesList[message.directMessageId] = "failed";
      setFullMessage(fullMessagesList);
      console.log("catch fetchSingleMail", error);
    }
  };
 */

  useEffect(() => {
    let intervalId;

    const refreshConversations = async () => {
      intervalId = setInterval(async () => {
        console.log("Launching again refreshConversations");
        if (!loading) {
          dispatch(
            fetchMailsRedux(
              localStorage.getItem("companyId"),
              getBoxFromUrl(),
              currentPage,
              pageSize
            )
          );
        }
      }, 120000);
    };

    refreshConversations();

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  function fetchMessageOrders(messages) {
    console.log({ full_messages: messages });

    if (selectedMessage) {
      if (
        !messageOrderInfos ||
        (messageOrderInfos &&
          !messageOrderInfos[selectedMessage.directMessageId])
      ) {
        // const messages = selectedMessage.related_messages ? [selectedMessage, ...selectedMessage.related_messages] : [selectedMessage];
        console.log({ fetchAgain: messageOrderInfos });

        const orderPromises = messages.map((message) =>
          fetchMessagesOrderInfos(message)
        );
        try {
          // Attendre que toutes les promesses soient résolues
          Promise.all(orderPromises).then((res) => {
            console.log("Orders fetched successfully", res);
          });
        } catch (error) {
          console.error("Error while fetching orders:", error);
        }
      }
    }
  }

  function cleanMessageId(messageId) {
    // Expression régulière pour capturer l'ID de message dans les chevrons <>
    const pattern = /<([^>]+)>/;
    // Enlever les caractères de retour à la ligne
    const cleanId = messageId.replace(/\r\n/g, "").trim();

    // Extraire la partie utile de l'ID de message
    const match = pattern.exec(cleanId);
    return match ? match[0] : cleanId;
  }

  /*
  const fetchMessageOrders = useCallback(() => {
    console.log("fetchMessageOrders");
    if (selectedMessage) {
      if (!messageOrderInfos[selectedMessage.directMessageId]) {
        const messages = selectedMessage.related_messages 
          ? [selectedMessage, ...selectedMessage.related_messages] 
          : [selectedMessage];
        
        const orderPromises = messages.map((message) => fetchMessagesOrderInfos(message));
        
        Promise.all(orderPromises)
          .then((res) => {
            console.log("Orders fetched successfully", res);
            // Mise à jour de messageOrderInfos avec les nouvelles informations
            setMessageOrderInfos(prevInfos => ({
              ...prevInfos,
              [selectedMessage.directMessageId]: res
            }));
          })
          .catch((error) => {
            console.error("Error while fetching orders:", error);
          });
      }
    }
  }, [selectedMessage, messageOrderInfos]);

  useEffect(() => {
    let intervalId;
    
    if (selectedMessage) {
      fetchMessageOrders();
      intervalId = setInterval(fetchMessageOrders, 5000); 
    }
    
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [selectedMessage, fetchMessageOrders]);
*/

  // function getMessageAssignation(message) {
  //   let messageId = "";
  //   if (typeof message.headers["message-id"] === "string") {
  //     messageId = message.headers["message-id"];
  //   } else if (Array.isArray(message.headers["message-id"])) {
  //     messageId = message.headers["message-id"][0];
  //   }
  //   messageId = cleanMessageId(messageId);
  //   let name = "-";

  //   if (client_data && messageInfos && messageInfos[messageId]) {
  //     const agents = client_data.agents.map((element) => JSON.parse(element));
  //     for (let i = 0; i < agents.length; i++) {
  //       if (agents[i].id === messageInfos[messageId].treated_by) {
  //         name =
  //           messageInfos[messageId].treated_by_ia === true ? (
  //             <div style={{ direction: "flex", alignItems: "end" }}>
  //               <span>{agents[i].agent_name}</span>
  //               <img
  //                 src={aiButtonicon}
  //                 alt="aiButton__icon"
  //                 style={{
  //                   width: "24px",
  //                   height: "24px",
  //                   paddingLeft: "5px"
  //                 }}
  //               />
  //             </div>
  //           ) : (
  //             <span>{agents[i].agent_name}</span>
  //           );
  //       }
  //     }
  //   }

  //   return name;
  // }

  function formaterDate(date, with_year) {
    const dateObj = new Date(date);
    const maintenant = new Date();
    const estAujourdhui = dateObj.toDateString() === maintenant.toDateString();
    const mois = dateObj.toLocaleString(props.i18n.language, {
      month: "short"
    });
    const jour = estAujourdhui ? "Aujourd'hui" : dateObj.getDate();
    const annee = dateObj.getFullYear().toString();
    const heures = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    return estAujourdhui
      ? `${heures}:${minutes}`
      : `${jour} ${mois}${with_year ? " " + annee : ""}`;
  }
  // function formatDate(dateString) {
  //   const options = { day: "2-digit", month: "short", year: "2-digit", hour: "2-digit", minute: "2-digit" };
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString(props.i18n.language + "-" + props.i18n.language.toUpperCase(), options);
  //   // return "";
  // }
  async function fetchMessagesOrderInfos(message) {
    if (
      client_data &&
      ((messageInfos[message.directMessageId] &&
        messageInfos[message.directMessageId].order_number &&
        messageInfos[message.directMessageId].order_number !== "" &&
        messageInfos[message.directMessageId].order_number !== "<UNKNOWN>") ||
        (messageInfos[message.directMessageId] &&
          messageInfos[message.directMessageId].order_email &&
          messageInfos[message.directMessageId].order_email !== "" &&
          messageInfos[message.directMessageId].order_email !== "<UNKNOWN>"))
    ) {
      console.log(
        "Fetching messages order",
        messageInfos[message.directMessageId].order_number,
        messageInfos[message.directMessageId].order_email
      );
      // try {
      // const response = await
      const search =
        messageInfos[message.directMessageId].order_number &&
        messageInfos[message.directMessageId].order_number !== "" &&
        messageInfos[message.directMessageId].order_number !== "<UNKNOWN>"
          ? messageInfos[message.directMessageId].order_number
          : messageInfos[message.directMessageId].order_email;

      const search_field =
        messageInfos[message.directMessageId].order_number &&
        messageInfos[message.directMessageId].order_number !== "" &&
        messageInfos[message.directMessageId].order_number !== "<UNKNOWN>"
          ? "name"
          : "email";

      searchShopifyOrder(
        `${search}`,
        ["line_items", "billing_address", "payment_details"],
        client_data.shopify_token,
        client_data.shopify_store_url,
        search_field
      )
        .then((response) => {
          console.log("searchShopifyOrder is ", {
            response: response,
            shopify_api_key: client_data.shopify_api_key,
            shopify_store_url: client_data.shopify_store_url
          });
          if (response.orders.length > 0) {
            // const updated_orders =
            //   messageOrderInfos && messageOrderInfos.length > 0 ? [...messageOrderInfos, response.orders[0]] : response.orders;
            const updated_orders = response.orders;
            console.log({ updated_orders });
            setMessageOrderInfos((prev) => {
              return { ...prev, [message.directMessageId]: updated_orders };
            });
          } else {
            setMessageOrderInfos((prev) => {
              return { ...prev, [message.directMessageId]: undefined };
            });
          }
        })
        .catch((error) => {
          setMessageOrderInfos((prev) => {
            return { ...prev, [message.directMessageId]: undefined };
          });
          console.log("searchShopifyOrder error ", {
            error: error,
            shopify_api_key: client_data.shopify_api_key,
            shopify_store_url: client_data.shopify_store_url
          }); // Failure
        });

      // } catch (error) {

      // }
    } else {
      setMessageOrderInfos((prev) => {
        return { ...prev, [message.directMessageId]: undefined };
      });
    }
  }

  async function goToMessageReadView(message) {
    console.log("selectedMessage is", message);
    // if (multiSelectedMessage.length === 0) {
    setSelectedMessage(message);

    setShowReadEmailView(true);
    //   }

    setMultiSelectedMessage([message.messageId]);

    if (multiSelectedMessage.length === 1) {
      // setMultiSelectedMessage((prev) => {
      //   let updatedMultiSelectedMessage = [...prev];
      //   if (multiSelectedMessage.includes(message.messageId)) {
      //     updatedMultiSelectedMessage = updatedMultiSelectedMessage.filter((messageId) => messageId !== message.messageId);
      //   } else {
      //     updatedMultiSelectedMessage.push(message.messageId);
      //   }
      //   return updatedMultiSelectedMessage;
      // });
      //   if (multiSelectedMessage[0] === message.messageId) {
      //    }
    } else if (multiSelectedMessage.length === 0) {
      //   setMultiSelectedMessage([message.messageId]);
    }

    // navigate("/read-email", {
    //   replace: false,
    //   state: { the_message: message, all_messages: messages, folder: the_folder ? the_folder : "INBOX" },
    // });
  }

  // Update the current page when the user clicks on pagination controls
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    // onLoading(true);

    // fetchMails(localStorage.getItem('companyId'), the_folder);
    if (!loading) {
      dispatch(
        fetchMailsRedux(
          localStorage.getItem("companyId"),
          getBoxFromUrl(),
          1,
          pageSize,
          []
        )
      );
    }
  };

  const showColumn = () => {
    setColumnVisibility(!isColumnVisible);
  };

  const closeMessageView = () => {
    console.log("closeMessageView");
    setShowReadEmailView(false);
    setSelectedMessage(undefined);
  };

  // async function updateMessageData(message, proccessed, process_start_time) {
  //   console.log(`Start saving message data for ${message.messageId}`);

  //   const client = new Client();

  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   try {
  //     let message_to_reply_id = "";
  //     if (typeof message.headers["message-id"] === "string") {
  //       message_to_reply_id = message.headers["message-id"];
  //     } else if (Array.isArray(message.headers["message-id"])) {
  //       // eslint-disable-next-line prefer-destructuring
  //       message_to_reply_id = message.headers["message-id"][0];
  //     }
  //     console.log("message date is", new Date(message.attributes.date).getTime().toString());
  //     console.log("new date is", Date.now().toString());
  //     const response = await databases.updateDocument("default", "message", message_to_reply_id, {
  //       message_process_date: process_start_time,
  //       message_process_end_date: Date.now().toString(),
  //       process_state: proccessed,
  //       treated_by_ia: false
  //     });

  //     console.log(`Successfully updated message data for ${message.messageId}`);
  //     return response.$id;
  //   } catch (error) {
  //     console.log(`Failed updating message data for ${message.messageId}. Error is: ${error}`);
  //     // throw error;
  //     return null;
  //   }
  // }

  const copyMail = async function (message_id, the_folder, destination_folder) {
    console.log("copyMail");
    onMailActionLoading("copy");

    const apiUrl = "https://mailbox.semecloud.tech/copy-mail";
    // const apiUrl = "http://localhost:55000/copy-mail";
    // axios
    //   .post(
    //     apiUrl,
    //     {
    //       company_id: client_data.$id,
    //       destination_folder: destination_folder,
    //       folder: the_folder,
    //       messageId: message_id,
    //     },

    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   )
    copyMailPromise(message_id, the_folder, destination_folder)
      .then(async (response) => {
        console.log("Msg copied", response);
        onMailActionLoading(undefined);
        setActionPerformed({
          title: props.t("Copie effectuée !"),
          body: props.t("Email(s) copié(s) vers le dossier spécifié."),
          key: "success"
        });
        triggerTimeout();
      })
      .catch((error) => {
        // Handle the error
        onMailActionLoading(undefined);
        console.log("Failed copying msg", error);
      });
  };

  const moveMail = async function (
    message_id,
    folder,
    destination_folder,
    isDeletion
  ) {
    console.log("moveMail");
    onMailActionLoading(isDeletion ? "delete" : "move");

    try {
      const response = await moveMailPromise(
        message_id,
        folder,
        destination_folder
      );
      console.log("Msg moved", response);
      onMailActionLoading(undefined);
      if (isDeletion) {
        setActionPerformed({
          title: props.t("Suppression effectuée !"),
          body: props.t("Email(s) supprimé(s) avec succès"),
          key: "success"
        });
      } else {
        setActionPerformed({
          title: props.t("E-mail(s) déplacé(s)"),
          body: props.t("Email(s) déplacé(s) avec succès"),
          key: "success"
        });
      }

      triggerTimeout();
    } catch (error) {
      onMailActionLoading(undefined);
      console.error("Failed moving msg", error);
      throw error; // Rejette l'erreur pour que Promise.all la capture
    }
  };

  const deleteMail = async function (message_id, destination_box) {
    console.log("deleteMail", message_id, destination_box);

    onMailActionLoading("delete");
    setMultiSelectedMessage([]);

    const apiUrl = "https://mailbox.semecloud.tech/delete-mail";
    // const apiUrl = "http://localhost:55000/copy-mail";
    // axios
    //   .post(
    //     apiUrl,
    //     {
    //       company_id: client_data.$id,
    //       folder: destination_box,
    //       messageId: message_id,
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   )
    deleteMailPromise(message_id, destination_box)
      .then(async (response) => {
        console.log("Msg deleted", response);
        onMailActionLoading(undefined);
        setDecompte(10);
        setActionPerformed({
          title: props.t("Suppression effectuée !"),
          body: props.t("Email(s) supprimé(s) avec succès"),
          key: "success"
        });
        triggerTimeout();
      })
      .catch((error) => {
        // Handle the error
        onMailActionLoading(undefined);
        console.log("Failed deleting msg", error);
      });
  };

  const deleteMailFromCache = () => {
    const msg = localStorage.getItem(
      `cached_messages_${localStorage.getItem(
        "companyId"
      )}_${localStorage.getItem("selected_mail_box")}`
    );
    console.log({ cached_messages_msg: msg });

    if (msg) {
      const messages_mapJSON = JSON.parse(msg);
      if (
        messages_mapJSON[getBoxFromUrl()] &&
        messages_mapJSON[getBoxFromUrl()].length > 0
      ) {
        const cached_messages_ = messages_mapJSON[getBoxFromUrl()].filter(
          (message) => !messageToDelete.includes(message.messageId)
        );

        localStorage.setItem(
          `cached_messages_${localStorage.getItem(
            "companyId"
          )}_${localStorage.getItem("selected_mail_box")}`,
          JSON.stringify(cached_messages_)
        );
      }
    }
  };

  const selectedAction = async function (
    selectedMessages,
    the_folder,
    destination_box
  ) {
    console.log("selectedAction", selectedMessages, destination_box);
    setMultiSelectedMessage([]);

    if (type === "copy") {
      const copyPromises = selectedMessages.map((id) =>
        copyMail(id, the_folder, destination_box)
      );
      try {
        // Attendre que toutes les promesses soient résolues
        await Promise.all(copyPromises);
        dispatch(
          fetchMailsRedux(
            localStorage.getItem("companyId"),
            the_folder,
            1,
            pageSize,
            []
          )
        );
        console.log("Tous les mails ont été copiés avec succès.");
        togModalDossierVisibility(false);
      } catch (error) {
        console.error(
          "Une erreur est survenue lors de la copie des mails:",
          error
        );
        togModalDossierVisibility(false);
      }
    } else if (type === "move") {
      // closeMessageView();
      tog_Modal();
      const movePromises = selectedMessages.map((id) =>
        moveMail(id, the_folder, destination_box, false)
      );
      try {
        // Attendre que toutes les promesses soient résolues
        await Promise.all(movePromises);
        dispatch(
          fetchMailsRedux(
            localStorage.getItem("companyId"),
            the_folder,
            1,
            pageSize,
            []
          )
        );
        if (selectedMessageNext) {
          goToMessageReadView(selectedMessageNext);
        }
        console.log("Tous les mails ont été déplacés avec succès.");
      } catch (error) {
        console.error(
          "Une erreur est survenue lors du déplacement des mails:",
          error
        );
      }
    }
  };

  function goToMBoxPage(box) {
    // console.log("box props data is:", box);
    navigate(`/mailbox?box=${box}`, {
      replace: false,
      state: { box: box }
    });
  }

  function getMailboxIcon(boxName) {
    if (boxName.toLowerCase().includes(".inbox")) {
      return (
        // <i className="mdi mdi-at align-middle email-menu-icon me-1"></i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="auto"
          viewBox="0 0 26 20"
          fill="currentColor"
          className="email-menu-icon me-1"
        >
          <path
            d="M12.2006 1.60367C10.053 1.60367 7.89827 1.63193 5.75062 1.59661C3.75132 1.56129 1.90745 3.05192 1.62487 5.16425C1.60367 5.34793 1.60367 5.53161 1.60367 5.71529C1.60367 8.2727 1.59661 10.823 1.60367 13.3804C1.60367 15.4574 2.97421 17.0964 5.02296 17.4638C5.29848 17.5132 5.58107 17.5062 5.86365 17.5062C8.45638 17.5062 11.042 17.5062 13.6348 17.5062C13.7902 17.5062 13.9527 17.5132 14.1081 17.5344C14.5249 17.591 14.8216 17.923 14.8216 18.3186C14.8216 18.7284 14.4966 19.0604 14.0728 19.0957C13.988 19.1028 13.8961 19.1028 13.8114 19.1028C11.1409 19.1028 8.4705 19.1028 5.80007 19.1028C2.87531 19.1099 0.558107 17.16 0.0706464 14.2706C0.0211939 13.9668 0 13.656 0 13.3522C0 10.8301 0 8.30802 0 5.78594C0.00706464 2.88237 1.97104 0.565171 4.83928 0.0706464C5.14306 0.0211939 5.44684 0 5.75768 0C10.0459 0 14.3412 0 18.6295 0C21.6178 0 24.0057 2.11939 24.3518 5.08654C24.4649 6.01907 24.373 6.95161 24.3942 7.88414C24.4013 8.15966 24.4013 8.42812 24.3942 8.70364C24.3801 9.1699 24.0763 9.50901 23.6383 9.53727C23.2285 9.56552 22.8824 9.25468 22.8188 8.80254C22.7623 8.39279 22.7976 7.97598 22.7976 7.55917C22.7905 6.90922 22.8047 6.25221 22.7905 5.60226C22.7552 3.36277 20.982 1.61074 18.7496 1.59661C18.7354 1.59661 18.7142 1.59661 18.7001 1.59661C16.5383 1.60367 14.3695 1.60367 12.2006 1.60367Z"
            fill="currentColor"
          />
          <path
            d="M20.5863 10.1448C23.1437 10.2225 25.4114 12.4338 25.2772 15.2667C25.15 18.1349 22.7551 20.1413 20.0988 20C17.2941 19.8516 15.316 17.5415 15.4008 14.9488C15.5068 11.8474 18.1419 9.97527 20.5863 10.1448ZM20.3461 18.4105C22.2111 18.4105 23.6876 16.941 23.6947 15.0759C23.6947 13.2109 22.2111 11.7132 20.3461 11.7132C18.5022 11.7132 16.9974 13.2109 16.9974 15.0547C16.9904 16.9269 18.4739 18.4105 20.3461 18.4105Z"
            fill="currentColor"
          />
          <path
            d="M12.1865 9.64324C11.8262 9.62205 11.4729 9.55847 11.1338 9.42424C8.84488 8.50583 6.55594 7.5945 4.26699 6.68316C3.85724 6.52067 3.67356 6.24515 3.69476 5.85659C3.71595 5.52456 3.94202 5.24197 4.27406 5.15013C4.50719 5.08655 4.72619 5.15719 4.93813 5.24197C7.12817 6.11799 9.32528 6.98694 11.5082 7.87708C11.9816 8.06783 12.4125 8.06783 12.8859 7.87708C15.0618 6.994 17.2518 6.12505 19.4348 5.2561C19.5902 5.19252 19.7386 5.12187 19.9152 5.12187C20.2684 5.12187 20.5793 5.34794 20.6782 5.67291C20.7771 6.01202 20.657 6.36525 20.3673 6.55599C20.2825 6.61251 20.1836 6.6549 20.0847 6.69729C17.8452 7.5945 15.6057 8.49171 13.3663 9.38892C12.9918 9.53727 12.5962 9.62205 12.1865 9.64324Z"
            fill="currentColor"
          />
          <path
            d="M22.5504 14.3483C22.5363 14.6167 22.4303 14.8287 22.2254 14.9982C21.5825 15.521 20.9397 16.0438 20.2897 16.5525C19.8376 16.9128 19.4137 16.8562 19.0534 16.4041C18.8132 16.1074 18.5801 15.8107 18.354 15.514C18.0502 15.1042 18.0926 14.6591 18.4529 14.3624C18.8061 14.0728 19.2583 14.1434 19.5903 14.539C19.8658 14.864 19.8658 14.864 20.2049 14.5955C20.5582 14.313 20.9043 14.0304 21.2576 13.7549C21.526 13.55 21.8298 13.5217 22.1265 13.6701C22.402 13.8043 22.5221 14.0586 22.5504 14.3483Z"
            fill="currentColor"
          />
        </svg>
      );
    } else if (boxName.toLowerCase().includes("draft")) {
      return (
        // <i className="mdi mdi-file-outline align-middle email-menu-icon me-1"></i>
        <svg
          width="17"
          height="auto"
          viewBox="0 0 17 20"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          className="email-menu-icon me-1"
        >
          <path
            d="M0 11.4214C0 9.28231 0 7.14324 0 5.00417C0 3.89275 0.714884 3.04941 1.80955 2.85952C2.07205 2.81484 2.34013 2.83718 2.60262 2.84277C2.75901 2.84277 2.80927 2.7925 2.80927 2.63612C2.7981 2.234 2.79252 1.82629 2.93214 1.43534C3.2449 0.580828 4.01564 0.011155 4.94834 0.00556993C7.10975 -0.00560013 9.26557 -0.00560013 11.427 0.00556993C12.0078 0.00556993 12.5161 0.223386 12.9293 0.636679C14.0799 1.7872 15.236 2.93771 16.3865 4.09381C16.7998 4.50711 17.0064 5.00976 17.0064 5.59619C17.0064 8.74056 17.0064 11.8793 17.0064 15.0237C17.0064 16.2468 16.0793 17.1516 14.8562 17.1572C14.6942 17.1572 14.5378 17.1628 14.3759 17.1572C14.2474 17.1516 14.2027 17.2075 14.2027 17.3303C14.1972 17.604 14.2251 17.8721 14.1804 18.1458C13.9849 19.2628 13.1304 19.9944 11.9911 19.9944C8.89137 20 5.79168 19.9944 2.69199 19.9944C2.2396 19.9944 1.78721 20.0112 1.35158 19.838C0.547333 19.5197 0.0111701 18.7601 0.00558503 17.9C0 15.7442 0 13.5828 0 11.4214ZM4.07149 8.57859C4.07149 10.7121 4.08266 12.84 4.0659 14.9735C4.06032 15.5655 4.50712 15.9285 4.9986 15.9285C8.27143 15.9285 11.5443 15.9285 14.8171 15.9229C15.3868 15.9229 15.761 15.5431 15.761 14.9735C15.761 11.9352 15.761 8.90253 15.7665 5.86427C15.7665 5.65204 15.6884 5.60736 15.4985 5.60736C14.8953 5.61853 14.2865 5.61294 13.6833 5.60736C12.3262 5.59619 11.4214 4.68024 11.4214 3.32866C11.4214 2.71431 11.4158 2.10554 11.427 1.49119C11.427 1.31805 11.3711 1.2622 11.198 1.2622C9.12036 1.26779 7.04831 1.26779 4.97068 1.2622C4.80871 1.2622 4.65233 1.29571 4.51271 1.37949C4.19436 1.56938 4.07707 1.85422 4.07707 2.22283C4.07707 4.34514 4.07149 6.46187 4.07149 8.57859ZM1.23988 11.4046C1.23988 13.499 1.25105 15.599 1.23429 17.6934C1.22871 18.2407 1.55264 18.7434 2.27311 18.7378C4.75845 18.7154 7.24379 18.7266 9.73471 18.7266C10.5222 18.7266 11.3097 18.7322 12.0972 18.721C12.5663 18.7154 12.9126 18.3747 12.9349 17.9056C12.9405 17.7604 12.9405 17.6152 12.9405 17.4644C12.9405 17.1516 12.9405 17.1516 12.6333 17.1516C10.1145 17.1516 7.59006 17.1516 5.07121 17.1516C4.92041 17.1516 4.76403 17.1572 4.61324 17.1293C3.52974 16.9282 2.81486 16.0737 2.81486 14.9623C2.81486 11.5051 2.81486 8.0536 2.81486 4.59647C2.81486 4.06589 2.81486 4.06589 2.28986 4.06589C1.59173 4.06589 1.24546 4.40658 1.24546 5.1047C1.23988 7.21026 1.23988 9.31023 1.23988 11.4046ZM12.6836 2.22841C12.6836 2.66405 12.678 3.07734 12.6836 3.49621C12.6948 3.99328 13.0522 4.33955 13.5549 4.35073C13.9123 4.35631 14.2642 4.35631 14.6216 4.35073C14.683 4.35073 14.7668 4.38424 14.7947 4.31721C14.8171 4.25578 14.7333 4.21668 14.6942 4.172C14.091 3.56324 13.4823 2.96005 12.8791 2.35128C12.8288 2.3066 12.7953 2.25075 12.6836 2.22841Z"
            fill="currentColor"
          />
          <path
            d="M9.90227 11.3879C8.86345 11.3879 7.83022 11.3879 6.7914 11.3879C6.66295 11.3879 6.54008 11.3823 6.42279 11.3376C6.17146 11.2371 6.0095 10.9802 6.03184 10.7065C6.05418 10.4384 6.26082 10.1983 6.52332 10.1536C6.65178 10.1312 6.78582 10.1201 6.91986 10.1201C8.92488 10.1201 10.9299 10.1201 12.9349 10.1201C13.0411 10.1201 13.1416 10.1256 13.2477 10.1424C13.5996 10.1983 13.8174 10.4608 13.8006 10.7847C13.7839 11.1086 13.527 11.3599 13.1807 11.3767C12.907 11.3879 12.6389 11.3823 12.3653 11.3823C11.5443 11.3879 10.7233 11.3879 9.90227 11.3879Z"
            fill="currentColor"
          />
          <path
            d="M9.22647 12.9964C10.0586 12.9964 10.8964 12.9964 11.7286 12.9964C12.1419 12.9964 12.4211 13.2477 12.4267 13.6107C12.4323 13.9681 12.1419 14.2362 11.7342 14.2362C10.0531 14.2362 8.36638 14.2362 6.68529 14.2362C6.33901 14.2362 6.0821 14.024 6.02625 13.7168C5.97599 13.4208 6.15471 13.1304 6.45071 13.0299C6.54566 12.9964 6.6406 13.0019 6.74114 13.0019C7.57331 12.9964 8.39989 12.9964 9.22647 12.9964Z"
            fill="currentColor"
          />
          <path
            d="M7.94196 8.54508C7.52867 8.54508 7.12097 8.55067 6.70767 8.54508C6.18826 8.53391 5.88109 8.07594 6.09332 7.64589C6.21619 7.40015 6.42842 7.28845 6.68533 7.28845C7.52867 7.28287 8.37201 7.27728 9.21535 7.28845C9.60072 7.29404 9.88556 7.57887 9.87439 7.92515C9.8688 8.277 9.58396 8.5395 9.19301 8.54508C8.77414 8.55067 8.35526 8.54508 7.94196 8.54508Z"
            fill="currentColor"
          />
        </svg>
      );
    } else if (boxName.toLowerCase().includes("trash")) {
      return (
        // <i className="mdi mdi-at align-middle email-menu-icon me-1"></i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="20"
          viewBox="0 0 19 20"
          fill="currentColor"
          className="email-menu-icon me-1"
        >
          <path
            d="M9.0502 19.9942C8.08096 19.9942 7.11172 20 6.14248 19.9942C5.64335 19.9884 5.14422 19.9536 4.6567 19.8375C3.54237 19.5705 2.89234 18.8799 2.70081 17.7481C2.59054 17.1097 2.57313 16.4655 2.5325 15.827C2.44544 14.556 2.36419 13.285 2.28293 12.0197C2.2365 11.3175 2.19007 10.621 2.14945 9.91875C2.09721 9.10041 2.05078 8.28787 2.00435 7.46953C1.97533 7.01683 2.24231 6.6686 2.64277 6.64539C3.07226 6.61637 3.39727 6.90076 3.42629 7.35926C3.50174 8.46199 3.57138 9.56471 3.64103 10.6732C3.72228 11.8862 3.80934 13.0992 3.88479 14.3064C3.93703 15.0725 3.97765 15.8387 4.02989 16.599C4.0473 16.8717 4.07051 17.1445 4.11114 17.4173C4.21561 18.1196 4.54062 18.4214 5.2545 18.5026C5.54469 18.5316 5.82907 18.549 6.11927 18.549C8.07516 18.549 10.031 18.549 11.9811 18.549C12.2771 18.549 12.5731 18.5316 12.8691 18.5026C13.6236 18.4214 13.9718 18.0499 14.0357 17.2432C14.1169 16.0882 14.1866 14.9333 14.262 13.7783C14.3607 12.3273 14.4594 10.8764 14.5522 9.42542C14.5987 8.72316 14.6393 8.0267 14.6915 7.32443C14.7205 6.89495 15.0514 6.61056 15.4808 6.63958C15.8697 6.6628 16.1425 6.99942 16.1193 7.4231C16.0264 8.9321 15.9335 10.4411 15.8407 11.9501C15.7536 13.2908 15.6724 14.6373 15.5795 15.9779C15.5389 16.5525 15.5215 17.1329 15.4228 17.7075C15.2081 18.9379 14.5406 19.6286 13.3102 19.8723C12.8691 19.9594 12.4222 19.9942 11.9753 19.9942C10.9945 20 10.0252 19.9942 9.0502 19.9942Z"
            fill="currentColor"
          />
          <path
            d="M9.06181 0C9.71764 0.0174115 10.3793 -0.0406268 11.0351 0.0754498C11.9811 0.243761 12.5267 0.766106 12.7182 1.71213C12.8169 2.18804 12.8981 2.66396 12.9736 3.14568C12.9968 3.28497 13.0548 3.34881 13.1941 3.36042C13.7223 3.39524 14.2446 3.43006 14.7728 3.47069C15.6608 3.54034 16.5429 3.61579 17.4309 3.69704C17.8662 3.73767 18.1448 4.08009 18.11 4.49797C18.0752 4.88683 17.7269 5.17121 17.2974 5.13639C16.63 5.08416 15.9568 5.01451 15.2893 4.95647C14.5929 4.89843 13.8906 4.84039 13.1941 4.79977C11.2789 4.6953 9.3636 4.62565 7.44254 4.67208C6.00319 4.70691 4.56384 4.76494 3.13029 4.91584C2.37579 4.9971 1.62129 5.06674 0.860993 5.13639C0.396687 5.18282 0.0310454 4.89843 0.0020263 4.49216C-0.0269929 4.03366 0.257395 3.73186 0.744917 3.68543C1.76059 3.59257 2.77626 3.4881 3.79193 3.40104C4.14596 3.37203 4.49999 3.35461 4.85403 3.3372C5.02814 3.3314 5.12681 3.27916 5.15583 3.07603C5.21967 2.61753 5.30092 2.15902 5.39378 1.70633C5.62013 0.644225 6.28757 0.104469 7.37289 0.0290192C7.93586 -0.00580383 8.49883 0.0174115 9.06181 0ZM10.7972 3.26756C10.9422 3.26756 11.1512 3.25595 11.3601 3.27336C11.5052 3.28497 11.54 3.22693 11.5168 3.09925C11.4472 2.71619 11.3833 2.33314 11.3021 1.95009C11.2382 1.64829 11.0989 1.54382 10.7972 1.49739C10.2864 1.42194 9.76987 1.46257 9.25914 1.46257C8.62652 1.46257 7.9881 1.41613 7.35548 1.49158C7.01886 1.53221 6.88537 1.64829 6.81572 1.98491C6.74027 2.34475 6.68804 2.71039 6.61259 3.07023C6.58357 3.20952 6.63 3.26175 6.76349 3.25014C7.01886 3.23854 7.26842 3.22693 7.52379 3.22113C8.59169 3.20952 9.6596 3.20952 10.7972 3.26756Z"
            fill="currentColor"
          />
          <path
            d="M9.05594 11.184C8.31886 11.184 7.58177 11.184 6.84469 11.184C6.36297 11.184 6.03215 10.8938 6.02054 10.4759C6.00893 10.0638 6.36297 9.73883 6.84469 9.73883C8.31886 9.73303 9.79883 9.73883 11.273 9.73883C11.6619 9.73883 11.9288 9.91295 12.0449 10.2264C12.1552 10.5165 12.0797 10.7661 11.865 10.9809C11.7083 11.1376 11.511 11.1898 11.2904 11.1898C10.5417 11.184 9.79883 11.184 9.05594 11.184Z"
            fill="currentColor"
          />
          <path
            d="M9.0327 14.881C8.53357 14.881 8.03444 14.881 7.53532 14.881C7.11164 14.881 6.78662 14.5676 6.78662 14.173C6.78662 13.7783 7.11164 13.4649 7.53532 13.4649C8.55099 13.4649 9.56085 13.4649 10.5765 13.4649C10.9944 13.4649 11.3252 13.7899 11.3194 14.1846C11.3136 14.5734 10.9944 14.881 10.5823 14.8868C10.0658 14.881 9.54924 14.881 9.0327 14.881Z"
            fill="currentColor"
          />
        </svg>
      );
    } else if (boxName.toLowerCase().includes("untreated")) {
      return (
        <img
          src={maaiaIconInfoPink}
          alt="Synibox Icon Info Pink"
          className="me-1"
          style={{
            width: "20px",
            height: "20px"
          }}
        />
      );
    } else if (boxName.toLowerCase().includes("treated")) {
      return (
        <img
          src={maaiaIconInfoPurple}
          alt="Synibox Icon Info Purple"
          className="me-1"
          style={{
            width: "20px",
            height: "20px"
          }}
        />
      );
    } else if (boxName.toLowerCase().includes("spam")) {
      return (
        <i className="mdi mdi-chart-bar  align-middle email-menu-icon me-1"></i>
      );
    } else if (boxName.toLowerCase().includes("sent")) {
      return (
        // <i className="mdi mdi-at align-middle email-menu-icon me-1"></i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="auto"
          viewBox="0 0 26 20"
          fill="currentColor"
          className="email-menu-icon me-1"
        >
          <path
            d="M12.2006 1.60367C10.053 1.60367 7.89827 1.63193 5.75062 1.59661C3.75132 1.56129 1.90745 3.05192 1.62487 5.16425C1.60367 5.34793 1.60367 5.53161 1.60367 5.71529C1.60367 8.2727 1.59661 10.823 1.60367 13.3804C1.60367 15.4574 2.97421 17.0964 5.02296 17.4638C5.29848 17.5132 5.58107 17.5062 5.86365 17.5062C8.45638 17.5062 11.042 17.5062 13.6348 17.5062C13.7902 17.5062 13.9527 17.5132 14.1081 17.5344C14.5249 17.591 14.8216 17.923 14.8216 18.3186C14.8216 18.7284 14.4966 19.0604 14.0728 19.0957C13.988 19.1028 13.8961 19.1028 13.8114 19.1028C11.1409 19.1028 8.4705 19.1028 5.80007 19.1028C2.87531 19.1099 0.558107 17.16 0.0706464 14.2706C0.0211939 13.9668 0 13.656 0 13.3522C0 10.8301 0 8.30802 0 5.78594C0.00706464 2.88237 1.97104 0.565171 4.83928 0.0706464C5.14306 0.0211939 5.44684 0 5.75768 0C10.0459 0 14.3412 0 18.6295 0C21.6178 0 24.0057 2.11939 24.3518 5.08654C24.4649 6.01907 24.373 6.95161 24.3942 7.88414C24.4013 8.15966 24.4013 8.42812 24.3942 8.70364C24.3801 9.1699 24.0763 9.50901 23.6383 9.53727C23.2285 9.56552 22.8824 9.25468 22.8188 8.80254C22.7623 8.39279 22.7976 7.97598 22.7976 7.55917C22.7905 6.90922 22.8047 6.25221 22.7905 5.60226C22.7552 3.36277 20.982 1.61074 18.7496 1.59661C18.7354 1.59661 18.7142 1.59661 18.7001 1.59661C16.5383 1.60367 14.3695 1.60367 12.2006 1.60367Z"
            fill="currentColor"
          />
          <path
            d="M20.5863 10.1448C23.1437 10.2225 25.4114 12.4338 25.2772 15.2667C25.15 18.1349 22.7551 20.1413 20.0988 20C17.2941 19.8516 15.316 17.5415 15.4008 14.9488C15.5068 11.8474 18.1419 9.97527 20.5863 10.1448ZM20.3461 18.4105C22.2111 18.4105 23.6876 16.941 23.6947 15.0759C23.6947 13.2109 22.2111 11.7132 20.3461 11.7132C18.5022 11.7132 16.9974 13.2109 16.9974 15.0547C16.9904 16.9269 18.4739 18.4105 20.3461 18.4105Z"
            fill="currentColor"
          />
          <path
            d="M12.1865 9.64324C11.8262 9.62205 11.4729 9.55847 11.1338 9.42424C8.84488 8.50583 6.55594 7.5945 4.26699 6.68316C3.85724 6.52067 3.67356 6.24515 3.69476 5.85659C3.71595 5.52456 3.94202 5.24197 4.27406 5.15013C4.50719 5.08655 4.72619 5.15719 4.93813 5.24197C7.12817 6.11799 9.32528 6.98694 11.5082 7.87708C11.9816 8.06783 12.4125 8.06783 12.8859 7.87708C15.0618 6.994 17.2518 6.12505 19.4348 5.2561C19.5902 5.19252 19.7386 5.12187 19.9152 5.12187C20.2684 5.12187 20.5793 5.34794 20.6782 5.67291C20.7771 6.01202 20.657 6.36525 20.3673 6.55599C20.2825 6.61251 20.1836 6.6549 20.0847 6.69729C17.8452 7.5945 15.6057 8.49171 13.3663 9.38892C12.9918 9.53727 12.5962 9.62205 12.1865 9.64324Z"
            fill="currentColor"
          />
          <path
            d="M22.5504 14.3483C22.5363 14.6167 22.4303 14.8287 22.2254 14.9982C21.5825 15.521 20.9397 16.0438 20.2897 16.5525C19.8376 16.9128 19.4137 16.8562 19.0534 16.4041C18.8132 16.1074 18.5801 15.8107 18.354 15.514C18.0502 15.1042 18.0926 14.6591 18.4529 14.3624C18.8061 14.0728 19.2583 14.1434 19.5903 14.539C19.8658 14.864 19.8658 14.864 20.2049 14.5955C20.5582 14.313 20.9043 14.0304 21.2576 13.7549C21.526 13.55 21.8298 13.5217 22.1265 13.6701C22.402 13.8043 22.5221 14.0586 22.5504 14.3483Z"
            fill="currentColor"
          />
        </svg>
      );
    } else {
      return (
        // <i className="mdi mdi-at align-middle email-menu-icon me-1"></i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="auto"
          viewBox="0 0 26 20"
          fill="currentColor"
          className="email-menu-icon me-1"
        >
          <path
            d="M12.2006 1.60367C10.053 1.60367 7.89827 1.63193 5.75062 1.59661C3.75132 1.56129 1.90745 3.05192 1.62487 5.16425C1.60367 5.34793 1.60367 5.53161 1.60367 5.71529C1.60367 8.2727 1.59661 10.823 1.60367 13.3804C1.60367 15.4574 2.97421 17.0964 5.02296 17.4638C5.29848 17.5132 5.58107 17.5062 5.86365 17.5062C8.45638 17.5062 11.042 17.5062 13.6348 17.5062C13.7902 17.5062 13.9527 17.5132 14.1081 17.5344C14.5249 17.591 14.8216 17.923 14.8216 18.3186C14.8216 18.7284 14.4966 19.0604 14.0728 19.0957C13.988 19.1028 13.8961 19.1028 13.8114 19.1028C11.1409 19.1028 8.4705 19.1028 5.80007 19.1028C2.87531 19.1099 0.558107 17.16 0.0706464 14.2706C0.0211939 13.9668 0 13.656 0 13.3522C0 10.8301 0 8.30802 0 5.78594C0.00706464 2.88237 1.97104 0.565171 4.83928 0.0706464C5.14306 0.0211939 5.44684 0 5.75768 0C10.0459 0 14.3412 0 18.6295 0C21.6178 0 24.0057 2.11939 24.3518 5.08654C24.4649 6.01907 24.373 6.95161 24.3942 7.88414C24.4013 8.15966 24.4013 8.42812 24.3942 8.70364C24.3801 9.1699 24.0763 9.50901 23.6383 9.53727C23.2285 9.56552 22.8824 9.25468 22.8188 8.80254C22.7623 8.39279 22.7976 7.97598 22.7976 7.55917C22.7905 6.90922 22.8047 6.25221 22.7905 5.60226C22.7552 3.36277 20.982 1.61074 18.7496 1.59661C18.7354 1.59661 18.7142 1.59661 18.7001 1.59661C16.5383 1.60367 14.3695 1.60367 12.2006 1.60367Z"
            fill="currentColor"
          />
          <path
            d="M20.5863 10.1448C23.1437 10.2225 25.4114 12.4338 25.2772 15.2667C25.15 18.1349 22.7551 20.1413 20.0988 20C17.2941 19.8516 15.316 17.5415 15.4008 14.9488C15.5068 11.8474 18.1419 9.97527 20.5863 10.1448ZM20.3461 18.4105C22.2111 18.4105 23.6876 16.941 23.6947 15.0759C23.6947 13.2109 22.2111 11.7132 20.3461 11.7132C18.5022 11.7132 16.9974 13.2109 16.9974 15.0547C16.9904 16.9269 18.4739 18.4105 20.3461 18.4105Z"
            fill="currentColor"
          />
          <path
            d="M12.1865 9.64324C11.8262 9.62205 11.4729 9.55847 11.1338 9.42424C8.84488 8.50583 6.55594 7.5945 4.26699 6.68316C3.85724 6.52067 3.67356 6.24515 3.69476 5.85659C3.71595 5.52456 3.94202 5.24197 4.27406 5.15013C4.50719 5.08655 4.72619 5.15719 4.93813 5.24197C7.12817 6.11799 9.32528 6.98694 11.5082 7.87708C11.9816 8.06783 12.4125 8.06783 12.8859 7.87708C15.0618 6.994 17.2518 6.12505 19.4348 5.2561C19.5902 5.19252 19.7386 5.12187 19.9152 5.12187C20.2684 5.12187 20.5793 5.34794 20.6782 5.67291C20.7771 6.01202 20.657 6.36525 20.3673 6.55599C20.2825 6.61251 20.1836 6.6549 20.0847 6.69729C17.8452 7.5945 15.6057 8.49171 13.3663 9.38892C12.9918 9.53727 12.5962 9.62205 12.1865 9.64324Z"
            fill="currentColor"
          />
          <path
            d="M22.5504 14.3483C22.5363 14.6167 22.4303 14.8287 22.2254 14.9982C21.5825 15.521 20.9397 16.0438 20.2897 16.5525C19.8376 16.9128 19.4137 16.8562 19.0534 16.4041C18.8132 16.1074 18.5801 15.8107 18.354 15.514C18.0502 15.1042 18.0926 14.6591 18.4529 14.3624C18.8061 14.0728 19.2583 14.1434 19.5903 14.539C19.8658 14.864 19.8658 14.864 20.2049 14.5955C20.5582 14.313 20.9043 14.0304 21.2576 13.7549C21.526 13.55 21.8298 13.5217 22.1265 13.6701C22.402 13.8043 22.5221 14.0586 22.5504 14.3483Z"
            fill="currentColor"
          />
        </svg>
      );
    }
  }

  function onBoxeCreateModalVisibility() {
    setCreateBoxModalVisibility(!create_box_modal_visibility);
  }

  function onMessageCreateModalVisibility() {
    setCreateMessageModalVisibility(!create_message_modal_visibility);
  }

  function checkAuthorizations(message) {
    const all_related_messages_tags =
      messagesTagsList[message.directMessageId] || [];
    let isAuthorized = false;
    if (
      client_data &&
      client_data.$id === JSON.parse(localStorage.getItem("authUser")).userId
    ) {
      return true;
    }
    for (let index = 0; index < all_related_messages_tags.length; index++) {
      if (
        currentEmployee &&
        currentEmployee.contact_reasons &&
        currentEmployee.contact_reasons.includes(
          all_related_messages_tags[index]
        )
      ) {
        isAuthorized = true;
      }
    }
    return isAuthorized;
  }

  const createBoxe = async function () {
    console.log("createBoxe");
    onMailActionLoading("create");

    const apiUrl = "https://mailbox.semecloud.tech/create-boxe";
    // const apiUrl = "http://localhost:55000/create-boxe";
    // axios
    //   .post(
    //     apiUrl,
    //     {
    //       company_id: client_data.$id,
    //       folder: "SMARTAS." + dossierName,
    //     },

    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   )
    createBoxPromise("SMARTAS." + dossierName)
      .then(async (response) => {
        console.log("Msg createBoxe", response);
        // Créer le log
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        let logData = {
          eventCreatedAt: Date.now(),
          author_id: user_id,
          company_id: client_data?.$id,
          mail_box_name: dossierName
        };
        let data = {
          event: "mail_box_created",
          author_id: user_id,
          company_id: client_data?.$id,
          log_data: JSON.stringify(logData)
        };
        createLog(data, mixPanelTrack);
        onBoxeCreateModalVisibility();
        onMailActionLoading(undefined);
        // fetchMailBoxes(localStorage.getItem("companyId"));
        if (!boxes_loading) {
          dispatch(fetchFoldersRedux(localStorage.getItem("companyId")));
        }
      })
      .catch((error) => {
        onMailActionLoading(undefined);
        onBoxeCreateModalVisibility();
        console.log("Failed createBoxe msg", error);
      });
  };

  // async function getCompanyEmployeesData(company_id) {
  //   const client = new Client();
  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   const promise = databases.listDocuments("default", "employee", [Query.equal("company_id", company_id)]);

  //   return promise.then(
  //     async function (response) {
  //       const employeeData = response.documents;
  //       if (employeeData.length > 0) {
  //         if (localStorage.getItem("authUser")) {
  //           const userId = JSON.parse(localStorage.getItem("authUser")).userId;
  //           const employeesList = employeeData[0].employees;
  //           const employees = employeesList.map((element) => JSON.parse(element));
  //           const currentEmployee = employees.filter((element) => element.id === userId);
  //           if (currentEmployee && currentEmployee.length > 0) {
  //             setCurrentEmployee(currentEmployee[0]);
  //           }
  //           if (employeeData[0].owner) {
  //             setOwnerInfos(JSON.parse(employeeData[0].owner));
  //           }
  //         }
  //       }

  //       return employeeData;
  //     },
  //     function (error) {
  //       console.log("Error listing company employees ", error);
  //       console.log(error); // Failure
  //       return null;
  //     }
  //   );
  // }

  async function getEmployeeLink() {
    var user_data_string = localStorage.getItem("authUser");

    if (!user_data_string) return;

    var user = JSON.parse(user_data_string);

    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.listDocuments("default", "employee_link", [
      Query.equal("employee_id", user.userId)
    ]);

    return promise.then(
      async function (response) {
        console.log("Employee link is ", response.documents);
        return response.documents;
      },
      function (error) {
        console.log("Error creating Employee link", error); // Failure
        return null;
      }
    );
  }

  const initData = async function () {
    //  dispatch(emptyMailBox());

    if (state && state.id) {
      // console.log("fetchSingleMailsRedux");
      dispatch(
        fetchSingleMailRedux(
          state.id,
          localStorage.getItem("companyId"),
          "INBOX"
        )
      );
    } else {
      //  if (!loading || (loading && getBoxFromUrl() !== currentBox)) {
      dispatch(
        fetchMailsRedux(
          localStorage.getItem("companyId"),
          getBoxFromUrl(),
          1,
          pageSize,
          []
        )
      );
      //    }
      //  if (!boxes_loading) {
      dispatch(fetchFoldersRedux(localStorage.getItem("companyId")));
      //    }
    }
  };

  const updateFolderData = async function (box) {
    console.log("the_folder to fetch is", box);

    // dispatch(emptyMailBox());

    closeMessageView();

    //  if (!loading ||  loading && getBoxFromUrl() !== box) {
    dispatch(
      fetchMailsRedux(localStorage.getItem("companyId"), box, 1, pageSize, [])
    );
    // }

    //   if (!boxes_loading) {
    dispatch(fetchFoldersRedux(localStorage.getItem("companyId")));
    // }
  };

  const parentDivRef = useRef(null);

  const getColors = function (key) {
    if (key === "REFUNDED" || key === "PAID" || key === "FULFILLED") {
      return { backgroundColor: "#d7fee1", color: "#046c28" };
    } else if (
      key === "IN_PROGRESS" ||
      key === "ON_HOLD" ||
      key === "OPEN" ||
      key === "PARTIALLY_FULFILLED" ||
      key === "PENDING_FULFILLMENT" ||
      key === "RESTOCKED" ||
      key === "SCHEDULED" ||
      key === "PARTIALLY_PAID" ||
      key === "PARTIALLY_REFUNDED" ||
      key === "PENDING" ||
      key === "UNFULFILLED"
    ) {
      return { backgroundColor: "rgba(255, 164, 18, 0.3)", color: "#ffa412" };
    } else if (key === "VOIDED") {
      return { backgroundColor: "rgba(241, 9, 68, 0.3)", color: "#f10944" };
    }
  };

  const svgs = {
    close_icon: (
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.37 19.6142C19.0771 19.8983 18.778 20.038 18.4725 20.0334C18.1504 20.0115 17.8473 19.8542 17.5632 19.5613L12.9511 14.8068L8.27403 19.3437C7.98118 19.6278 7.68204 19.7675 7.3766 19.7629C7.07117 19.7582 6.78476 19.6181 6.5174 19.3425C6.25003 19.0668 6.11866 18.7763 6.12331 18.4709C6.12795 18.1654 6.2767 17.8707 6.56955 17.5866L11.2466 13.0497L6.78484 8.45016C6.48405 8.14008 6.33598 7.83232 6.34062 7.52688C6.34527 7.22145 6.50263 6.91834 6.81271 6.61755C7.10556 6.33347 7.39609 6.2021 7.6843 6.22346C7.98973 6.2281 8.29284 6.38546 8.59364 6.69554L13.0554 11.295L17.7324 6.75812C18.0252 6.47404 18.3244 6.33432 18.6298 6.33896C18.9353 6.34361 19.2217 6.48374 19.489 6.75937C19.7564 7.03499 19.8878 7.32552 19.8831 7.63096C19.8785 7.93639 19.7297 8.23115 19.4369 8.51523L14.7598 13.0522L19.372 17.8067C19.6561 18.0996 19.8041 18.4073 19.8162 18.73C19.8288 19.0187 19.68 19.3135 19.37 19.6142Z"
          fill="#2F384C"
        />
      </svg>
    )
  };

  const handleFileSelect = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      console.log("Fichier sélectionné :", file);
    };
    fileInput.click();
  };

  const onInstructionRequestChange = (value) => {
    setInstructionRequestValue(value);
  };
  const onSendEmailRequestChange = (value) => {
    setSendEmailRequestValue(value);
  };

  const onInstructionInputChange = (event) => {
    setInstructionText(event.target.value);
  };
  const updateEmailSuggestedText = (value) => {
    setEmailSuggestedText(value);
  };

  let message = null;
  const process_start_time = Date.now().toString();

  const the_folder = getBoxFromUrl();

  // if (props.the_message) {
  //   message = props.the_message;
  //   const the_folder = getBoxFromUrl();
  //   the_folder = props.folder;
  // } else if (state) {
  //   message = state.the_message;
  //   const the_folder = getBoxFromUrl();
  //   the_folder = state.folder;
  // }

  // async function getAiTextImprovement(theTask) {
  //   console.log("getAiTextImprovement called");
  //   // console.log("text to process is", getText());

  //   const messageToReply =
  //     !message.related_messages || message.related_messages.length === 0 ? message : message.related_messages[message.related_messages.length - 1];

  //   // let message_to_reply_id = "";
  //   // if (typeof messageToReply.headers["message-id"] === "string") {
  //   //   message_to_reply_id = messageToReply.headers["message-id"];
  //   // } else if (Array.isArray(messageToReply.headers["message-id"])) {
  //   //   message_to_reply_id = messageToReply.headers["message-id"][0];
  //   // }

  //   // const msg_language = messageInfos[message_to_reply_id].client_language;

  //   onInstructionRequestChange(true);
  //   onSendEmailRequestChange(true);

  //   const response = await createAiTextImprovementFunctionExecution({
  //     task: theTask,
  //     data: getText(),
  //     interlocutor_text:
  //       theTask === "translation" ? (messageToReply.body.textAsHtml ? messageToReply.body.textAsHtml : messageToReply.body.text) : undefined,
  //   });
  //   console.log({ createAiTextImprovementFunctionExecution: response });

  //   if (response && response.responseBody) {
  //     //  updateCompanyTokenUsage(500, 2000);
  //     const data = JSON.parse(response.responseBody).ia_response;

  //     console.log("text response is", data);
  //     const jsonObject = {
  //       text: data,
  //     };
  //     const jsonString = JSON.stringify(jsonObject);

  //     addSimpleTextToEditor(JSON.parse(jsonString).text);
  //     onInstructionRequestChange(false);
  //     onSendEmailRequestChange(false);

  //     updateEmailSuggestedText(data);

  //     var reason;
  //     switch (theTask) {
  //       case "styling":
  //         reason = "Text style improvement";
  //         break;
  //       case "translation":
  //         reason = "Text translation";
  //         break;
  //       case "grammar":
  //         reason = "Text style improvement";
  //         break;
  //       case "reduce":
  //         reason = "Text contraction";
  //         break;
  //       default:
  //         break;
  //     }
  //     props.incrementAttrByValue(0.25, reason);

  //     // Créer le log
  //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //     const company_id = localStorage.getItem("companyId");
  //     let logData = {
  //       eventCreatedAt: Date.now(),
  //       author_id: user_id,
  //       company_id,
  //     };
  //     let logdata = {
  //       event: "ia_autogen_request",
  //       author_id: user_id,
  //       company_id,
  //       log_data: JSON.stringify(logData),
  //     };
  //     createLog(logdata, mixPanelTrack);
  //   } else {
  //     const error =
  //       response && response.responseBody && JSON.parse(response.responseBody).error && JSON.parse(response.responseBody).error.message
  //         ? JSON.parse(response.responseBody).error.message
  //         : "Erreur inattendue";
  //     console.log("Failed getting AIResponse", error);

  //     onInstructionRequestChange(false);
  //     onSendEmailRequestChange(false);
  //   }
  // }

  // async function getAIResponse() {
  //   const messageToReply =
  //     !message.related_messages || message.related_messages.length === 0 ? message : message.related_messages[message.related_messages.length - 1];

  //   console.log("getAIResponse called");
  //   console.log("input instruction is", instruction_text);
  //   console.log("messageToReply body is", messageToReply.body.text);

  //   onInstructionRequestChange(true);
  //   onSendEmailRequestChange(true);

  //   const response = await createAIResponseExecution({
  //     emails: [
  //       {
  //         email_id: messageToReply.messageId,
  //         // email_subject: messageToReply.subject,
  //         email_body: messageToReply.body.textAsHtml ? messageToReply.body.textAsHtml : messageToReply.body.text,
  //         email_sender: `${messageToReply.from.value[0].name} <${messageToReply.from.value[0].address}>`,
  //       },
  //     ],
  //     company_id: localStorage.getItem("companyId"),
  //   });

  //   console.log({ createAIResponseExecution: response });

  //   if (response && response.responseBody && JSON.parse(response.responseBody).result) {
  //     const data = JSON.parse(response.responseBody);
  //     console.log({ data });
  //     updateCompanyTokenUsage(
  //       data.token_email_response.prompt_tokens + data.token_analyse.prompt_tokens,
  //       data.token_email_response.completion_tokens + data.token_analyse.completion_tokens
  //     );

  //     console.log("text response is", data.result[messageToReply.messageId].mail_response);
  //     const jsonObject = {
  //       text: data.result[messageToReply.messageId].mail_response,
  //     };
  //     const jsonString = JSON.stringify(jsonObject);

  //     addSimpleTextToEditor(JSON.parse(jsonString).text);
  //     onInstructionRequestChange(false);
  //     onSendEmailRequestChange(false);

  //     updateEmailSuggestedText(data.result[messageToReply.messageId].mail_response);

  //     props.incrementAttrByValue(1, "Email reply");

  //     // Créer le log
  //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //     const company_id = localStorage.getItem("companyId");
  //     let logData = {
  //       eventCreatedAt: Date.now(),
  //       author_id: user_id,
  //       company_id,
  //       mail_id: messageToReply.messageId,
  //       receiver: `${messageToReply.from.value[0].name} <${messageToReply.from.value[0].address}>`,
  //       subject: messageToReply.subject,
  //     };
  //     let logdata = {
  //       event: "ia_autogen_request",
  //       author_id: user_id,
  //       company_id,
  //       log_data: JSON.stringify(logData),
  //     };
  //     createLog(logdata, mixPanelTrack);
  //   } else {
  //     const error =
  //       response && response.responseBody && JSON.parse(response.responseBody).error && JSON.parse(response.responseBody).error.message
  //         ? JSON.parse(response.responseBody).error.message
  //         : "Erreur inattendue";
  //     console.log("Failed getting AIResponse", error);

  //     onInstructionRequestChange(false);
  //     onSendEmailRequestChange(false);
  //   }

  //   /*
  //   axios
  //     .post(
  //       "https://ai.semecloud.tech/email-reply",

  //       {
  //         emails: [
  //           {
  //             email_id: messageToReply.messageId,
  //             // email_subject: messageToReply.subject,
  //             email_body: messageToReply.body.textAsHtml ? messageToReply.body.textAsHtml : messageToReply.body.text,
  //             email_sender: `${messageToReply.from.value[0].name} <${messageToReply.from.value[0].address}>`,
  //           },
  //         ],
  //         company_id: localStorage.getItem("companyId"),
  //       },
  //     )
  //     .then((response) => {
  //       // Traiter les données de la réponse

  //       const data = response.result;
  //       updateCompanyTokenUsage(
  //         response.token_email_response.prompt_tokens + response.token_analyse.prompt_tokens,
  //         response.token_email_response.completion_tokens + response.token_analyse.completion_tokens,
  //       );

  //       console.log("instruction response is", data);

  //       console.log("text response is", data[messageToReply.messageId].mail_response);
  //       const jsonObject = {
  //         text: data[messageToReply.messageId].mail_response,
  //       };
  //       const jsonString = JSON.stringify(jsonObject);

  //       addSimpleTextToEditor(JSON.parse(jsonString).text);
  //       onInstructionRequestChange(false);
  //       onSendEmailRequestChange(false);

  //       updateEmailSuggestedText(data);
  //       // Créer le log
  //       var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //       const company_id = localStorage.getItem("companyId");
  //       let logData = {
  //         eventCreatedAt: Date.now(),
  //         author_id: user_id,
  //         company_id,
  //         mail_id: messageToReply.messageId,
  //         receiver: `${messageToReply.from.value[0].name} <${messageToReply.from.value[0].address}>`,
  //         subject: messageToReply.subject,
  //       };
  //       let logdata = {
  //         event: "ia_autogen_request",
  //         author_id: user_id,
  //         company_id,
  //         log_data: JSON.stringify(logData),
  //       };
  //       createLog(logdata, mixPanelTrack);
  //     })
  //     .catch((error) => {
  //       console.log("Failed getting AIResponse", error);
  //       // Gérer l'erreur
  //       if (error.response) {
  //         // La requête a été reçue, mais le serveur a répondu avec un code d'erreur
  //         console.log("// La requête a été reçue, mais le serveur a répondu avec un code d'erreur");
  //         console.log(error.response.data);
  //         console.log(error.response.status);
  //         console.log(error.response.headers);
  //       } else if (error.request) {
  //         console.log("// La requête a été envoyée, mais aucune réponse n'a été reçue");
  //         console.log(error.request);
  //       } else {
  //         console.log("// Une erreur est survenue lors de la création de la requête");
  //         console.log("Erreur", error.message);
  //       }
  //       console.log(error.config);
  //       onInstructionRequestChange(false);
  //       onSendEmailRequestChange(false);
  //     });
  //     */
  // }

  const { subscription_credits } = useSelector((state) => {
    return {
      subscription_credits: state.subscription.subscriptionCredits
      // client_data: state.GeneralStateRedux.client_data
    };
  });

  const [detailsAccordion, setDetailsAccordion] = useState({
    infos: true,
    alerts: true,
    tags: true
  });

  const onToggleDetailsAccordion = (val, attr) => {
    setDetailsAccordion({ ...detailsAccordion, [attr]: val });
  };

  const [selected_alert, seletectAlert] = useState(undefined);
  const [modal_list, setmodal_list] = useState(false);
  const [updateAlertloading, setUpdateAlertloading] = useState(false);
  const [modalInfo, setModalInfo] = useState({
    id: "", // Initialisez ces valeurs à vide
    statusText: "",
    information: "",
    date: ""
  });
  const [allAlerts, setAllAlerts] = useState([]);

  const onSeletectAlert = (val) => {
    seletectAlert(val);
  };
  const onLoadingChanged = (val) => {
    setUpdateAlertloading(val);
  };

  async function updateCompanyInfos(data) {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      {
        company_data: data.map((item) => JSON.stringify(item, null, 4))
      }
    );
    return promise.then(
      async function (response) {
        console.log(response); // Success
        return response;
      },
      function (error) {
        //   onDeleteLoadingChanged(false);
        setToastMessage({
          header: props.t("Echec"),
          body: error.message,
          key: "danger"
        });
        toggleToast();
        console.log(error); // Failure
        return null;
      }
    );
  }
  async function updateAlert(alert_id) {
    console.log("updateAlert", alert_id);
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);
    try {
      await databases.updateDocument("default", "alert", alert_id, {
        active: false
      });
      console.log("Alert deleted successfully");
    } catch (error) {
      console.log("Error updating alert:", error);
    }
  }

  const formik = useFormik({
    initialValues: {
      status_field: "",
      information: ""
    },
    validationSchema: Yup.object({
      status_field: Yup.string().required("Veuillez sélectionner un tag."),
      information: Yup.string()
        .required("add-res_error_msg_2")
        .max(500, "add-res_error_msg_3")
    }),
    onSubmit: (values) => {
      handleModalUpdate();
    }
  });

  const handleModalUpdate = async () => {
    const newItem = {
      id: Date.now(),
      statusText: modalInfo.statusText,
      information: modalInfo.information,
      date: Date.now()
    };

    const updatedList = [...topicList, newItem];
    console.log({ updatedList });
    setModalInfo({
      id: "", // Initialisez ces valeurs à vide
      statusText: "",
      information: "",
      date: ""
    });

    onLoadingChanged(true);

    const response = await updateCompanyInfos(updatedList);
    if (!response) {
      onLoadingChanged(false);
      return;
    }

    await updateAlert(selected_alert.$id);

    // const newList = allAlerts.filter((alert) => alert.$id !== selected_alert.$id);
    // setAllAlerts(newList);

    tog_list();
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    let logData = {
      eventCreatedAt: response?.$createdAt,
      author_id: user_id,
      company_id: response.$id,
      topic_tag: newItem.statusText,
      topic_id: newItem.id
    };
    let logdata = {
      event: "topic_added",
      author_id: user_id,
      company_id: response.$id,
      log_data: JSON.stringify(logData)
    };
    createLog(logdata, mixPanelTrack);
    console.log("response message: ", response);
    onLoadingChanged(false);
    toggleToast();
    setToastMessage({
      header: props.t("Succès"),
      body: props.t("Modifications effectuées"),
      key: "success"
    });
  };

  function tog_list(alert) {
    setmodal_list(!modal_list);
    if (modal_list) {
      if (!formik.isValid) {
        formik.resetForm(formik.initialValues);
      }
    }
  }

  const handleNavigation = (box) => {
    console.log("handleNavigation", box);

    // Navigue vers une nouvelle URL sans rafraîchir la page
    navigate(`/mailbox?folder=${box}`);
  };
  function getBoxFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get("folder") || "INBOX";
  }

  return (
    <React.Fragment>
      <Modal isOpen={modal_list} toggle={tog_list} centered>
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={tog_list}
        >
          {props.t("Ajouter une ressource")}
        </ModalHeader>
        <form className="tablelist-form">
          <ModalBody>
            <div>
              <label htmlFor="status_field" className="form-label">
                {props.t("Catégories")}
              </label>
              <select
                className={`form-control ${
                  formik.touched.status_field &&
                  formik.errors.status_field &&
                  "border border-danger"
                }`}
                data-trigger
                name="status_field"
                id="status_field"
                value={modalInfo.statusText}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  console.log({ select_option_value: e });

                  formik.handleChange(e);
                  setModalInfo({
                    ...modalInfo,
                    statusText: e.target.value
                  });
                }}
              >
                <option value="" disabled>
                  {props.t("Aucun")}
                </option>
                {selected_alert &&
                selected_alert.contact_reasons &&
                selected_alert.contact_reasons.length > 0 ? (
                  selected_alert.contact_reasons.map((item, index) => (
                    <option key={index} value={item}>
                      {props.t(item)}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    {props.t("Aucun")}
                  </option>
                )}
              </select>
              {formik.touched.status_field && formik.errors.status_field && (
                <span className="font-primary text-danger">
                  {props.t("add-res_error_msg_1")}
                </span>
              )}
            </div>
            <div className="my-3">
              <label htmlFor="information" className="form-label">
                {props.t("Informations")}
              </label>
              <textarea
                id="information"
                name="information"
                style={{
                  border: "none",
                  position: "relative" // Rendre le textarea positionnel
                }}
                required
                className={`text-area col-12 form-control ${
                  formik.touched.information &&
                  formik.errors.information &&
                  "border border-danger"
                }`}
                placeholder={props.t("Entrer les informations")}
                rows="3"
                cols="45"
                value={modalInfo.information}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                  setModalInfo({ ...modalInfo, information: e.target.value });
                }}
              ></textarea>
              {
                <span
                  className={`font-primary mt-1 ${
                    formik.touched.information && formik.errors.information
                      ? "text-danger"
                      : ""
                  }`}
                  style={{ float: "right" }}
                >{`${modalInfo.information.length}/500`}</span>
              }
              {formik.touched.information && formik.errors.information && (
                <span className="font-primary text-danger">
                  {props.t(formik.errors.information)}
                </span>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <div
              className="hstack gap-2 justify-content-end"
              style={{ width: "100%" }}
            >
              <button
                type="button"
                className="view-button "
                style={{ color: "black", width: "100%" }}
                onClick={tog_list}
              >
                {props.t("Annuler")}
              </button>
              <button
                type="button"
                className="view-button "
                style={{ backgroundColor: "#563bff", width: "100%" }}
                id="edit-btn"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                {updateAlertloading && (
                  <span
                    className="spinner-border spinner-border-sm me-2 font-primary"
                    role="status"
                    aria-hidden="true"
                  />
                )}

                {props.t("Ajouter")}
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>
      <Modal
        isOpen={moveToModal}
        toggle={tog_Modal}
        centered
        className=""
        style={{ maxWidth: "30%" }}
      >
        <ModalBody>
          <Button
            className="close_button"
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: "0px",
              float: "right"
            }}
            onClick={() => {
              tog_Modal();
            }}
          >
            {svgs.close_icon}
          </Button>
          <h1
            className="modal_title"
            style={{ marginTop: "4%", marginBottom: "4%" }}
          >
            {props.t("Attention")}
          </h1>
          <Row
            className="mb-3"
            style={{ paddingLeft: "5%", paddingRight: "5%" }}
          >
            <p className="text-center font-primary simple-text">
              {props.t("moving_alert_msg")}
            </p>
          </Row>
          <Row
            className="mb-2 d-flex justify-content-center gap-3"
            style={{ paddingLeft: "5%", paddingRight: "5%" }}
          >
            <Button
              style={{
                padding: "8px 10px",
                borderRadius: "10px",
                fontWeight: "600",
                backgroundColor: "#563bff",
                boxShadow:
                  "0px 16.20517px 37.81205px 0px rgba(255, 112, 73, 0.2)",
                border: "none"
              }}
              className="col-3 font-primary simple-text"
              onClick={() => {
                selectedAction(
                  multiSelectedMessage.length > 0
                    ? multiSelectedMessage
                    : [selectedMessage.messageId],
                  getBoxFromUrl(),
                  folder.name
                );
              }}
            >
              {props.t("Oui")}
            </Button>
            <Button
              className="col-3 font-primary simple-text"
              style={{
                padding: "8px 10px",
                borderRadius: "10px",
                border: "none",
                fontWeight: "600"
              }}
              onClick={() => {
                tog_Modal();
              }}
            >
              {props.t("Annuler")}
            </Button>
          </Row>
        </ModalBody>
      </Modal>

      <div className="page-box-content">
        {/* <div className="page-content"> */}
        <Container fluid={true} style={{ padding: "0px", height: "100%" }}>
          {/* <Breadcrumbs title="Email" breadcrumbItem="Inbox" /> */}
          {/* <!-- Begin page --> */}
          <div id="layout-wrapper" style={{ height: "100%" }}>
            {/* @@include("partials/menu.html", {"title": "Inbox"}) */}
            {/*   
        <!-- ============================================================== -->
        <!-- Start right Content here -->
        <!-- ============================================================== --> */}

            <div className="" style={{ height: "100%" }}>
              <div
                className="cols-container d-flex"
                style={{
                  backgroundColor: "#f1f1f1",
                  height: "100%"
                }}
              >
                {/* SideBar */}
                <Col
                  lg={"auto"}
                  className="inbox-menu col-xl-auto"
                  style={{
                    height: "100%",
                    overflowY: "auto",
                    minWidth: "200px"
                  }}
                >
                  <div className="" style={{ height: "100%" }}>
                    {/* <div className="card">
            <div className="card-body"> */}
                    {/* <Row className="" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
          <Col xl={10}>
            <div className="column-title">BOITE DE RÉCEPTION</div>
          </Col>
          <Col xl={2} className="d-flex justify-content-end">
            <Link to="">
              <i
                className="bx bx-search "
                style={{
                  marginLeft: "8px",
                  color: "#222222",
                  fontSize: "18px",
                  marginTop: "3px",
                }}
              ></i>
            </Link>
          </Col>
        </Row> */}

                    {/* <button className="compose-mail-button d-flex align-items-center">
                        <span>
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M7.4 14.104C6.98933 14.104 6.672 13.992 6.448 13.768C6.224 13.5253 6.112 13.1987 6.112 12.788V8.196H1.604C1.212 8.196 0.904 8.09333 0.68 7.888C0.456 7.664 0.344 7.356 0.344 6.964C0.344 6.572 0.456 6.27333 0.68 6.068C0.904 5.844 1.212 5.732 1.604 5.732H6.112V1.28C6.112 0.869333 6.224 0.551999 6.448 0.327999C6.672 0.103999 6.99867 -0.00800037 7.428 -0.00800037C7.83867 -0.00800037 8.14667 0.103999 8.352 0.327999C8.576 0.551999 8.688 0.869333 8.688 1.28V5.732H13.196C13.6067 5.732 13.9147 5.844 14.12 6.068C14.344 6.27333 14.456 6.572 14.456 6.964C14.456 7.356 14.344 7.664 14.12 7.888C13.9147 8.09333 13.6067 8.196 13.196 8.196H8.688V12.788C8.688 13.1987 8.576 13.5253 8.352 13.768C8.14667 13.992 7.82933 14.104 7.4 14.104Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                        Nouv. Message
                      </button> */}

                    <div className=" p-0 overflow-hidden shadow-none">
                      <div className="mail-list">
                        <div className="mail-list-title mt-4 w-100 d-flex justify-content-between">
                          {displaySearchBar ? (
                            <InputGroup
                              style={{
                                border: "1px solid #2F384C",
                                borderRadius: "4px",
                                maxWidth: "100%"
                              }}
                            >
                              <Input
                                className="font-primary ps-2 py-1 pe-0"
                                placeholder="Search..."
                                style={{
                                  color: "black",
                                  border: "none",
                                  fontSize: "12px"
                                }}
                                // disabled={loading}
                                value={recherche}
                                onChange={(e) => {
                                  setRecherche(e.target.value);
                                }}
                                onKeyDown={(event) => {
                                  const input = recherche
                                    .replace(/<div>|<br.*?>/gi, "\n")
                                    .replace(/<\/div>/g, "")
                                    .trim();
                                  console.log({ input: recherche.length });
                                  if (recherche.length === 1) {
                                    if (isSearch) {
                                      closeMessageView();
                                      dispatch(
                                        fetchMailsRedux(
                                          localStorage.getItem("companyId"),
                                          getBoxFromUrl(),
                                          1,
                                          pageSize,
                                          []
                                        )
                                      );
                                    }
                                  } else if (
                                    !loading &&
                                    event.key === "Enter" &&
                                    input.length > 0
                                  ) {
                                    dispatch(
                                      searchMailsRedux(
                                        recherche,
                                        localStorage.getItem("companyId"),
                                        getBoxFromUrl()
                                      )
                                    );
                                  }
                                }}
                              />
                              <InputGroupText
                                style={{
                                  backgroundColor: "white",
                                  border: "none",
                                  padding: "0",
                                  paddingLeft: "1px"
                                }}
                              >
                                <div
                                  onClick={() => {
                                    setDisplaySearchBar(false);
                                    setRecherche("");
                                    // if (isSearch) {
                                    closeMessageView();
                                    dispatch(
                                      fetchMailsRedux(
                                        localStorage.getItem("companyId"),
                                        "INBOX",
                                        1,
                                        pageSize,
                                        []
                                      )
                                    );
                                    // }
                                  }}
                                  style={{
                                    color: "black",
                                    cursor: "pointer"
                                  }}
                                >
                                  {!loading ? (
                                    <CrossOutlined
                                      width={"22px"}
                                      height={"22px"}
                                    />
                                  ) : (
                                    recherche && (
                                      <span
                                        className="spinner-border me-1 spinner-border-sm font-primary"
                                        role="status"
                                        aria-hidden="true"
                                        style={{
                                          height: "14px",
                                          width: "14px"
                                        }}
                                      />
                                    )
                                  )}
                                </div>
                              </InputGroupText>
                            </InputGroup>
                          ) : (
                            <>
                              {props.t("Email")}
                              <div className="d-flex">
                                {/* <Button className="me-2">
                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M18.5 14C18.5 14 17.7308 14 17.4103 14.112C17.2147 14.1804 17.0308 14.2788 16.8654 14.4037C16.5944 14.6082 16.3962 14.9054 15.9999 15.5C15.6035 16.0946 15.4053 16.3918 15.1344 16.5963C14.9689 16.7212 14.7851 16.8196 14.5894 16.888C14.2689 17 13.9117 17 13.1971 17H10.8026C10.0881 17 9.73079 17 9.41035 16.888C9.21467 16.8196 9.03081 16.7212 8.86536 16.5963C8.59442 16.3918 8.39624 16.0946 7.99987 15.5C7.60349 14.9054 7.40531 14.6082 7.13437 14.4037C6.96892 14.2788 6.78506 14.1804 6.58938 14.112C6.26895 14 5.71458 14 5.00001 14V14C3.54706 14 2.36996 12.813 2.66834 11.391C2.72905 11.1017 2.79668 10.8129 2.869 10.5237L3.30357 8.78543C4.02044 5.91811 4.37888 4.48444 5.31351 3.52013C5.63445 3.18901 5.99965 2.90388 6.39872 2.67284C7.56093 2 9.0406 2 11.9999 2C14.9593 2 16.439 2 17.6013 2.67287C18.0003 2.90391 18.3655 3.18905 18.6865 3.52018C19.6211 4.48452 19.9795 5.91823 20.6963 8.78566L21.1308 10.5237C21.2714 11.0859 21.3416 11.367 21.3977 11.6473C21.7082 13.2004 21.7082 14.7996 21.3977 16.3527C21.3416 16.633 21.2713 16.9141 21.1308 17.4763C20.9559 18.1759 20.8684 18.5257 20.7506 18.8261C20.0846 20.5237 18.5471 21.7241 16.7387 21.9585C16.4187 22 16.0581 22 15.3369 22H8.66273C7.94164 22 7.5811 22 7.26112 21.9585C5.45261 21.7241 3.91514 20.5237 3.24913 18.8261C3.13129 18.5257 3.04385 18.1759 2.86896 17.4764C2.8224 17.2901 2.78355 17.1347 2.75038 17C2.70076 16.7985 2.66384 16.6432 2.6328 16.5M9.00006 7H15.0001M10.0001 11H14.0001"
                                      stroke="#2F384C"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                </Button> */}
                                <Button
                                  onClick={() => {
                                    setDisplaySearchBar(true);
                                  }}
                                >
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M21 21L18.4953 18.4953C18.1033 18.1033 17.9073 17.9073 17.7092 17.8311C17.5121 17.7553 17.3684 17.7425 17.161 17.7825C16.9527 17.8226 16.6814 18.0117 16.1387 18.3897C14.6817 19.4048 12.9104 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 12.2414 19.7487 13.4241 19.2941 14.5"
                                      stroke="#2F384C"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                </Button>
                              </div>
                            </>
                          )}
                        </div>

                        <div
                          style={{ marginBottom: "10px", marginTop: "10px" }}
                        >
                          <h2
                            className="accordion-header"
                            id="flush-headingFive"
                          >
                            <button
                              onClick={() => {
                                onMessageCreateModalVisibility();
                              }}
                              className="accordion-button collapsed accordion-new-button"
                              disabled={boxes_loading}
                              cursor={boxes_loading ? "not-allowed" : "pointer"}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseFive"
                              aria-expanded="false"
                              aria-controls="flush-collapseFive"
                              style={{ backgroundColor: "#563bff" }}
                            >
                              {props.t("Nouveau message")}
                              {/* <span style={{ marginLeft: "10px" }}>+</span> */}
                            </button>
                          </h2>
                        </div>

                        <h2 className="accordion-header" id="flush-headingFive">
                          <button
                            onClick={() => {
                              onBoxeCreateModalVisibility();
                            }}
                            className="accordion-button collapsed accordion-new-button"
                            disabled={boxes_loading}
                            cursor={boxes_loading ? "not-allowed" : "pointer"}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseFive"
                            aria-expanded="false"
                            aria-controls="flush-collapseFive"
                            style={{ backgroundColor: "black" }}
                          >
                            {props.t("Créer un dossier")}
                            {/* <span style={{ marginLeft: "10px" }}>+</span> */}
                          </button>
                        </h2>

                        {boxes && boxes[localStorage.getItem("companyId")] ? (
                          boxes[localStorage.getItem("companyId")].map(
                            (box, index) =>
                              (currentEmployee &&
                                currentEmployee.autorizations &&
                                currentEmployee.autorizations.includes(
                                  box.name.toLowerCase()
                                )) ||
                              (client_data &&
                                client_data.$id ===
                                  JSON.parse(localStorage.getItem("authUser"))
                                    .userId) ? (
                                <div
                                  to="/mailbox"
                                  className={`${
                                    getBoxFromUrl() === box.name
                                      ? "email-menu-active"
                                      : getBoxFromUrl() === undefined &&
                                        box.name.toLowerCase() === "inbox"
                                      ? "email-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    //  cursor: loading ? "not-allowed" : "pointer",
                                    cursor: "pointer",
                                    marginTop: index ? "10px" : "18px"
                                  }}
                                  onClick={
                                    () => {
                                      //   if (!loading) {
                                      // onBoxChanged(box.name);
                                      handleNavigation(box.name);
                                      updateFolderData(box.name);
                                      setMultiSelectedMessage([]);
                                      //    }
                                    } /*goToMBoxPage(box.name)*/
                                  }
                                >
                                  <div className="d-flex">
                                    {getMailboxIcon(box.name)}

                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p className="email-menu-title font-primary">
                                          {props.t(getBoxLocalName(box.name))}
                                        </p>
                                      </div>
                                      {/* {box.status &&
                  box.status.UNSEEN &&
                  box.status.UNSEEN > 0 ? ( */}
                                      {/* <div className="flex-shrink-0 ms-auto">
                                      <span className="unseen-badge font-primary">
                                        {box.status && box.status.MESSAGES ? box.status.MESSAGES : ""}
                                      </span>
                                    </div> */}
                                      {/* ) : (
                    <div></div>
                  )} */}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div
                                  to="/mailbox"
                                  className={`${
                                    getBoxFromUrl() === box.name
                                      ? "email-menu-active"
                                      : getBoxFromUrl() === undefined &&
                                        box.name.toLowerCase() === "inbox"
                                      ? "email-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    // cursor: loading ? "not-allowed" : "pointer",
                                    cursor: "pointer",
                                    marginTop: index ? "10px" : "18px"
                                  }}
                                  onClick={
                                    () => {
                                      // if (!loading) {
                                      // onBoxChanged(box.name);
                                      handleNavigation(box.name);
                                      updateFolderData(box.name);
                                      // }
                                    } /*goToMBoxPage(box.name)*/
                                  }
                                >
                                  <div className="d-flex">
                                    {getMailboxIcon(box.name)}

                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p className="email-menu-title">
                                          {props.t(getBoxLocalName(box.name))}
                                        </p>
                                      </div>
                                      {/* {box.status &&
                  box.status.UNSEEN &&
                  box.status.UNSEEN > 0 ? ( */}
                                      <div className="flex-shrink-0 ms-auto">
                                        <span className="unseen-badge font-primary">
                                          {box.status && box.status.MESSAGES
                                            ? box.status.MESSAGES
                                            : ""}
                                        </span>
                                      </div>
                                      {/* ) : (
                    <div></div>
                  )} */}
                                    </div>
                                  </div>
                                </div>
                              )
                          )
                        ) : (
                          <div
                            to="/mailbox"
                            className={`${
                              state && state.pathname === "/mailbox"
                                ? "email-menu-active"
                                : ""
                            }`}
                            style={{
                              // cursor: loading ? "not-allowed" : "pointer",
                              cursor: "pointer",
                              marginTop: "18px"
                            }}
                            onClick={() => goToMBoxPage("INBOX")}
                          >
                            <div className="d-flex font-primary">
                              {getMailboxIcon("INBOX")}
                              <div className="flex-grow-1 flex-srink-1 mt-0">
                                <p className="email-menu-title font-primary">
                                  {"Inbox"}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* <div className="mail-list">
            <Link to="/mailbox" className={`${location.pathname === '/mailbox' ? 'email-menu-active' : ''}`}>
              <div className="d-flex">
                {
                  getMessages && getMessages[0] ? <Badge color="black" className="rounded-circle align-middle me-3" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: '20px', width: '20px', padding: "6px" }}>
                    {(getMessages[0].from.value[0].address ?? getMessages[0].from.value[0].name)
                      .split(' ')
                      .map(part => part.charAt(0).toUpperCase())
                      .join('').slice(0, 2)}
                  </Badge> : <Badge color="black" className="rounded-circle align-middle me-3" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: '20px', width: '20px', padding: "6px" }}>
                    .
                  </Badge>
                } 

                 <div className="flex-grow-1 mt-0">
                  <p className="email-menu-title">Boite de réception</p>

                </div>
                <div className="flex-shrink-0">
                  <div className="float-end">
                    <span className="bg-black badge">{props.message_type === "main" ? props.messages.length : 0}</span>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="/sent" className={`${location.pathname === '/sent' ? 'email-menu-active' : ''}`}>
              <div className="d-flex align-items-center">
                <i className="mdi mdi-at align-middle email-menu-icon"></i>
                <div className="flex-grow-1">
                  <h5 className="email-menu-title">Envoyés</h5>
                  <span className="text-muted font-size-13 text-truncate ">

                  </span>
                </div>
                <div className="flex-shrink-0">
                  <div className="float-end">
                    <span className="bg-success badge"></span>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="/treated" className={`${location.pathname === '/treated' ? 'email-menu-active' : ''}`}>
              <div className="d-flex align-items-center">
                <i className="mdi mdi-account-multiple email-menu-icon align-middle me-3"></i>
                <div className="flex-grow-1">
                  <h5 className="email-menu-title">Traités</h5>

                </div>
              </div>
            </Link>
            <Link to="/untreated" className={`${location.pathname === '/untreated' ? 'email-menu-active' : ''}`}>
              <div className="d-flex align-items-center">
                <i className="mdi mdi-account-settings align-middle email-menu-icon"></i>
                <div className="flex-grow-1">
                  <h5 className="email-menu-title">Non traités</h5>

                </div>
              </div>
            </Link>

            <a href="#" className="border-bottom">
              <div className="d-flex align-items-center">
                <i className="mdi mdi-chart-bar  align-middle email-menu-icon"></i>
                <div className="flex-grow-1">
                  <h5 className="email-menu-title">Archivés</h5>

                </div>
                <div className="flex-shrink-0"></div>
              </div>
            </a> 
            <a href="#" className="border-bottom">
              <div className="d-flex align-items-center">
                <i className="mdi mdi-file-outline align-middle email-menu-icon"></i>
                <div className="flex-grow-1">
                  <h5 className="email-menu-title">Brouillon</h5>
                  <span className="text-muted font-size-13 text-truncate">

                  </span>
                </div>
                <div className="flex-shrink-0"></div>
              </div>
            </a>


            <a href="#">
              <div className="d-flex align-items-center">
                <i className="mdi mdi-trash-can-outline align-middle email-menu-icon"></i>
                <div className="flex-grow-1">
                  <h5 className="email-menu-title">Supprimés</h5>
                  <span className="text-muted font-size-13 text-truncate">

                  </span>
                </div>
                <div className="flex-shrink-0"></div>
              </div>
            </a>
          </div>   */}
                    </div>

                    {/* <div className="accordion accordion-bar" id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingFive">
              <button className="accordion-button collapsed accordion-new-button" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                DOSSIERS
              </button>
            </h2>
            <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
              <div className="accordion-body" >
                {folderData.map((folder, index) => (
                  <Row key={index} className='align-items-center  mb-2'>
                    <Col xl={1} >
                      <div style={{ backgroundColor: folder.color, borderRadius: "50px", width: '15px', height: '15px' }}> </div>
                    </Col>
                    <Col xl={11} >{folder.name}</Col>
                  </Row>
                ))}
              </div>
            </div>
          </div>
        </div> */}

                    {/*                        <h5 className="mt-3 font-size-15 text-uppercase">Labels</h5>

                        <div className="card p-0 overflow-hidden mt-3 shadow-none">
                          <div className="mail-list">
                            <a href="#" className="border-bottom">
                              <span className="mdi mdi-arrow-right-drop-circle text-info float-end"></span>
                              Theme Support
                            </a>
                            <a href="#" className="border-bottom">
                              <span className="mdi mdi-arrow-right-drop-circle text-warning float-end"></span>
                              Freelance
                            </a>
                            <a href="#" className="border-bottom">
                              <span className="mdi mdi-arrow-right-drop-circle text-primary float-end"></span>
                              Social
                            </a>
                            <a href="#" className="border-bottom">
                              <span className="mdi mdi-arrow-right-drop-circle text-danger float-end"></span>
                              Friends
                            </a>
                            <a href="#">
                              <span className="mdi mdi-arrow-right-drop-circle text-success float-end"></span>
                              Family
                            </a>
                          </div>
                        </div>

                        <h5 className="mt-3 font-size-15 text-uppercase">Chat</h5>

                        <div className="card p-0 overflow-hidden mt-3 mb-1 shadow-none">
                          <div className="mail-list">
                            <a
                              href="javascript: void(0);"
                              className="d-flex align-items-start border-bottom"
                            >
                              <img
                                className="flex-shrink-0 me-3 rounded-circle"
                                src={avatar_2}
                                alt="Generic placeholder image"
                                height="36"
                              ></img>
                              <div className="flex-grow-1 chat-user-box">
                                <p className="user-title m-0">Scott Median</p>
                                <p className="text-muted mb-0">Hello</p>
                              </div>
                            </a>

                            <a
                              href="javascript: void(0);"
                              className="d-flex align-items-start border-bottom"
                            >
                              <img
                                className="flex-shrink-0 me-3 rounded-circle"
                                src={avatar_3}
                                alt="Generic placeholder image"
                                height="36"
                              ></img>
                              <div className="flex-grow-1 chat-user-box">
                                <p className="user-title m-0">Julian Rosa</p>
                                <p className="text-muted mb-0">
                                  What about our next..
                                </p>
                              </div>
                            </a>

                            <a
                              href="javascript: void(0);"
                              className="d-flex align-items-start border-bottom"
                            >
                              <img
                                className="flex-shrink-0 me-3 rounded-circle"
                                src={avatar_4}
                                alt="Generic placeholder image"
                                height="36"
                              ></img>
                              <div className="flex-grow-1 chat-user-box">
                                <p className="user-title m-0">David Medina</p>
                                <p className="text-muted mb-0">
                                  Yeah everything is fine
                                </p>
                              </div>
                            </a>

                            <a
                              href="javascript: void(0);"
                              className="d-flex align-items-start border-bottom"
                            >
                              <img
                                className="flex-shrink-0 me-3 rounded-circle"
                                src={avatar_6}
                                alt="Generic placeholder image"
                                height="36"
                              ></img>
                              <div className="flex-grow-1 chat-user-box">
                                <p className="user-title m-0">Jay Baker</p>
                                <p className="text-muted mb-0">Wow that's great</p>
                              </div>
                            </a>
                          </div>
                        </div>  
                        </div>
          </div> */}
                    <div>
                      <Modal
                        isOpen={create_box_modal_visibility}
                        toggle={() => {
                          onBoxeCreateModalVisibility();
                        }}
                        centered
                        id="firstmodal"
                      >
                        <ModalHeader toggle={onBoxeCreateModalVisibility}>
                          <h5
                            className="modal-title font-primary"
                            id="myModalLabel"
                          >
                            {props.t("Créer un dossier")}
                          </h5>
                        </ModalHeader>
                        <ModalBody className="modal-body">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={
                              props.t("Entrez le nom du dossier") + "..."
                            }
                            value={dossierName}
                            onChange={(e) => setDossierName(e.target.value)}
                          ></input>
                        </ModalBody>
                        <ModalFooter>
                          <div
                            className="hstack gap-2 justify-content-end"
                            style={{ width: "100%" }}
                          >
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#563bff",
                                width: "100%"
                              }}
                              className="btn btn-light font-primary view-button"
                              disabled={boxes_loading || mailActionLoading}
                              onClick={() => {
                                createBoxe();
                              }}
                            >
                              {mailActionLoading && (
                                <span
                                  className="spinner-border spinner-border-sm me-2 font-primary"
                                  role="status"
                                  aria-hidden="true"
                                />
                              )}
                              {props.t("Créer")}
                            </button>

                            <button
                              type="button"
                              className="font-primary view-button"
                              style={{
                                color: "black",
                                width: "100%"
                              }}
                              onClick={() => {
                                onBoxeCreateModalVisibility();
                              }}
                            >
                              {props.t("Annuler")}
                            </button>
                          </div>
                        </ModalFooter>
                      </Modal>
                    </div>

                    <div>
                      <Modal
                        backdrop={"static"}
                        keyboard={false}
                        isOpen={create_message_modal_visibility}
                        toggle={() => {
                          onMessageCreateModalVisibility();
                        }}
                        centered
                        id="firstmodal"
                        size="lg"
                      >
                        <ModalHeader toggle={onMessageCreateModalVisibility}>
                          <h5
                            className="modal-title font-primary"
                            id="myModalLabel"
                          >
                            {props.t("Nouveau message")}
                          </h5>
                        </ModalHeader>
                        <ModalBody className="modal-body">
                          <EmailRedact
                            create_message_modal_visibility={
                              create_message_modal_visibility
                            }
                            setCreateMessageModalVisibility={
                              setCreateMessageModalVisibility
                            }
                            setToastMessage={setToastMessage}
                            toggleToast={toggleToast}
                            toEmail={to_email}
                          />
                        </ModalBody>
                      </Modal>
                    </div>

                    <div>
                      <Modal
                        backdrop={"static"}
                        keyboard={false}
                        isOpen={no_configured_mailbox}
                        toggle={() => {}}
                        centered
                        id="firstmodal"
                        size="lg"
                      >
                        <ModalHeader toggle={() => {}}>
                          <h5
                            className="modal-title font-primary"
                            id="myModalLabel"
                          >
                            {props.t("Email service client")}
                          </h5>
                        </ModalHeader>
                        <ModalBody className="modal-body">
                          <p>
                            {props.t(
                              "Veuillez connecter votre boîte e-mail du service client"
                            )}
                          </p>
                        </ModalBody>
                        <ModalFooter>
                          <div
                            className="hstack gap-2 justify-content-end"
                            style={{ width: "100%" }}
                          >
                            <button
                              type="button"
                              className="view-button "
                              style={{
                                backgroundColor: "#563bff",
                                width: "auto"
                              }}
                              onClick={() => {
                                navigate(`/settings`, {
                                  replace: false,
                                  state: { tab: "email", modal: "" }
                                });
                              }}
                            >
                              {props.t("Ajouter")}
                            </button>
                          </div>
                        </ModalFooter>
                      </Modal>
                    </div>
                  </div>
                </Col>

                <div
                  className="d-flex flex-grow-1 h-100"
                  style={{ flexDirection: "column" }}
                >
                  <div className="d-flex flex-row flex-grow-1 h-100">
                    <div
                      // xl={3}
                      ref={parentDivRef}
                      className="inbox-mails-conatiner"
                      style={{
                        padding: "0 12px",
                        height: "100%",
                        overflowY: "auto",
                        width: "390px"
                      }}
                    >
                      {/* <div className=""> */}
                      {/* <div className="row mb-4"> */}
                      {/* <div className="col-xl-3 col-md-12">
                                <div className="pb-3 pb-xl-0">
                                  <form className="email-search">
                                    <div className="position-relative">
                                      <input
                                        type="text"
                                        className="form-control bg-light"
                                        placeholder="Search..."
                                      ></input>
                                      <span className="bx bx-search font-size-18"></span>
                                    </div>
                                  </form>
                                </div>
                              </div> */}
                      {/* <div className="col-xl-9 col-md-12">
                        <div className="pb-3 pb-xl-0">
                          <div
                            className="btn-toolbar float-end"
                            role="toolbar"
                          >
                            <div className="btn-group me-2 mb-2">
                              <button
                                type="button"
                                className="btn btn-primary waves-light waves-effect"
                              >
                                <i className="fa fa-inbox"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary waves-light waves-effect"
                              >
                                <i className="fa fa-exclamation-circle"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary waves-light waves-effect"
                              >
                                <i className="far fa-trash-alt"></i>
                              </button>
                            </div>
                            <div className="btn-group me-2 mb-2">
                              <Dropdown
                                isOpen={folderbtn}
                                toggle={() => setfolderbtn(!folderbtn)}
                              >
                                <DropdownToggle
                                  className="btn"
                                  color="primary"
                                  caret
                                >
                                  <i className="fa fa-folder me-1"></i>
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem>Updates</DropdownItem>
                                  <DropdownItem>Social</DropdownItem>
                                  <DropdownItem>
                                    Team Manage
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            <div className="btn-group me-2 mb-2">
                              <Dropdown
                                isOpen={tagbtn}
                                toggle={() => settagbtn(!tagbtn)}
                              >
                                <DropdownToggle
                                  className="btn"
                                  color="primary"
                                  caret
                                >
                                  <i className="fa fa-tag me-1"></i>
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem>Updates</DropdownItem>
                                  <DropdownItem>Social</DropdownItem>
                                  <DropdownItem>
                                    Team Manage
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>

                            <div className="btn-group me-2 mb-2">
                              <Dropdown
                                isOpen={menubtn}
                                toggle={() => setmenubtn(!menubtn)}
                              >
                                <DropdownToggle
                                  className="btn"
                                  color="primary"
                                  caret
                                >
                                  Plus
                                  <i className="mdi mdi-dots-vertical ms-1"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem>
                                    Mark as Unread
                                  </DropdownItem>
                                  <DropdownItem>
                                    Mark as Important
                                  </DropdownItem>
                                  <DropdownItem>
                                    Add to Tasks
                                  </DropdownItem>
                                  <DropdownItem>Add Star</DropdownItem>
                                  <DropdownItem>Mute</DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            <div
                              className="btn-group me-2 mb-2"
                              onClick={getClientData}
                            >
                              <Link
                                to=""
                                className="btn btn-success waves-effect waves-light w-100"
                              >
                                Actualiser
                              </Link>
                            </div>
                            <div
                              className="btn-group me-2 mb-2"
                              onClick={() => handleChangeColor('red')}
                            >
                              <Link
                                to=""
                                className="btn btn-danger waves-effect waves-light w-100"
                              >
                                Déconnexion
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      {/* </div> */}

                      {/*    <h6 className="text-muted text-uppercase mb-3">
                                Aujourd'hui
                              </h6>*/}
                      {/* start mail 1 */}
                      {/* <Row className="email-menu-bar">
                        <Col xl={1}>
                          <Link
                            to="/compose-email" >
                            <i className="mdi mdi-dock-left email-title-icon"></i>
                           </Link>
                        </Col>
                        <Col xl={3}>
                          {client_data ? (
                            <p className="column-title">
                              {client_data.company}
                            </p>
                          ) : (
                            <p className="column-title"></p>
                          )}
                        </Col>
                        <Col xl={9}>
                          {totalMails > 0 ? (
                            <Row className="d-flex justify-content-end">
                              <div className="col-6">
                                Pages
                                {currentPage === 1
                                  ? currentPage
                                  : currentPage * pageSize - pageSize}
                                -
                                {totalPage === currentPage
                                  ? totalMails
                                  : currentPage * pageSize}
                                sur {totalMails}
                              </div>
                              <div className="col-4">
                                <div className="btn-group">
                                  <button
                                    style={{
                                      color: "white",
                                      cursor: "pointer",
                                      padding: "3px 8px",
                                      backgroundColor: "#1b263b",
                                      borderRadius: "5px",
                                      border: "none",
                                    }}
                                    type="button"
                                    className="btn btn-sm waves-effect me-2"
                                    onClick={() =>
                                      handlePageChange(currentPage - 1)
                                    }
                                    disabled={currentPage === 1}
                                  >
                                    <i className="fa fa-chevron-left"></i>
                                  </button>
                                  <button
                                    style={{
                                      color: "white",
                                      cursor: "pointer",
                                      padding: "3px 8px",
                                      backgroundColor: "#1b263b",
                                      borderRadius: "5px",
                                      border: "none",
                                    }}
                                    type="button"
                                    className="btn btn-sm waves-effect"
                                    onClick={() =>
                                      handlePageChange(currentPage + 1)
                                    }
                                    disabled={totalPage == currentPage}
                                  >
                                    <i className="fa fa-chevron-right"></i>
                                  </button>
                                </div>
                              </div>
                            </Row>
                          ) : null}
                        </Col>

                        <Col xl={9}>
                          {totalMails > 0 ? <Row className="my-4">
                            <div className="col-7">
                              Affichage {((currentPage === 1 ? currentPage : (currentPage * pageSize) - pageSize))} - {totalPage === currentPage ? totalMails : currentPage * pageSize} sur {totalMails}
                            </div>
                            <div className="col-5">
                              <div className="btn-group float-end">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-success waves-effect"
                                  onClick={() => handlePageChange(currentPage - 1)}
                                  disabled={currentPage === 1}
                                >
                                  <i className="fa fa-chevron-left"></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-success waves-effect"
                                  onClick={() => handlePageChange(currentPage + 1)}
                                  disabled={totalPage == currentPage}
                                >
                                  <i className="fa fa-chevron-right"></i>
                                </button>
                              </div>
                            </div>
                          </Row>
                            : null}
                        </Col>
                      </Row> */}
                      {/* <InputGroup
                        className="mx-auto mb-3"
                        style={{
                          backgroundColor: "#F9FAFB",
                          borderRadius: "13.511px",
                          marginTop: "40px",
                        }}>
                        <InputGroupText
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            paddingRight: "0",
                          }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
                            <path
                              d="M23.4164 21.7504L19.1291 17.4632C20.0149 16.1281 20.5334 14.5296 20.5334 12.8111C20.5334 8.15485 16.7452 4.36667 12.089 4.36667C7.43271 4.36667 3.64453 8.15485 3.64453 12.8111C3.64453 17.4674 7.43271 21.2556 12.089 21.2556C13.8074 21.2556 15.406 20.7371 16.741 19.8512L21.0283 24.1385C21.6869 24.798 22.7577 24.798 23.4164 24.1385C24.0759 23.479 24.0759 22.4099 23.4164 21.7504ZM6.17786 12.8111C6.17786 9.55156 8.82942 6.9 12.089 6.9C15.3485 6.9 18.0001 9.55156 18.0001 12.8111C18.0001 16.0707 15.3485 18.7222 12.089 18.7222C8.82942 18.7222 6.17786 16.0707 6.17786 12.8111Z"
                              fill="#5D5FEF"
                            />
                          </svg>
                        </InputGroupText>
                        <Input
                          placeholder={props.t("Recherche") + "..."}
                          style={{
                            font: "normal 400 15.2px/normal Montserrat, sans-serif",
                            border: "none",
                            backgroundColor: "transparent",
                            color: "#737791",
                          }}
                          value={recherche}
                          onChange={(e) => setRecherche(e.target.value)}
                          onKeyPress={handleKeyPressForSearch}
                        />
                        <InputGroupText
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}>
                          {recherche.length > 0 && (
                            <button className="btn" onClick={() => clearSearch()}>
                              <span style={{ cursor: "pointer" }} className="detail-bar-menu-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M17.3276 17.8933C16.9957 18.2251 16.6488 18.3911 16.2867 18.3911C15.9096 18.376 15.5551 18.2025 15.2233 17.8706L11.5124 14.1597L7.86934 17.8028C7.55256 18.1195 7.22069 18.2855 6.87374 18.3006C6.5117 18.3006 6.17229 18.1422 5.8555 17.8254C5.53872 17.5086 5.38787 17.1767 5.40295 16.8298C5.40295 16.4677 5.56135 16.1283 5.87813 15.8116L9.52114 12.1685L5.92339 8.57078C5.59152 8.23891 5.42558 7.89195 5.42558 7.52992C5.42558 7.16788 5.59906 6.81338 5.94601 6.46643C6.27788 6.13456 6.61729 5.97617 6.96425 5.99125C7.32628 5.99125 7.67324 6.15719 8.00511 6.48906L11.6029 10.0868L15.2459 6.4438C15.5777 6.11193 15.9172 5.95354 16.2641 5.96862C16.6111 5.95354 16.9429 6.10439 17.2597 6.42117C17.5765 6.73796 17.7349 7.07737 17.7349 7.43941C17.7349 7.77127 17.569 8.10314 17.2371 8.43501L13.5941 12.078L17.305 15.7889C17.6368 16.1208 17.8103 16.4753 17.8254 16.8524C17.8405 17.1994 17.6746 17.5463 17.3276 17.8933Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                            </button>
                          )}
                          <button className="btn" style={{ padding: "0", border: "none" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                              <rect x="5" width="14" height="3" rx="1.5" fill="#5D5FEF" />
                              <circle cx="1.5" cy="1.5" r="1.5" fill="#5D5FEF" />
                              <rect x="9" y="14" width="10" height="3" rx="1.5" fill="#5D5FEF" />
                              <circle cx="5.5" cy="15.5" r="1.5" fill="#5D5FEF" />
                              <rect y="7" width="14" height="3" rx="1.5" fill="#5D5FEF" />
                              <circle cx="17.5" cy="8.5" r="1.5" fill="#5D5FEF" />
                            </svg>
                          </button>
                        </InputGroupText>
                      </InputGroup> */}

                      <Row>
                        {/* <div className="col-xl-9 col-md-12">
                        <div className="pb-3 pb-xl-0">
                          <div
                            className="btn-toolbar float-end"
                            role="toolbar"
                          >
                            <div className="btn-group me-2 mb-2">
                              <button
                                type="button"
                                className="btn btn-primary waves-light waves-effect"
                              >
                                <i className="fa fa-inbox"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary waves-light waves-effect"
                              >
                                <i className="fa fa-exclamation-circle"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary waves-light waves-effect"
                              >
                                <i className="far fa-trash-alt"></i>
                              </button>
                            </div>
                            <div className="btn-group me-2 mb-2">
                              <Dropdown
                                isOpen={folderbtn}
                                toggle={() => setfolderbtn(!folderbtn)}
                              >
                                <DropdownToggle
                                  className="btn"
                                  color="primary"
                                  caret
                                >
                                  <i className="fa fa-folder me-1"></i>
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem>Updates</DropdownItem>
                                  <DropdownItem>Social</DropdownItem>
                                  <DropdownItem>
                                    Team Manage
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            <div className="btn-group me-2 mb-2">
                              <Dropdown
                                isOpen={tagbtn}
                                toggle={() => settagbtn(!tagbtn)}
                              >
                                <DropdownToggle
                                  className="btn"
                                  color="primary"
                                  caret
                                >
                                  <i className="fa fa-tag me-1"></i>
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem>Updates</DropdownItem>
                                  <DropdownItem>Social</DropdownItem>
                                  <DropdownItem>
                                    Team Manage
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>

                            <div className="btn-group me-2 mb-2">
                              <Dropdown
                                isOpen={menubtn}
                                toggle={() => setmenubtn(!menubtn)}
                              >
                                <DropdownToggle
                                  className="btn"
                                  color="primary"
                                  caret
                                >
                                  Plus
                                  <i className="mdi mdi-dots-vertical ms-1"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem>
                                    Mark as Unread
                                  </DropdownItem>
                                  <DropdownItem>
                                    Mark as Important
                                  </DropdownItem>
                                  <DropdownItem>
                                    Add to Tasks
                                  </DropdownItem>
                                  <DropdownItem>Add Star</DropdownItem>
                                  <DropdownItem>Mute</DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            <div
                              className="btn-group me-2 mb-2"
                              onClick={getClientData}
                            >
                              <Link
                                to=""
                                className="btn btn-success waves-effect waves-light w-100"
                              >
                                Actualiser
                              </Link>
                            </div>
                            <div
                              className="btn-group me-2 mb-2"
                              onClick={() => handleChangeColor('red')}
                            >
                              <Link
                                to=""
                                className="btn btn-danger waves-effect waves-light w-100"
                              >
                                Déconnexion
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div> */}
                        <div className="d-flex justify-content-between mt-4 mb-3">
                          {/* <div>
                            <Dropdown
                              isOpen={btnprimary1}
                              toggle={() => setBtnprimary1(!btnprimary1)}
                            >
                              <DropdownToggle tag="button"
                                className={`btn email-menu-dropdown ${btnprimary1 ? "email-menu-dropdown-active" : ""}`}
                              >
                                Paramètres
                                <i className="mdi mdi-chevron-down" />
                               </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem><Link
                                  to=""
                                  className=""
                                >
                                  Actualiser
                                </Link></DropdownItem>
                                <DropdownItem>Updates</DropdownItem>
                                <DropdownItem>Social</DropdownItem>
                                <DropdownItem>
                                  Team Manage
                                </DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div> */}

                          <h3
                            id="email-list-title"
                            style={{ fontSize: "14px" }}
                            className="font-primary"
                          >
                            {props.t(
                              getBoxLocalName(getBoxFromUrl() || "Inbox")
                            )}
                          </h3>

                          <div className="d-flex align-items-center gap-2">
                            {/* <Dropdown
                                  isOpen={btnprimary2}
                                  toggle={() => setBtnprimary2(!btnprimary2)}
                                  style={{
                                    display: "flex",
                                  }}
                                >
                                  <DropdownToggle
                                    tag="button"
                                    className={`btn email-menu-dropdown ${btnprimary2
                                      ? "email-menu-dropdown-active"
                                      : ""
                                      }`}
                                    style={{
                                      border: "none",
                                      padding: "0",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                    >
                                      <path
                                        style={{
                                          fillRule: "evenodd",
                                          clipRule: "evenodd",
                                        }}
                                        d="M13.6431 0.22995L13.8549 0.172949C14.7141 -0.0286044 15.605 -0.0542117 16.4737 0.0972837L16.8441 0.172946C18.0875 0.464606 19.0816 1.39292 19.4691 2.64311L19.5261 2.855C19.7276 3.71419 19.7532 4.60494 19.5964 5.50205L19.5261 5.84406C19.2345 7.08745 18.3061 8.08157 17.0559 8.46907L16.8441 8.52607C15.9849 8.72762 15.094 8.75323 14.1969 8.59636L13.8549 8.52607C12.6115 8.23441 11.6174 7.30611 11.2299 6.05591L11.1729 5.84402C10.9424 4.86102 10.9424 3.838 11.1729 2.85496C11.4646 1.61157 12.3929 0.61745 13.6431 0.22995ZM16.4155 2.12628L16.1302 2.06755C15.5269 1.96236 14.9083 1.98014 14.3459 2.11143L14.2022 2.14989C13.6622 2.31755 13.2496 2.75931 13.1201 3.31162C12.96 3.99428 12.96 4.70474 13.1114 5.35315L13.1499 5.49686C13.3175 6.03683 13.7593 6.44935 14.2835 6.57274L14.5689 6.63147C15.1721 6.73666 15.7907 6.71888 16.3531 6.58759L16.4968 6.54913C17.0368 6.38147 17.4494 5.93971 17.5727 5.41561L17.6314 5.13021C17.7366 4.5269 17.7188 3.9083 17.5876 3.34587L17.5491 3.20216C17.3815 2.66219 16.9397 2.24967 16.4155 2.12628ZM2.85493 0.172947L2.64308 0.22995C1.39289 0.617444 0.464594 1.61155 0.172938 2.85494C-0.0576455 3.83798 -0.0576455 4.86104 0.172937 5.84407L0.229942 6.05593C0.617437 7.30612 1.61155 8.23442 2.85494 8.52608L3.19691 8.59636C4.09406 8.75323 4.98485 8.72762 5.84408 8.52607L6.05592 8.46907C7.30611 8.08158 8.23441 7.08747 8.52607 5.84408L8.59636 5.50211C8.75322 4.60495 8.72762 3.71416 8.52607 2.85494L8.46906 2.64309C8.08157 1.3929 7.08746 0.464602 5.84407 0.172945L5.47372 0.0972833C4.60495 -0.054211 3.71415 -0.0286046 2.85493 0.172947ZM5.13015 2.06755L5.41554 2.12628C5.93971 2.24966 6.38147 2.66218 6.54912 3.20218L6.58758 3.34589C6.71887 3.90833 6.73666 4.52689 6.63146 5.13016L6.57273 5.41555C6.44935 5.93972 6.03684 6.38147 5.49684 6.54913L5.35313 6.58759C4.79069 6.71888 4.17212 6.73666 3.56886 6.63147L3.28347 6.57274C2.7593 6.44936 2.31754 6.03684 2.14988 5.49684L2.11142 5.35314C1.95997 4.70472 1.95997 3.9943 2.12009 3.31167C2.24966 2.7593 2.66217 2.31755 3.20217 2.14989L3.34588 2.11143C3.90832 1.98014 4.52688 1.96236 5.13015 2.06755ZM2.85499 11.1729L2.6431 11.2299C1.39291 11.6174 0.464598 12.6115 0.172938 13.8549C-0.0576461 14.8379 -0.0576461 15.8611 0.172938 16.8441L0.229943 17.0559C0.617442 18.3061 1.61156 19.2345 2.85495 19.5261L3.19697 19.5964C4.09407 19.7532 4.98482 19.7276 5.84401 19.5261L6.05591 19.4691C7.3061 19.0816 8.23441 18.0875 8.52607 16.8441L8.59636 16.5021C8.75322 15.605 8.72762 14.7141 8.52606 13.8549L8.46906 13.6431C8.08156 12.3929 7.08744 11.4646 5.84405 11.1729L5.47367 11.0973C4.60493 10.9458 3.71418 10.9714 2.85499 11.1729ZM5.1302 13.0676L5.4156 13.1263C5.9397 13.2496 6.38146 13.6622 6.54912 14.2022L6.58758 14.3459C6.71887 14.9083 6.73666 15.5269 6.63146 16.1302L6.57273 16.4155C6.44935 16.9397 6.03682 17.3815 5.49685 17.5491L5.35314 17.5876C4.79072 17.7188 4.17211 17.7366 3.5688 17.6315L3.28341 17.5727C2.75931 17.4494 2.31754 17.0369 2.14988 16.4968L2.11142 16.3531C1.95997 15.7047 1.95997 14.9943 2.12009 14.3117C2.24966 13.7593 2.66218 13.3175 3.20216 13.1499L3.34586 13.1114C3.90829 12.9802 4.52689 12.9624 5.1302 13.0676ZM13.855 11.1729L13.6431 11.2299C12.3929 11.6174 11.4646 12.6116 11.1729 13.855C10.9424 14.838 10.9424 15.8611 11.1729 16.844L11.2299 17.0559C11.6174 18.3061 12.6116 19.2345 13.855 19.5261L14.197 19.5964C15.0941 19.7532 15.9849 19.7276 16.844 19.5261L17.0559 19.4691C18.3061 19.0816 19.2344 18.0875 19.5261 16.8441L19.5964 16.5021C19.7532 15.605 19.7276 14.7142 19.5261 13.855L19.4691 13.6431C19.0816 12.3929 18.0874 11.4646 16.8441 11.1729L16.4737 11.0973C15.6049 10.9458 14.7142 10.9714 13.855 11.1729ZM16.1302 13.0676L16.4156 13.1263C16.9397 13.2496 17.3815 13.6622 17.5491 14.2022L17.5876 14.3459C17.7188 14.9083 17.7366 15.5269 17.6314 16.1302L17.5727 16.4156C17.4494 16.9397 17.0368 17.3815 16.4968 17.5491L16.3531 17.5876C15.7907 17.7188 15.1721 17.7366 14.5688 17.6315L14.2834 17.5727C13.7593 17.4494 13.3175 17.0368 13.1499 16.4969L13.1114 16.3531C12.96 15.7048 12.96 14.9943 13.1201 14.3116C13.2496 13.7593 13.6622 13.3175 14.2022 13.1499L14.3459 13.1114C14.9083 12.9802 15.5269 12.9624 16.1302 13.0676Z"
                                        fill="#563BFF"
                                      />
                                    </svg>
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem>Mark as Unread</DropdownItem>
                                    <DropdownItem>
                                      Mark as Important
                                    </DropdownItem>
                                    <DropdownItem>Add to Tasks</DropdownItem>
                                    <DropdownItem>Add Star</DropdownItem>
                                    <DropdownItem>Mute</DropdownItem>
                                  </DropdownMenu>
                                </Dropdown> */}
                            <div
                              className={`btn-group d-flex align-items-center`}
                              onClick={() => {
                                // onLoading(true);

                                // fetchMails(localStorage.getItem('companyId'), the_folder);
                                if (!loading) {
                                  dispatch(
                                    fetchMailsRedux(
                                      localStorage.getItem("companyId"),
                                      getBoxFromUrl()
                                    )
                                  );
                                }
                              }}
                            >
                              <Link
                                to=""
                                className="fetch-mail-button font-primary"
                                style={{
                                  margin: "auto",
                                  color: "#091B3D",
                                  cursor: "pointer",
                                  backgroundColor: "white",
                                  border: "none"
                                }}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 4.44325C9.89898 4.16831 10.899 4 12 4C16.9706 4 21 8.02944 21 13C21 17.9706 16.9706 22 12 22C10.1599 22 8.44877 21.4478 7.02331 20.5M9 4.44325L12 1M9 4.44325L12.5 7M4.51555 8C3.55827 9.4301 3 11.1499 3 13C3 14.8501 3.55827 16.5699 4.51555 18"
                                    stroke="#2F384C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </Link>
                            </div>

                            {multiSelectedMessage.length > 0 && (
                              <Dropdown
                                isOpen={btnprimary2}
                                toggle={() => setBtnprimary2(!btnprimary2)}
                              >
                                <DropdownToggle
                                  tag="button"
                                  style={{
                                    padding: "0",
                                    backgroundColor: "transparent",
                                    border: "none",
                                    borderRadius: "5px"
                                  }}
                                >
                                  <svg
                                    width="21"
                                    height="21"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M13 21.0001H21M9.99999 14.9996H6.99999M21 14.9996H14M9 9.00006H21M13 2.99982H3M21 2.99982H17"
                                      stroke="#FF7049"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    className="font-primary simple-text"
                                    onClick={() => {
                                      setType("copy");
                                      togModalDossierVisibility();
                                    }}
                                  >
                                    {props.t("Copier vers")}
                                  </DropdownItem>
                                  <DropdownItem
                                    className="font-primary simple-text"
                                    onClick={() => {
                                      setType("move");
                                      togModalDossierVisibility();
                                    }}
                                  >
                                    {props.t("Déplacer vers")}
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            )}
                            {multiSelectedMessage.length > 0 && (
                              <button
                                style={{
                                  cursor: "pointer",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  padding: "0"
                                }}
                                onClick={() => {
                                  setMessageToDelete(multiSelectedMessage);
                                  if (
                                    selectedMessageNext &&
                                    multiSelectedMessage.length === 1
                                  ) {
                                    goToMessageReadView(selectedMessageNext);
                                    setSelectedMessageNext(
                                      email_conversations[
                                        selectedMessageNextIndex + 1
                                      ]
                                    );
                                    setSelectedMessageNextIndex(
                                      selectedMessageNextIndex + 1
                                    );
                                  } else {
                                    closeMessageView();
                                  }
                                  setStartCountdown(true);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 9 10"
                                  fill="none"
                                >
                                  <path
                                    d="M4.05383 9.07683C3.6197 9.07683 3.18557 9.07942 2.75144 9.07683C2.52787 9.07423 2.30431 9.05863 2.08594 9.00664C1.58683 8.88706 1.29567 8.57771 1.20989 8.07079C1.16049 7.78483 1.1527 7.49628 1.1345 7.21033C1.09551 6.64102 1.05911 6.07171 1.02272 5.505C1.00192 5.19046 0.981124 4.87851 0.962927 4.56396C0.93953 4.19742 0.918734 3.83347 0.897937 3.46693C0.884939 3.26417 1.00452 3.10819 1.18389 3.09779C1.37626 3.0848 1.52184 3.21218 1.53483 3.41754C1.56863 3.91146 1.59982 4.40538 1.63102 4.9019C1.66741 5.44521 1.70641 5.98853 1.7402 6.52924C1.7636 6.87238 1.78179 7.21553 1.80519 7.55607C1.81299 7.67825 1.82339 7.80043 1.84158 7.92261C1.88838 8.23716 2.03395 8.37234 2.3537 8.40873C2.48368 8.42173 2.61106 8.42953 2.74104 8.42953C3.6171 8.42953 4.49315 8.42953 5.36661 8.42953C5.49919 8.42953 5.63177 8.42173 5.76435 8.40873C6.10229 8.37234 6.25827 8.20597 6.28686 7.84462C6.32326 7.32731 6.35445 6.80999 6.38825 6.29268C6.43244 5.64278 6.47663 4.99289 6.51823 4.34299C6.53902 4.02844 6.55722 3.71649 6.58062 3.40194C6.59361 3.20958 6.74179 3.0822 6.93416 3.09519C7.10833 3.10559 7.23051 3.25637 7.22011 3.44614C7.17852 4.12203 7.13693 4.79792 7.09533 5.47381C7.05634 6.07431 7.01995 6.67741 6.97835 7.27792C6.96016 7.53527 6.95236 7.79523 6.90816 8.05259C6.81198 8.6037 6.51303 8.91305 5.96192 9.02223C5.76435 9.06123 5.56418 9.07683 5.36401 9.07683C4.92469 9.07942 4.49056 9.07683 4.05383 9.07683Z"
                                    fill="#F10944"
                                  />
                                  <path
                                    d="M4.05885 0.121277C4.3526 0.129076 4.64895 0.10308 4.94271 0.155071C5.36644 0.230459 5.6108 0.464421 5.69658 0.888153C5.74078 1.10132 5.77717 1.31448 5.81097 1.53025C5.82136 1.59264 5.84736 1.62123 5.90975 1.62643C6.14631 1.64203 6.38027 1.65763 6.61684 1.67582C7.01457 1.70702 7.40971 1.74081 7.80744 1.77721C8.00241 1.79541 8.12719 1.94878 8.11159 2.13595C8.096 2.31012 7.94002 2.4375 7.74765 2.4219C7.4487 2.39851 7.14715 2.36731 6.8482 2.34132C6.53625 2.31532 6.2217 2.28933 5.90975 2.27113C5.05189 2.22434 4.19403 2.19314 3.33357 2.21394C2.68887 2.22954 2.04418 2.25553 1.40208 2.32312C1.06414 2.35951 0.72619 2.39071 0.385645 2.4219C0.177679 2.4427 0.0139055 2.31532 0.000907593 2.13335C-0.0120903 1.92798 0.115289 1.79281 0.333654 1.77201C0.78858 1.73042 1.24351 1.68362 1.69843 1.64463C1.85701 1.63163 2.01558 1.62383 2.17416 1.61603C2.25214 1.61344 2.29634 1.59004 2.30933 1.49905C2.33793 1.29369 2.37432 1.08832 2.41592 0.885553C2.5173 0.40983 2.81625 0.168069 3.30237 0.134275C3.55453 0.118677 3.80669 0.129076 4.05885 0.121277ZM4.83612 1.58484C4.90111 1.58484 4.9947 1.57964 5.08828 1.58744C5.15327 1.59264 5.16887 1.56664 5.15847 1.50945C5.12728 1.33788 5.09868 1.16631 5.06229 0.994735C5.03369 0.859557 4.9713 0.812765 4.83612 0.791968C4.60736 0.758174 4.376 0.776371 4.14724 0.776371C3.86388 0.776371 3.57793 0.755574 3.29457 0.789369C3.1438 0.807566 3.08401 0.859557 3.05281 1.01033C3.01902 1.17151 2.99562 1.33528 2.96183 1.49645C2.94883 1.55884 2.96963 1.58224 3.02942 1.57704C3.1438 1.57184 3.25558 1.56664 3.36996 1.56404C3.84828 1.55884 4.32661 1.55884 4.83612 1.58484Z"
                                    fill="#F10944"
                                  />
                                  <path
                                    d="M4.05648 5.13067C3.72633 5.13067 3.39619 5.13067 3.06604 5.13067C2.85028 5.13067 2.7021 5.00069 2.6969 4.81352C2.6917 4.62895 2.85028 4.48337 3.06604 4.48337C3.72633 4.48077 4.38923 4.48337 5.04952 4.48337C5.22369 4.48337 5.34327 4.56136 5.39526 4.70174C5.44466 4.83171 5.41086 4.9435 5.31468 5.03968C5.24449 5.10987 5.1561 5.13327 5.05732 5.13327C4.72197 5.13067 4.38923 5.13067 4.05648 5.13067Z"
                                    fill="#F10944"
                                  />
                                  <path
                                    d="M4.04608 6.7866C3.82251 6.7866 3.59895 6.7866 3.37538 6.7866C3.18562 6.7866 3.04004 6.64622 3.04004 6.46945C3.04004 6.29268 3.18562 6.1523 3.37538 6.1523C3.83031 6.1523 4.28264 6.1523 4.73756 6.1523C4.92473 6.1523 5.07291 6.29787 5.07031 6.47465C5.06771 6.64882 4.92473 6.7866 4.74016 6.78919C4.5088 6.7866 4.27744 6.7866 4.04608 6.7866Z"
                                    fill="#F10944"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                        </div>
                      </Row>
                      {/* {loading && (
                          <div
                            style={{
                              backgroundColor: '#ffff0059',
                              paddingLeft: '5px',
                              color: 'grey',
                              textAlign: 'center',
                              borderRadius: '5px',
                            }}>
                            Chargement en cours...{' '}
                            <span>
                              <Spinner style={{ height: '15px', width: '15px' }} animation="border" />
                            </span>
                          </div>
                        )} */}

                      {/* <div className="d-flex justify-content-between mb-3">
                            <div className="d-flex">
                              <h4
                                className={`email-list-category ${true && "email-list-category-active"
                                  }`}
                              >
                                Tout
                              </h4>
                              <h4
                                className={`email-list-category ${false && "email-list-category-active"
                                  }`}
                              >
                                Non lus
                              </h4>
                              <h4
                                className={`email-list-category ${false && "email-list-category-active"
                                  }`}
                              >
                                Marqués
                              </h4>
                            </div>
                            <div>
                              <button className="btn">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19"
                                  height="18"
                                  viewBox="0 0 19 18"
                                  fill="none"
                                >
                                  <rect
                                    x="5"
                                    y="0.121307"
                                    width="14"
                                    height="3"
                                    rx="1.5"
                                    fill="#B1BDBC"
                                  />
                                  <circle
                                    cx="1.5"
                                    cy="1.62131"
                                    r="1.5"
                                    fill="#B1BDBC"
                                  />
                                  <rect
                                    x="9"
                                    y="14.1213"
                                    width="10"
                                    height="3"
                                    rx="1.5"
                                    fill="#B1BDBC"
                                  />
                                  <circle
                                    cx="5.5"
                                    cy="15.6213"
                                    r="1.5"
                                    fill="#B1BDBC"
                                  />
                                  <rect
                                    y="7.12131"
                                    width="14"
                                    height="3"
                                    rx="1.5"
                                    fill="#B1BDBC"
                                  />
                                  <circle
                                    cx="17.5"
                                    cy="8.62131"
                                    r="1.5"
                                    fill="#B1BDBC"
                                  />
                                </svg>
                                <span className="visually-hidden">action</span>
                              </button>
                            </div>
                          </div> */}

                      <ul className="p-0" style={{ minHeight: "30vh" }}>
                        {(loading && !email_conversations[getBoxFromUrl()]) ||
                        (loading &&
                          email_conversations[getBoxFromUrl()].length === 0) ||
                        (!loading && getBoxFromUrl() !== currentBox) ? (
                          <div className="mb-4" style={{ textAlign: "center" }}>
                            <div style={{ textAlign: "center" }}>
                              {props.t("Chargement")}...
                            </div>
                          </div>
                        ) : (error &&
                            !loading) /*|| !messages[getBoxFromUrl()] */ ||
                          !getBoxFromUrl() ? (
                          <div
                            className="font-primary"
                            style={{
                              textAlign: "center",
                              paddingTop: "5em",
                              paddingLeft: "1em",
                              paddingRight: "1em"
                            }}
                          >
                            {error
                              ? error.includes("Authentication failed") ||
                                error.includes("AUTHENTICATIONFAILED")
                                ? props.t(
                                    "Problème d'authentification (Vérifiez votre configuration E-mail)"
                                  )
                                : props.t(error)
                              : props.t("Erreur inattendue")}
                          </div>
                        ) : !loading &&
                          email_conversations[getBoxFromUrl()] &&
                          email_conversations[getBoxFromUrl()].length === 0 &&
                          (!state ||
                            !state.id ||
                            getBoxFromUrl() !== "INBOX") &&
                          !isSearch ? (
                          <div
                            className="simple-text font-primary"
                            style={{
                              textAlign: "center",
                              padding: "5em",
                              fontSize: "14px"
                            }}
                          >
                            {props.t("Vide")} {error}
                          </div>
                        ) : !loading &&
                          !email_conversations[getBoxFromUrl()] ? (
                          <div
                            className="simple-text font-primary"
                            style={{
                              textAlign: "center",
                              padding: "5em",
                              fontSize: "14px"
                            }}
                          >
                            ...
                          </div>
                        ) : (
                          <div>
                            <ul className="p-0" style={{ minHeight: "30vh" }}>
                              {((state &&
                                state.id &&
                                getBoxFromUrl() === "INBOX") ||
                                (isSearch && !loading)) && (
                                <Row
                                  className="py-2 d-flex justify-content-center simple-text"
                                  style={{
                                    backgroundColor: "#ffde7e",
                                    color: "black",
                                    cursor: !loading ? "pointer" : "default",
                                    userSelect: "none"
                                  }}
                                  onClick={() => {
                                    if (!loading) {
                                      if (
                                        state &&
                                        state.id &&
                                        getBoxFromUrl() === "INBOX"
                                      ) {
                                        navigate("/mailbox", {
                                          replace: true,
                                          state: { box: "INBOX" }
                                        });
                                      }
                                      setRecherche("");
                                      closeMessageView();
                                      dispatch(
                                        fetchMailsRedux(
                                          localStorage.getItem("companyId"),
                                          getBoxFromUrl(),
                                          1,
                                          pageSize,
                                          []
                                        )
                                      );
                                    }
                                  }}
                                >
                                  {loading ? (
                                    <div className="d-flex justify-content-center align-items-center">
                                      {props.t("Filtrage")}
                                      <span
                                        className="spinner-border ms-1 spinner-border-sm font-primary"
                                        role="status"
                                        aria-hidden="true"
                                        style={{
                                          height: "14px",
                                          width: "14px"
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div className="d-flex justify-content-center align-items-center simple-text">
                                      <span>
                                        {props.t("Retirer le filtrage")}
                                      </span>
                                      <CrossOutlined
                                        height={20}
                                        style={{ marginTop: "2px" }}
                                      />
                                    </div>
                                  )}
                                </Row>
                              )}
                              {/* {loading && !state && parentDivRef.current && parentDivRef.current.scrollHeight > parentDivRef.current.clientHeight && (
                                // <Row
                                //   className="py-2 d-flex justify-content-center simple-text"
                                //   style={{
                                //     backgroundColor: "#ffde7e",
                                //     color: "black",
                                //     userSelect: "none",
                                //   }}>
                                //   {props.t("Chargement")}...
                                // </Row>
                                <div></div>
                              )} */}
                              {mailActionLoading && (
                                <Row
                                  className="py-2 d-flex justify-content-center simple-text"
                                  style={{
                                    backgroundColor: "#ffde7e",
                                    color: "black",
                                    userSelect: "none"
                                  }}
                                >
                                  <div className="d-flex justify-content-center align-items-center">
                                    {props.t(
                                      getTextForAction(mailActionLoading)
                                    ) + "..."}
                                    <span
                                      className="spinner-border ms-1 spinner-border-sm font-primary"
                                      role="status"
                                      aria-hidden="true"
                                      style={{ height: "14px", width: "14px" }}
                                    />
                                  </div>
                                </Row>
                              )}
                              {email_conversations &&
                              email_conversations[getBoxFromUrl()].length >
                                0 ? (
                                email_conversations[getBoxFromUrl()].map(
                                  (message, index) =>
                                    checkAuthorizations(message) && (
                                      <ConversationComponent
                                        key={index}
                                        index={index}
                                        messages={email_conversations}
                                        the_folder={getBoxFromUrl()}
                                        message={message}
                                        messageToDelete={messageToDelete}
                                        setMessageToDelete={setMessageToDelete}
                                        selectedMessage={selectedMessage}
                                        multiSelectedMessage={
                                          multiSelectedMessage
                                        }
                                        setMultiSelectedMessage={
                                          setMultiSelectedMessage
                                        }
                                        goToMessageReadView={
                                          goToMessageReadView
                                        }
                                        setSelectedMessageNext={
                                          setSelectedMessageNext
                                        }
                                        setSelectedMessageNextIndex={
                                          setSelectedMessageNextIndex
                                        }
                                        copyMail={copyMail}
                                        setType={setType}
                                        togModalDossierVisibility={
                                          togModalDossierVisibility
                                        }
                                        setShowReadEmailView={
                                          setShowReadEmailView
                                        }
                                        setStartCountdown={setStartCountdown}
                                        messagesTagsList={messagesTagsList}
                                        setMessagesTagsList={
                                          setMessagesTagsList
                                        }
                                        messagesStateList={messagesStateList}
                                        setMessagesStateList={
                                          setMessagesStateList
                                        }
                                        stringToColour={stringToColour}
                                        formaterDate={formaterDate}
                                        messageInfos={messageInfos}
                                        setMessageInfos={setMessageInfos}
                                        alertList={alertList}
                                        setAlertList={setAlertList}
                                        fetchMessageOrders={fetchMessageOrders}
                                      />
                                      // <Row
                                      //   key={index}
                                      //   className="mb-2"
                                      //   style={{
                                      //     display: messageToDelete && messageToDelete.includes(message.messageId) ? "none" : "flex",
                                      //   }}>
                                      //   <div
                                      //     style={{
                                      //       padding: "0",
                                      //     }}
                                      //     className="">
                                      //     <div
                                      //       key={index}
                                      //       className={`email-message font-primary  ${
                                      //         (selectedMessage && selectedMessage.messageId === message.messageId) ||
                                      //         // && multiSelectedMessage.length === 0
                                      //         multiSelectedMessage.includes(message.messageId)
                                      //           ? "email-message-background"
                                      //           : ""
                                      //       }`}>
                                      //       <div className="d-flex position-relative">
                                      //         {/* <div className="checkbox-container">
                                      //         <input
                                      //           type="checkbox"
                                      //           className="form-check-input"
                                      //         />
                                      //       </div> */}

                                      //         <Badge
                                      //           className={`avatarBadge rounded-circle align-middle me-2 font-primary ${
                                      //             multiSelectedMessage.includes(message.messageId) ||
                                      //             (selectedMessage &&
                                      //               selectedMessage.messageId === message.messageId &&
                                      //               multiSelectedMessage.length === 0)
                                      //               ? "avatarBadge_selected"
                                      //               : "avatarBadge_regular"
                                      //           }`}
                                      //           style={{
                                      //             display: "flex",
                                      //             alignItems: "center",
                                      //             justifyContent: "center",
                                      //             flexShrink: "0",
                                      //             height: "30px !important",
                                      //             width: "30px !important",
                                      //             fontSize: " 14px",
                                      //             padding: "6px",
                                      //             cursor: "pointer",
                                      //           }}
                                      //           onClick={() => {
                                      //             setMultiSelectedMessage((prev) => {
                                      //               let updatedMultiSelectedMessage = [...prev];
                                      //               if (multiSelectedMessage.includes(message.messageId)) {
                                      //                 updatedMultiSelectedMessage = updatedMultiSelectedMessage.filter(
                                      //                   (messageId) => messageId !== message.messageId,
                                      //                 );
                                      //               } else {
                                      //                 updatedMultiSelectedMessage.push(message.messageId);
                                      //               }
                                      //               return updatedMultiSelectedMessage;
                                      //             });
                                      //           }}>
                                      //           {multiSelectedMessage.includes(message.messageId) ? (
                                      //             <CheckGestalt height="20px" width="20px" />
                                      //           ) : (
                                      //             (message.from.value[0].address ?? message.from.value[0].name)
                                      //               .split(" ")
                                      //               .map((part) => part.charAt(0).toUpperCase())
                                      //               .join("")
                                      //               .slice(0, 2)
                                      //           )}
                                      //         </Badge>

                                      //         <div
                                      //           style={{
                                      //             cursor: "pointer",
                                      //             padding: "0",
                                      //           }}
                                      //           onClick={() => {
                                      //             goToMessageReadView(message);
                                      //             setSelectedMessageNext(messages[the_folder][index + 1]);
                                      //             setSelectedMessageNextIndex(index + 1);
                                      //             console.log({ selectedMessage: message, selectedMessageNext: messages[the_folder][index + 1] });
                                      //           }}>
                                      //           <div className="email-message-text font-primary"> {message.from.value[0].name} </div>
                                      //           <div className="email-message-subject font-primary">{message.subject}</div>
                                      //           <div className="teaser font-primary">{message.body.text}</div>
                                      //           <div className="email-message-actions font-primary">
                                      //             {selectedMessage &&
                                      //             selectedMessage.messageId === message.messageId &&
                                      //             multiSelectedMessage.length === 0 ? (
                                      //               <>
                                      //                 {the_folder !== "Starred" && (
                                      //                   <button
                                      //                     className="message-action-starred font-primary"
                                      //                     style={{
                                      //                       cursor: "pointer",
                                      //                     }}
                                      //                     onClick={() => {
                                      //                       copyMail(selectedMessage.messageId, the_folder, "Starred");
                                      //                     }}>
                                      //                     <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                                      //                       <path
                                      //                         d="M1.41788 7.87758C1.43318 7.64511 1.48418 7.41774 1.52244 7.19038C1.60405 6.69478 1.69076 6.19917 1.77747 5.70357C1.79277 5.62182 1.76472 5.56562 1.70861 5.50942C1.2113 5.02403 0.716545 4.53865 0.221789 4.05071C-0.0587433 3.77225 -0.0740451 3.35584 0.180984 3.05695C0.311049 2.90367 0.484469 2.83469 0.680841 2.80659C1.35412 2.70951 2.0274 2.61244 2.70067 2.51792C2.77718 2.5077 2.81799 2.46682 2.84859 2.40296C3.15207 1.78217 3.46066 1.16395 3.76414 0.543167C3.85085 0.366896 3.98347 0.239163 4.16709 0.170187C4.52158 0.0347907 4.90157 0.18807 5.07499 0.540612C5.35043 1.09242 5.63096 1.64422 5.89109 2.20625C5.99055 2.42084 6.10531 2.53069 6.35524 2.55624C6.95201 2.6201 7.54368 2.72484 8.13789 2.80659C8.51279 2.86024 8.75506 3.05695 8.82392 3.3865C8.88003 3.65729 8.80097 3.88977 8.6046 4.08136C8.12004 4.55653 7.63549 5.02914 7.14838 5.50175C7.07442 5.57328 7.05657 5.64226 7.07442 5.73934C7.19429 6.41376 7.3116 7.08819 7.42126 7.76262C7.46717 8.04874 7.37791 8.29654 7.14073 8.47026C6.90355 8.64653 6.63832 8.66952 6.37564 8.53413C5.77377 8.22246 5.17446 7.90568 4.57769 7.58635C4.46547 7.52504 4.37876 7.53015 4.2691 7.5889C3.67488 7.90824 3.07812 8.22246 2.4788 8.53157C2.08605 8.73339 1.63975 8.56478 1.46888 8.1637C1.43063 8.06663 1.41533 7.97466 1.41788 7.87758ZM6.79899 7.87247C6.79644 7.86481 6.79389 7.85203 6.79134 7.83926C6.68168 7.20571 6.58732 6.5696 6.4598 5.9386C6.38074 5.55029 6.46745 5.24884 6.76329 4.97805C7.22744 4.55142 7.66864 4.1018 8.12004 3.65985C8.16085 3.61897 8.2246 3.58321 8.2042 3.51168C8.18125 3.42993 8.10474 3.44015 8.04608 3.42993C7.38301 3.3303 6.71993 3.23322 6.05686 3.1387C5.77122 3.09782 5.56975 2.95732 5.44224 2.6993C5.14895 2.09895 4.85057 1.49861 4.55473 0.900819C4.52413 0.839507 4.50883 0.755203 4.42212 0.755203C4.33541 0.757758 4.32011 0.842062 4.29205 0.903373C3.99622 1.50372 3.69784 2.10151 3.40455 2.70185C3.28724 2.93943 3.10362 3.08505 2.84349 3.12848C2.65987 3.15913 2.4737 3.18213 2.28752 3.21023C1.77747 3.28431 1.26996 3.36095 0.7599 3.43504C0.711445 3.4427 0.66554 3.45036 0.645137 3.50401C0.624735 3.56021 0.662989 3.59342 0.696143 3.62664C0.84661 3.77481 0.994527 3.92042 1.14499 4.06859C1.49693 4.41347 1.85398 4.75579 2.20337 5.10323C2.37168 5.26928 2.44819 5.47621 2.41249 5.71123C2.36148 6.05356 2.29773 6.39588 2.23907 6.7382C2.17531 7.10608 2.11411 7.47139 2.05035 7.83926C2.0427 7.88524 2.04525 7.92101 2.08095 7.95167C2.11666 7.98488 2.15746 7.97466 2.19571 7.95678C2.21867 7.94656 2.24162 7.93378 2.26457 7.92101C2.85624 7.60934 3.44791 7.30023 4.03702 6.98601C4.29715 6.8455 4.54963 6.84805 4.80976 6.98856C5.28412 7.24403 5.76102 7.49183 6.23538 7.74218C6.37309 7.81371 6.51081 7.89035 6.65107 7.95933C6.73268 8.0002 6.79899 7.95678 6.79899 7.87247Z"
                                      //                         fill="#FFA412"
                                      //                       />
                                      //                     </svg>
                                      //                     {props.t("Suivre")}
                                      //                   </button>
                                      //                 )}
                                      //                 <button
                                      //                   className="message-action-moveto font-primary"
                                      //                   style={{
                                      //                     cursor: "pointer",
                                      //                   }}
                                      //                   onClick={() => {
                                      //                     setType("move");
                                      //                     togModalDossierVisibility();
                                      //                   }}>
                                      //                   <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                                      //                     <path
                                      //                       d="M0.0064164 8.62134C0.00419534 8.45698 0.00197428 8.29484 0.00197428 8.13048C0.00197428 7.69737 -0.00246785 7.26649 0.00197428 6.83338C0.0175217 5.64289 0.421755 4.59677 1.21467 3.70835C1.93652 2.89988 2.83383 2.3957 3.89771 2.18914C4.06651 2.15583 4.23754 2.13584 4.40856 2.12473C4.4863 2.11807 4.50851 2.09141 4.50851 2.01368C4.50629 1.42954 4.50629 0.8454 4.50629 0.261261C4.50629 0.23905 4.50406 0.21684 4.50629 0.194629C4.50851 0.170197 4.49518 0.139103 4.52183 0.125776C4.54849 0.11245 4.56625 0.141324 4.58402 0.15465C5.15483 0.618852 5.72565 1.08527 6.29868 1.54948C7.02053 2.13806 7.74237 2.72442 8.46422 3.313C8.48198 3.32632 8.49975 3.33743 8.51974 3.35076C8.51974 3.36186 8.51974 3.37297 8.51974 3.38407C8.33984 3.51067 8.1777 3.65504 8.0089 3.79497C6.8806 4.71449 5.7523 5.63845 4.624 6.55797C4.59291 6.5824 4.56181 6.63571 4.52405 6.62016C4.4863 6.60239 4.50851 6.54464 4.50851 6.50466C4.50629 5.92052 4.50851 5.33639 4.50851 4.75225C4.50851 4.63231 4.50406 4.62787 4.37968 4.63897C3.71781 4.70116 3.09369 4.89217 2.51621 5.22089C1.70997 5.67843 1.08141 6.31365 0.668292 7.14655C0.468397 7.54856 0.30626 7.96612 0.128575 8.37924C0.0930378 8.46142 0.0597218 8.54138 0.0241849 8.62356C0.0175217 8.62133 0.0130796 8.62134 0.0064164 8.62134ZM5.02601 5.55405C5.06599 5.52518 5.0882 5.50963 5.10819 5.49408C5.95664 4.80111 6.80286 4.11036 7.65131 3.41961C7.70683 3.37519 7.69129 3.35076 7.64686 3.313C6.80286 2.62669 5.95886 1.93816 5.11486 1.25185C5.09487 1.23409 5.07488 1.20077 5.046 1.21187C5.01269 1.2252 5.02823 1.26518 5.02823 1.29405C5.02823 1.69607 5.02823 2.09808 5.02823 2.50009C5.02823 2.62447 5.02823 2.62447 4.90608 2.62669C4.62622 2.63113 4.34859 2.64224 4.07096 2.68888C3.18253 2.83769 2.41849 3.23082 1.77882 3.8616C1.1858 4.44574 0.801556 5.14982 0.619429 5.96272C0.594997 6.06711 0.572787 6.17373 0.566124 6.30255C0.594997 6.26479 0.610545 6.24258 0.626092 6.22037C1.11473 5.55405 1.72552 5.0321 2.46291 4.65674C3.23362 4.26583 4.05097 4.08149 4.91718 4.10592C5.02601 4.10814 5.02823 4.10814 5.02823 4.21697C5.02823 4.6212 5.02823 5.02544 5.02823 5.42967C5.02601 5.46521 5.02601 5.49852 5.02601 5.55405Z"
                                      //                       fill="#05B714"
                                      //                     />
                                      //                   </svg>
                                      //                   {props.t("Déplacer")}
                                      //                 </button>
                                      //                 <button
                                      //                   className="message-action-trash me-0"
                                      //                   style={{
                                      //                     cursor: "pointer",
                                      //                   }}
                                      //                   onClick={() => {
                                      //                     setMessageToDelete([selectedMessage.messageId]);
                                      //                     setShowReadEmailView(false);
                                      //                     setStartCountdown(true);
                                      //                   }}>
                                      //                   <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
                                      //                     <path
                                      //                       d="M4.05383 9.07683C3.6197 9.07683 3.18557 9.07942 2.75144 9.07683C2.52787 9.07423 2.30431 9.05863 2.08594 9.00664C1.58683 8.88706 1.29567 8.57771 1.20989 8.07079C1.16049 7.78483 1.1527 7.49628 1.1345 7.21033C1.09551 6.64102 1.05911 6.07171 1.02272 5.505C1.00192 5.19046 0.981124 4.87851 0.962927 4.56396C0.93953 4.19742 0.918734 3.83347 0.897937 3.46693C0.884939 3.26417 1.00452 3.10819 1.18389 3.09779C1.37626 3.0848 1.52184 3.21218 1.53483 3.41754C1.56863 3.91146 1.59982 4.40538 1.63102 4.9019C1.66741 5.44521 1.70641 5.98853 1.7402 6.52924C1.7636 6.87238 1.78179 7.21553 1.80519 7.55607C1.81299 7.67825 1.82339 7.80043 1.84158 7.92261C1.88838 8.23716 2.03395 8.37234 2.3537 8.40873C2.48368 8.42173 2.61106 8.42953 2.74104 8.42953C3.6171 8.42953 4.49315 8.42953 5.36661 8.42953C5.49919 8.42953 5.63177 8.42173 5.76435 8.40873C6.10229 8.37234 6.25827 8.20597 6.28686 7.84462C6.32326 7.32731 6.35445 6.80999 6.38825 6.29268C6.43244 5.64278 6.47663 4.99289 6.51823 4.34299C6.53902 4.02844 6.55722 3.71649 6.58062 3.40194C6.59361 3.20958 6.74179 3.0822 6.93416 3.09519C7.10833 3.10559 7.23051 3.25637 7.22011 3.44614C7.17852 4.12203 7.13693 4.79792 7.09533 5.47381C7.05634 6.07431 7.01995 6.67741 6.97835 7.27792C6.96016 7.53527 6.95236 7.79523 6.90816 8.05259C6.81198 8.6037 6.51303 8.91305 5.96192 9.02223C5.76435 9.06123 5.56418 9.07683 5.36401 9.07683C4.92469 9.07942 4.49056 9.07683 4.05383 9.07683Z"
                                      //                       fill="#F10944"
                                      //                     />
                                      //                     <path
                                      //                       d="M4.05885 0.121277C4.3526 0.129076 4.64895 0.10308 4.94271 0.155071C5.36644 0.230459 5.6108 0.464421 5.69658 0.888153C5.74078 1.10132 5.77717 1.31448 5.81097 1.53025C5.82136 1.59264 5.84736 1.62123 5.90975 1.62643C6.14631 1.64203 6.38027 1.65763 6.61684 1.67582C7.01457 1.70702 7.40971 1.74081 7.80744 1.77721C8.00241 1.79541 8.12719 1.94878 8.11159 2.13595C8.096 2.31012 7.94002 2.4375 7.74765 2.4219C7.4487 2.39851 7.14715 2.36731 6.8482 2.34132C6.53625 2.31532 6.2217 2.28933 5.90975 2.27113C5.05189 2.22434 4.19403 2.19314 3.33357 2.21394C2.68887 2.22954 2.04418 2.25553 1.40208 2.32312C1.06414 2.35951 0.72619 2.39071 0.385645 2.4219C0.177679 2.4427 0.0139055 2.31532 0.000907593 2.13335C-0.0120903 1.92798 0.115289 1.79281 0.333654 1.77201C0.78858 1.73042 1.24351 1.68362 1.69843 1.64463C1.85701 1.63163 2.01558 1.62383 2.17416 1.61603C2.25214 1.61344 2.29634 1.59004 2.30933 1.49905C2.33793 1.29369 2.37432 1.08832 2.41592 0.885553C2.5173 0.40983 2.81625 0.168069 3.30237 0.134275C3.55453 0.118677 3.80669 0.129076 4.05885 0.121277ZM4.83612 1.58484C4.90111 1.58484 4.9947 1.57964 5.08828 1.58744C5.15327 1.59264 5.16887 1.56664 5.15847 1.50945C5.12728 1.33788 5.09868 1.16631 5.06229 0.994735C5.03369 0.859557 4.9713 0.812765 4.83612 0.791968C4.60736 0.758174 4.376 0.776371 4.14724 0.776371C3.86388 0.776371 3.57793 0.755574 3.29457 0.789369C3.1438 0.807566 3.08401 0.859557 3.05281 1.01033C3.01902 1.17151 2.99562 1.33528 2.96183 1.49645C2.94883 1.55884 2.96963 1.58224 3.02942 1.57704C3.1438 1.57184 3.25558 1.56664 3.36996 1.56404C3.84828 1.55884 4.32661 1.55884 4.83612 1.58484Z"
                                      //                       fill="#F10944"
                                      //                     />
                                      //                     <path
                                      //                       d="M4.05648 5.13067C3.72633 5.13067 3.39619 5.13067 3.06604 5.13067C2.85028 5.13067 2.7021 5.00069 2.6969 4.81352C2.6917 4.62895 2.85028 4.48337 3.06604 4.48337C3.72633 4.48077 4.38923 4.48337 5.04952 4.48337C5.22369 4.48337 5.34327 4.56136 5.39526 4.70174C5.44466 4.83171 5.41086 4.9435 5.31468 5.03968C5.24449 5.10987 5.1561 5.13327 5.05732 5.13327C4.72197 5.13067 4.38923 5.13067 4.05648 5.13067Z"
                                      //                       fill="#F10944"
                                      //                     />
                                      //                     <path
                                      //                       d="M4.04608 6.7866C3.82251 6.7866 3.59895 6.7866 3.37538 6.7866C3.18562 6.7866 3.04004 6.64622 3.04004 6.46945C3.04004 6.29268 3.18562 6.1523 3.37538 6.1523C3.83031 6.1523 4.28264 6.1523 4.73756 6.1523C4.92473 6.1523 5.07291 6.29787 5.07031 6.47465C5.06771 6.64882 4.92473 6.7866 4.74016 6.78919C4.5088 6.7866 4.27744 6.7866 4.04608 6.7866Z"
                                      //                       fill="#F10944"
                                      //                     />
                                      //                   </svg>
                                      //                   {the_folder !== "Trash" ? props.t("Corbeille") : props.t("Supprimer")}
                                      //                 </button>
                                      //               </>
                                      //             ) : (
                                      //               <div className="d-flex align-items-center">
                                      //                 {messagesTagsList[message.directMessageId]
                                      //                   ? messagesTagsList[message.directMessageId].slice(0, 3).map((reason, index) => (
                                      //                       <div key={index} className="d-flex">
                                      //                         {index === 2 && (
                                      //                           <UncontrolledTooltip
                                      //                             color="primary"
                                      //                             placement="top"
                                      //                             innerClassName="d-flex gap-1"
                                      //                             style={{
                                      //                               maxWidth: "500px",
                                      //                               padding: "4px",
                                      //                               border: "1px solid lightgray",
                                      //                               background: "white",
                                      //                               opacity: "1",
                                      //                               flexWrap: "wrap",
                                      //                             }}
                                      //                             target={"TooltipWithHtml1" + message.messageId}>
                                      //                             {messagesTagsList[message.directMessageId]
                                      //                               .slice(2, messagesTagsList[message.directMessageId].length + 1)
                                      //                               .map((reason, index) => (
                                      //                                 <span
                                      //                                   id={index}
                                      //                                   className={`badge font-primary`}
                                      //                                   style={{
                                      //                                     backgroundColor: `${stringToColour(reason)}25`,
                                      //                                     color: stringToColour(reason),
                                      //                                     display: "flex",
                                      //                                     padding: "4px",
                                      //                                   }}>
                                      //                                   {props.t(reason)}
                                      //                                 </span>
                                      //                               ))}
                                      //                           </UncontrolledTooltip>
                                      //                         )}

                                      //                         <div
                                      //                           id={index === 2 ? "TooltipWithHtml1" + message.messageId : ""}
                                      //                           className={`badge me-1 font-primary`}
                                      //                           style={{
                                      //                             backgroundColor: `${
                                      //                               index === 2
                                      //                                 ? stringToColour(messagesTagsList[message.directMessageId][index - 1])
                                      //                                 : stringToColour(reason)
                                      //                             }25`,
                                      //                             color:
                                      //                               index === 2
                                      //                                 ? stringToColour(messagesTagsList[message.directMessageId][index - 1])
                                      //                                 : stringToColour(reason),
                                      //                             marginTop: "6px",
                                      //                             display: "flex !important",
                                      //                             padding: "4px",
                                      //                           }}>
                                      //                           {index === 2 ? <PlusOutlined height={12} width={12} /> : props.t(reason)}
                                      //                         </div>
                                      //                       </div>
                                      //                     ))
                                      //                   : ""}
                                      //               </div>
                                      //             )}
                                      //           </div>
                                      //         </div>
                                      //         <div style={{ textAlign: "right" }}>
                                      //           <div className="email-message-date font-primary" style={{ minWidth: "35px" }}>
                                      //             {formaterDate(message.attributes.date)}
                                      //           </div>
                                      //           <div>
                                      //             {message.flags && !message.flags.includes("\\Seen") ? (
                                      //               <span className="email-count rounded-circle p-2 d-flex align-items-center justify-content-center font-primary">
                                      //                 {message.related_messages.length}
                                      //               </span>
                                      //             ) : (
                                      //               <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      //                 <path
                                      //                   d="M14.026 8.15665L5.62605 16.4067C5.48577 16.5446 5.29688 16.622 5.10011 16.622C4.90334 16.622 4.71445 16.5446 4.57417 16.4067L0.974175 12.8713C0.903938 12.8023 0.847993 12.72 0.809533 12.6294C0.771074 12.5387 0.750853 12.4413 0.750026 12.3428C0.749199 12.2443 0.767782 12.1466 0.804713 12.0553C0.841644 11.9639 0.896201 11.8808 0.965268 11.8106C1.03434 11.7403 1.11656 11.6844 1.20725 11.6459C1.29794 11.6075 1.39531 11.5872 1.49381 11.5864C1.59232 11.5856 1.69002 11.6042 1.78134 11.6411C1.87266 11.678 1.95581 11.7326 2.02605 11.8017L5.10011 14.8204L12.9751 7.08603C13.1171 6.94654 13.3087 6.86916 13.5077 6.87092C13.6062 6.87179 13.7036 6.89206 13.7943 6.93058C13.8851 6.9691 13.9673 7.0251 14.0364 7.0954C14.1054 7.1657 14.16 7.24891 14.1969 7.34029C14.2338 7.43167 14.2523 7.52942 14.2515 7.62797C14.2506 7.72651 14.2303 7.82392 14.1918 7.91463C14.1533 8.00535 14.0973 8.08758 14.027 8.15665H14.026ZM23.0354 7.0954C22.9664 7.02505 22.8842 6.969 22.7934 6.93045C22.7027 6.8919 22.6053 6.87161 22.5067 6.87074C22.4082 6.86987 22.3104 6.88843 22.219 6.92537C22.1276 6.96231 22.0444 7.01691 21.9742 7.08603L14.0992 14.8204L12.3339 13.086C12.1919 12.9467 12.0004 12.8694 11.8014 12.8713C11.6025 12.8731 11.4124 12.9539 11.2731 13.0959C11.1337 13.2378 11.0565 13.4294 11.0583 13.6283C11.0602 13.8272 11.141 14.0173 11.2829 14.1567L13.5732 16.4067C13.7135 16.5446 13.9024 16.622 14.0992 16.622C14.2959 16.622 14.4848 16.5446 14.6251 16.4067L23.0251 8.15665C23.0955 8.08768 23.1516 8.0055 23.1903 7.91482C23.2289 7.82413 23.2493 7.72673 23.2502 7.62816C23.2512 7.5296 23.2327 7.43181 23.1959 7.3404C23.159 7.24898 23.1045 7.16573 23.0354 7.0954Z"
                                      //                   fill="#329993"
                                      //                 />
                                      //               </svg>
                                      //             )}
                                      //           </div>
                                      //           {messagesStateList[message.directMessageId] &&
                                      //           messagesStateList[message.directMessageId] === "Treated" ? (
                                      //             <img
                                      //               src={maaiaIconInfoPurple}
                                      //               alt="Synibox Icon Info Purple"
                                      //               style={{
                                      //                 width: "24px",
                                      //                 height: "24px",
                                      //               }}
                                      //             />
                                      //           ) : messagesStateList[message.directMessageId] &&
                                      //             messagesStateList[message.directMessageId] === "Untreated" ? (
                                      //             <img
                                      //               src={maaiaIconInfoPink}
                                      //               alt="Synibox Icon Info Pink"
                                      //               style={{
                                      //                 width: "24px",
                                      //                 height: "24px",
                                      //               }}
                                      //             />
                                      //           ) : messagesStateList[message.directMessageId] &&
                                      //             messagesStateList[message.directMessageId] === "Pending" ? (
                                      //             <img
                                      //               src={maaiaIconInfoYellow}
                                      //               alt="Synibox Icon Info Yellow"
                                      //               style={{
                                      //                 width: "24px",
                                      //                 height: "24px",
                                      //               }}
                                      //             />
                                      //           ) : (
                                      //             <div></div>
                                      //           )}
                                      //         </div>
                                      //       </div>

                                      //       {/* {message.subject}
                                      //                  <div className="date" style={{ float: "right" }}>
                                      //                       {formaterDate(
                                      //                          message.attributes.date
                                      //                      )}
                                      //                  </div> */}
                                      //       <hr className="mails-separator" style={{ margin: "0 24px" }} />
                                      //     </div>
                                      //   </div>
                                      // </Row>
                                    )
                                )
                              ) : (
                                <div
                                  className="simple-text font-primary"
                                  style={{
                                    textAlign: "center",
                                    padding: "5em",
                                    fontSize: "14px"
                                  }}
                                >
                                  {props.t("Vide")} {error}
                                </div>
                              )}
                            </ul>
                          </div>
                        )}
                      </ul>
                      <div className="mb-4" style={{ textAlign: "center" }}>
                        {loading &&
                          email_conversations[getBoxFromUrl()] &&
                          email_conversations[getBoxFromUrl()].length > 0 && (
                            <div style={{ textAlign: "center" }}>
                              {props.t("Chargement")}...
                            </div>
                          )}
                      </div>

                      {/* end mail 1 */}
                      {/* <Row className="justify-content-end">
                              <Col xl={9}>
                                {totalMails > 0 ? <Row className="my-4">
                                  <div className="col-7">
                                    Affichage {((currentPage === 1 ? currentPage : (currentPage * pageSize) - pageSize))} - {totalPage === currentPage ? totalMails : currentPage * pageSize} sur {totalMails}
                                  </div>
                                  <div className="col-5">
                                    <div className="btn-group float-end">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-success waves-effect"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                      >
                                        <i className="fa fa-chevron-left"></i>
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-success waves-effect"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={totalPage == currentPage}
                                      >
                                        <i className="fa fa-chevron-right"></i>
                                      </button>
                                    </div>
                                  </div>
                                </Row>
                                  : null}
                              </Col>
                            </Row> */}
                      {/* </div>  */}
                    </div>
                    <div
                      className="d-flex flex-row flex-1"
                      style={{
                        flex: "1 1 0%",
                        position: "relative",
                        height: "100%"
                      }}
                    >
                      <Col
                        // xl={!isColumnVisible ? 7 : 5}
                        className="inbox-conversation-stream d-flex flex-column"
                        style={{
                          padding: "0 20px 0 20px",
                          backgroundColor: "#ffffff",
                          flex: "none",
                          width: isColumnVisible ? "73%" : "100%"
                        }}
                      >
                        <div>
                          {showReadEmailView && (
                            <div>
                              <Row className="email-menu-bar">
                                <Col
                                  xl={5}
                                  xxl={7}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    // width: "auto",
                                    padding: "0",
                                    marginRight: "24px"
                                  }}
                                >
                                  {selectedMessage ? (
                                    <div className="d-flex flex-column">
                                      <div
                                        className="message-subject font-primary"
                                        style={{ whiteSpace: "pre-wrap" }}
                                      >
                                        {/* {selectedMessage.headers.from[0].split("<")[0]}*/}
                                        {selectedMessage.subject}
                                      </div>
                                      <div className="simple-text font-primary message-headers">
                                        {selectedMessage.from.value[0].name}{" "}
                                        <div
                                          className="me-3 simple-text font-primary"
                                          style={{
                                            color: "#5E44FE",
                                            cursor: "pointer",
                                            fontSize: "14px"
                                          }}
                                          onClick={() => {
                                            setToEmail(
                                              selectedMessage.from.value[0]
                                                .address
                                            );
                                            onMessageCreateModalVisibility();
                                          }}
                                        >
                                          {
                                            selectedMessage.from.value[0]
                                              .address
                                          }
                                        </div>
                                        {/* <a
                                          //  href={`mailto:${selectedMessage.from.value[0].address}`}
                                          className="ms-1 font-primary simple-text"
                                          style={{
                                            //  color: "#5E44FE",
                                            fontWeight: "400"
                                          }}
                                          onClick={() => {
                                            onMessageCreateModalVisibility();
                                          }}>
                                          {selectedMessage.from.value[0].address}
                                        </a> */}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="message-subject font-primary">
                                      Aucun message{" "}
                                    </div>
                                  )}
                                </Col>
                                <Col
                                  className="d-flex align-items-center justify-content-end p-0"
                                  style={{ width: "fit-content" }}
                                >
                                  {/* {showReadEmailView ? (
                                    <i
                                      className="font-size-12 me-2"
                                      style={{
                                        color: "#FFA412",
                                        cursor: "pointer",
                                        marginBottom: "4px"
                                      }}
                                      onClick={() => {
                                        copyMail(selectedMessage.messageId, the_folder, "Starred");
                                      }}>
                                      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M4.77917 18C4.30831 19.4079 4.11876 20.2242 4.33707 20.7589C4.57355 21.3381 5.06741 21.7732 5.67176 21.9349C6.40459 22.131 7.53083 21.5679 9.78331 20.4417L10.4281 20.1192C11.0913 19.7876 11.4229 19.6218 11.7755 19.582C11.9247 19.5652 12.0753 19.5652 12.2245 19.582C12.5771 19.6218 12.9087 19.7876 13.5719 20.1192L14.2167 20.4416C16.4692 21.5679 17.5954 22.131 18.3282 21.9349C18.9326 21.7732 19.4265 21.3381 19.6629 20.7589C19.9497 20.0565 19.5328 18.8684 18.699 16.4921C18.4431 15.7628 18.3151 15.3981 18.3213 15.0398C18.3264 14.7381 18.3998 14.4415 18.5359 14.1721C18.6975 13.8523 18.9807 13.5893 19.5471 13.0634L19.688 12.9326C21.4827 11.266 22.3801 10.4327 22.4346 9.64341C22.4707 9.12094 22.3005 8.60516 21.9604 8.20688C21.4466 7.60515 20.2295 7.46992 17.7953 7.19945C17.0994 7.12213 16.7515 7.08347 16.4511 6.94222C16.2464 6.84591 16.0594 6.71555 15.8982 6.55668C15.6618 6.32367 15.5053 6.01055 15.1922 5.38432L15.1446 5.28921C13.9748 2.9496 13.3899 1.77979 12.5297 1.54353C12.183 1.4483 11.817 1.4483 11.4703 1.54353C10.6101 1.77979 10.0252 2.94959 8.85538 5.28921L8.80782 5.38433C8.49471 6.01055 8.33815 6.32367 8.10177 6.55668C7.9406 6.71555 7.75365 6.84591 7.54886 6.94222C7.24849 7.08347 6.90056 7.12213 6.2047 7.19945C3.77048 7.46992 2.55337 7.60515 2.0396 8.20688C1.69954 8.60516 1.52927 9.12094 1.56537 9.64341C1.61991 10.4327 2.51729 11.266 4.31205 12.9326L4.45294 13.0634C4.8296 13.4132 5.15249 13.7881 5.32654 14"
                                          stroke="#FFA412"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </i>
                                  ) : (
                                    <div></div>
                                  )} */}

                                  {showReadEmailView ? (
                                    <div className="me-2">
                                      <Dropdown
                                        isOpen={btnprimary1}
                                        toggle={() =>
                                          setBtnprimary1(!btnprimary1)
                                        }
                                        style={{
                                          padding: "0px 8px",
                                          marginTop: "4px"
                                        }}
                                      >
                                        <DropdownToggle
                                          tag="button"
                                          // className={}
                                          style={{
                                            marginBottom: "8px",
                                            padding: "0",
                                            backgroundColor: "transparent",
                                            border: "none",
                                            borderRadius: "5px"
                                          }}
                                        >
                                          {/* <i className="mdi mdi-dots-horizontal font-size-20"></i> */}
                                          <svg
                                            width="21"
                                            height="21"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M13 21.0001H21M9.99999 14.9996H6.99999M21 14.9996H14M9 9.00006H21M13 2.99982H3M21 2.99982H17"
                                              stroke="#FF7049"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem
                                            className="font-primary simple-text"
                                            onClick={() => {
                                              setType("copy");
                                              togModalDossierVisibility();
                                            }}
                                          >
                                            {props.t("Copier vers")}
                                          </DropdownItem>
                                          <DropdownItem
                                            className="font-primary simple-text"
                                            onClick={() => {
                                              setType("move");
                                              togModalDossierVisibility();
                                            }}
                                          >
                                            {props.t("Déplacer vers")}
                                          </DropdownItem>
                                          <DropdownItem
                                            className="font-primary simple-text"
                                            onClick={() => {
                                              setMessageToDelete([
                                                selectedMessage.messageId
                                              ]);
                                              setShowReadEmailView(false);
                                              setStartCountdown(true);
                                            }}
                                          >
                                            {props.t("Supprimer")}
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                    </div>
                                  ) : (
                                    <div></div>
                                  )}

                                  {/* <button
                                    className="me-2"
                                    style={{
                                      border: "none",
                                      backgroundColor: "#E8F7F7",
                                      padding: "6px 8px",
                                      borderRadius: "5px",
                                      cursor: "pointer"
                                    }}>
                                    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path
                                        d="M21.6664 18L21.5831 18.5V18.5C21.4267 19.4386 21.3484 19.9079 21.168 20.2876C20.7982 21.0659 20.1115 21.6476 19.283 21.8844C18.8788 22 18.403 22 17.4515 22H5.99976L7.33128 14.0109C7.56877 12.5859 7.68751 11.8735 8.04306 11.3388C8.35647 10.8675 8.79681 10.4945 9.31322 10.2628C9.89905 10 10.6214 10 12.066 10H19.4515C20.5388 10 21.0824 10 21.4844 10.1875C22.014 10.4346 22.409 10.9009 22.5656 11.4639C22.6845 11.8912 22.5952 12.4275 22.4164 13.5V13.5L22.3331 14M14.9998 21.9995H6.79976C5.1196 21.9995 4.27952 21.9995 3.63778 21.6725C3.0733 21.3849 2.61436 20.926 2.32674 20.3615C1.99976 19.7197 1.99976 18.8797 1.99976 17.1995V13.4998V12.9998M19.9998 9.99976V9.99976C19.9998 9.06956 19.9998 8.60446 19.8975 8.22287C19.6201 7.18774 18.8115 6.37922 17.7764 6.10178C17.3948 5.99951 16.9297 5.99951 15.9995 5.99951H14.2358C13.867 5.99951 13.6826 5.99951 13.5125 5.98002C12.6248 5.87835 11.8286 5.38629 11.3407 4.63778C11.2472 4.49432 11.1647 4.32939 10.9998 3.99951V3.99951C10.8348 3.66964 10.7524 3.5047 10.6588 3.36124C10.1709 2.61274 9.37473 2.12067 8.48704 2.019C8.3169 1.99951 8.1325 1.99951 7.76369 1.99951H6.79976C5.1196 1.99951 4.27952 1.99951 3.63778 2.32649C3.0733 2.61411 2.61436 3.07305 2.32674 3.63754C1.99976 4.27928 1.99976 5.11935 1.99976 6.79951V8.49976V8.99976"
                                        stroke="#2F384C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </button> */}
                                  {!isColumnVisible && (
                                    <i
                                      onClick={showColumn}
                                      className="mdi mdi-dock-left ms-3"
                                      style={{
                                        cursor: "pointer",
                                        fontSize: " 14px"
                                      }}
                                    ></i>
                                  )}
                                </Col>
                              </Row>
                            </div>
                          )}
                        </div>

                        {showReadEmailView && selectedMessage ? (
                          <ReadEmailView
                            key={selectedMessage.directMessageId}
                            showReadEmailView={showReadEmailView}
                            the_message={selectedMessage}
                            all_messages={
                              email_conversations[getBoxFromUrl()] ?? []
                            }
                            folder={getBoxFromUrl()}
                            client_data={client_data}
                            incrementAttr={incrementAttr}
                            incrementAttrByValue={incrementAttrByValue}
                            fetchMessageOrders={fetchMessageOrders}
                            // fullMessage={fullMessage}
                            fullMessage={
                              selectedMessage
                                ? {
                                    [selectedMessage.directMessageId]:
                                      selectedMessage
                                  }
                                : undefined
                            }
                            messageInfos={messageInfos}
                            sentMessage={sentMessage}
                            setMessageInfos={setMessageInfos}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "35%"
                            }}
                          >
                            <img
                              src={logo_smartas_1}
                              height={"40px"}
                              width={"40px"}
                              alt="logo_maaia"
                            />
                            {/* <img src={logo_maaia_2} height={"40x"} width={"40px"} /> */}
                          </div>
                        )}
                      </Col>

                      {isColumnVisible && (
                        <Col
                          // xl={2}
                          className="detail-bar"
                          style={{
                            width: "27%",
                            position: "absolute",
                            right: "0 ",
                            top: "0",
                            height: "100%",
                            overflow: "auto"
                          }}
                        >
                          <div className="email-menu-bar d-flex">
                            <p
                              className="column-title font-primary"
                              style={{ fontSize: "14px" }}
                            >
                              {props.t("Détails")}
                            </p>

                            <Col className="d-flex justify-content-end">
                              <span
                                style={{ cursor: "pointer" }}
                                className="detail-bar-menu-icon"
                                onClick={showColumn}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M17.3276 17.8933C16.9957 18.2251 16.6488 18.3911 16.2867 18.3911C15.9096 18.376 15.5551 18.2025 15.2233 17.8706L11.5124 14.1597L7.86934 17.8028C7.55256 18.1195 7.22069 18.2855 6.87374 18.3006C6.5117 18.3006 6.17229 18.1422 5.8555 17.8254C5.53872 17.5086 5.38787 17.1767 5.40295 16.8298C5.40295 16.4677 5.56135 16.1283 5.87813 15.8116L9.52114 12.1685L5.92339 8.57078C5.59152 8.23891 5.42558 7.89195 5.42558 7.52992C5.42558 7.16788 5.59906 6.81338 5.94601 6.46643C6.27788 6.13456 6.61729 5.97617 6.96425 5.99125C7.32628 5.99125 7.67324 6.15719 8.00511 6.48906L11.6029 10.0868L15.2459 6.4438C15.5777 6.11193 15.9172 5.95354 16.2641 5.96862C16.6111 5.95354 16.9429 6.10439 17.2597 6.42117C17.5765 6.73796 17.7349 7.07737 17.7349 7.43941C17.7349 7.77127 17.569 8.10314 17.2371 8.43501L13.5941 12.078L17.305 15.7889C17.6368 16.1208 17.8103 16.4753 17.8254 16.8524C17.8405 17.1994 17.6746 17.5463 17.3276 17.8933Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                            </Col>
                          </div>
                          <div className="email-menu-bar-line"> </div>
                          {selectedMessage && (
                            <div
                              className="d-flex align-items-center mb-4"
                              style={{ flexDirection: "column" }}
                            >
                              <Badge
                                className={`avatarBadge rounded-circle align-middle me-2 mb-2 font-primary avatarBadge_regular`}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexShrink: "0",
                                  height: "30px !important",
                                  width: "30px !important",
                                  fontSize: " 14px",
                                  padding: "6px"
                                }}
                              >
                                {(
                                  selectedMessage.from.value[0].address ??
                                  selectedMessage.from.value[0].name
                                )
                                  .split(" ")
                                  .map((part) => part.charAt(0).toUpperCase())
                                  .join("")
                                  .slice(0, 2)}
                              </Badge>
                              <div className="message-subject font-primary">
                                {selectedMessage.from.value[0].name}
                              </div>
                              {selectedMessage ? (
                                <span
                                  className="font-primary"
                                  style={{ fontSize: "14px", color: "#505d69" }}
                                >
                                  {" "}
                                  {formatDate(
                                    props,
                                    selectedMessage.attributes.date,
                                    true
                                  )}
                                </span>
                              ) : (
                                <span> </span>
                              )}
                            </div>
                          )}
                          <div
                            className="accordion accordion-flush"
                            id="accordionFlushExample"
                          >
                            <hr className="m-0" style={{ borderTop: "none" }} />
                            {selectedMessage &&
                              messageOrderInfos &&
                              messageOrderInfos[
                                selectedMessage.directMessageId
                              ] &&
                              messageOrderInfos[selectedMessage.directMessageId]
                                .length > 0 && (
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header d-flex"
                                    id="headingFlushOne"
                                    style={{ position: "relative" }}
                                  >
                                    <button
                                      className={classnames(
                                        "accordion-button",
                                        "font-size-16",
                                        {
                                          collapsed: !detailsAccordion.infos
                                        }
                                      )}
                                      type="button"
                                      onClick={() =>
                                        onToggleDetailsAccordion(
                                          !detailsAccordion.infos,
                                          "infos"
                                        )
                                      }
                                      style={{
                                        cursor: "pointer",
                                        fontWeight: "500"
                                      }}
                                    >
                                      {props.t("Informations")}
                                      {/* <span
                                        className="font-size-10 ms-auto"
                                        style={{
                                          position: "absolute",
                                          right: "20px",
                                          top: "6px"
                                        }}>
                                        {detailsAccordion.infos ? "Fermer" : "Ouvrir"}
                                      </span> */}
                                    </button>
                                  </h2>
                                  <Collapse
                                    isOpen={detailsAccordion.infos}
                                    className="accordion-collapse"
                                  >
                                    <div className="accordion-body">
                                      <div>
                                        {messageOrderInfos[
                                          selectedMessage.directMessageId
                                        ].map((messageOrderInfo, idx) => (
                                          <div
                                            key={idx}
                                            className={`${
                                              idx > 0 ? "mt-3" : "mt-0"
                                            } ${
                                              idx ===
                                              messageOrderInfos[
                                                selectedMessage.directMessageId
                                              ].length -
                                                1
                                                ? "mb-4"
                                                : ""
                                            } ms-xxl-2`}
                                          >
                                            <div
                                              className="d-flex align-items-center mb-2"
                                              style={{
                                                marginTop: "-10px",
                                                paddingTop: "8px",
                                                flexWrap: "wrap"
                                              }}
                                            >
                                              <h5
                                                className="font-primary d-flex gap-2 mb-0 me-xxl-3"
                                                style={{
                                                  fontSize: "12px",
                                                  fontWeight: "bold"
                                                }}
                                              >
                                                {props.t("order")}{" "}
                                                <a
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  href={`https://${client_data.shopify_store_url}/admin/orders/${messageOrderInfo.id}`}
                                                  className="d-flex gap-1"
                                                  style={{ color: "#5E44FE" }}
                                                >
                                                  {messageOrderInfo.name}
                                                  <ExternalLinkDuocolor
                                                    style={{
                                                      height: "14px"
                                                    }}
                                                  />
                                                </a>
                                              </h5>
                                              <img
                                                // src={messageOrderInfo.name === "#1030" ? logo_shopify : logo_prestashop}
                                                src={logo_shopify}
                                                style={{ height: "24px" }}
                                                alt="logo_cms"
                                              />
                                            </div>

                                            <div
                                              className="mb-1 d-flex align-items-center"
                                              style={{ flexWrap: "wrap" }}
                                            >
                                              <p
                                                className="font-primary mb-1"
                                                style={{
                                                  fontWeight: "bold",
                                                  fontSize: "12px"
                                                }}
                                              >
                                                {props.t("Status")}
                                              </p>
                                              <div className="font-primary mb-0 d-flex gap-1 ms-xl-auto">
                                                <div
                                                  className="badge d-flex align-items-center py-1 px-2"
                                                  style={{
                                                    borderRadius: "10px",
                                                    backgroundColor: getColors(
                                                      messageOrderInfo.financial_status
                                                    ).backgroundColor,
                                                    color: getColors(
                                                      messageOrderInfo.financial_status
                                                    ).color,
                                                    fontSize: "10px"
                                                  }}
                                                >
                                                  <DollarDuocolor
                                                    height="10"
                                                    className="me-1"
                                                  />
                                                  {props.t(
                                                    messageOrderInfo.financial_status
                                                  )}
                                                </div>
                                                <div
                                                  className="badge d-flex align-items-center py-1 px-2"
                                                  style={{
                                                    borderRadius: "10px",
                                                    backgroundColor: getColors(
                                                      messageOrderInfo.fulfillment_status
                                                    ).backgroundColor,
                                                    color: getColors(
                                                      messageOrderInfo.fulfillment_status
                                                    ).color,
                                                    fontSize: "10px"
                                                  }}
                                                >
                                                  {messageOrderInfo.fulfillment_status ===
                                                  "UNFULFILLED" ? (
                                                    <CrossOutlined
                                                      height="10"
                                                      className="me-1"
                                                    />
                                                  ) : (
                                                    <CheckCircleMono
                                                      height="10"
                                                      className="me-1"
                                                    />
                                                  )}
                                                  {props.t(
                                                    messageOrderInfo.fulfillment_status
                                                  )}
                                                </div>
                                              </div>
                                            </div>

                                            <div
                                              style={{
                                                marginTop: "12px",
                                                border:
                                                  "1.5px solid rgba(94, 68, 254, 0.2)",
                                                borderRadius: "8px",
                                                marginBottom: "12px"
                                              }}
                                            >
                                              {messageOrderInfo.line_items
                                                .slice(0, 3)
                                                .map((lineItem, idx) => (
                                                  <div
                                                    key={idx}
                                                    className="px-2 pt-3"
                                                  >
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        gap: "12px"
                                                      }}
                                                    >
                                                      <img
                                                        width={50}
                                                        height={50}
                                                        className="me-1"
                                                        style={{
                                                          borderRadius: "5px",
                                                          border:
                                                            "1px solid rgba(94, 68, 254, 0.3)",
                                                          flexShrink: 0
                                                        }}
                                                        src={
                                                          lineItem.image_url ??
                                                          "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png?v=1530129292"
                                                        }
                                                        alt={lineItem.name}
                                                      />
                                                      <div
                                                        style={{
                                                          flex: 1,
                                                          minWidth: 0
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            justifyContent:
                                                              "space-between",
                                                            alignItems:
                                                              "flex-start",
                                                            marginBottom: "4px"
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              fontSize: "12px",
                                                              textTransform:
                                                                "capitalize",
                                                              color:
                                                                "rgba(94, 68, 254)",
                                                              fontWeight:
                                                                "bold",
                                                              lineHeight: "1.2",
                                                              maxHeight:
                                                                "2.4em",
                                                              overflow:
                                                                "hidden",
                                                              textOverflow:
                                                                "ellipsis",
                                                              display:
                                                                "-webkit-box",
                                                              WebkitLineClamp: 2,
                                                              WebkitBoxOrient:
                                                                "vertical",
                                                              wordBreak:
                                                                "break-word",
                                                              flex: 1,
                                                              marginRight: "8px"
                                                            }}
                                                            title={lineItem.name.toLowerCase()}
                                                          >
                                                            {lineItem.name.toLowerCase()}
                                                          </div>
                                                          <div
                                                            style={{
                                                              fontSize: "12px",
                                                              fontWeight:
                                                                "bold",
                                                              whiteSpace:
                                                                "nowrap",
                                                              flexShrink: 0
                                                            }}
                                                          >
                                                            {`${
                                                              messageOrderInfo.currency ===
                                                              "EUR"
                                                                ? "€"
                                                                : "$"
                                                            }${parseFloat(
                                                              lineItem.price
                                                            ).toFixed(2)}`}
                                                          </div>
                                                        </div>

                                                        <div className="mt-2">
                                                          <div className="d-flex gap-1">
                                                            <div
                                                              style={{
                                                                fontSize:
                                                                  "12px",
                                                                fontWeight:
                                                                  "bold"
                                                              }}
                                                            >{`${props.t(
                                                              "SKU"
                                                            )}:`}</div>
                                                            <div
                                                              style={{
                                                                fontSize: "12px"
                                                              }}
                                                            >
                                                              {lineItem.sku}
                                                            </div>
                                                          </div>
                                                          <div className="d-flex gap-1">
                                                            <div
                                                              style={{
                                                                fontSize:
                                                                  "12px",
                                                                fontWeight:
                                                                  "bold"
                                                              }}
                                                            >{`${props.t(
                                                              "quantity"
                                                            )}:`}</div>
                                                            <div
                                                              style={{
                                                                fontSize: "12px"
                                                              }}
                                                            >
                                                              {
                                                                lineItem.quantity
                                                              }
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ))}
                                              <div className="d-flex justify-content-between align-items-end ms-2 me-2 mb-3">
                                                <a
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  href={`https://${client_data.shopify_store_url}/admin/orders/${messageOrderInfo.id}`}
                                                  className="d-flex gap-1"
                                                  style={{
                                                    color: "#5E44FE",
                                                    fontSize: "12px",
                                                    fontWeight: "bold"
                                                  }}
                                                >
                                                  {messageOrderInfo.line_items
                                                    .length > 2
                                                    ? props.t(
                                                        "Voir tous les produits"
                                                      )
                                                    : props.t(
                                                        "Voir la commande"
                                                      )}
                                                  <ExternalLinkDuocolor
                                                    style={{
                                                      height: "14px"
                                                    }}
                                                  />
                                                </a>

                                                <div>
                                                  <div
                                                    className="badge d-flex align-items-center py-1 px-2 ms-auto"
                                                    style={{
                                                      borderRadius: "10px",
                                                      backgroundColor:
                                                        "#5e44fe",
                                                      color: "white",
                                                      fontSize: "10px",
                                                      width: "fit-content"
                                                    }}
                                                  >
                                                    <TruckFilled
                                                      height="10"
                                                      className="me-1"
                                                    />
                                                    {`${
                                                      messageOrderInfo.currency ===
                                                      "EUR"
                                                        ? "€"
                                                        : "$"
                                                    }${messageOrderInfo.shipping_lines
                                                      .reduce(
                                                        (
                                                          total,
                                                          shipping_line
                                                        ) => {
                                                          return (
                                                            total +
                                                              parseFloat(
                                                                shipping_line.discounted_price
                                                              ) || 0
                                                          );
                                                        },
                                                        0
                                                      )
                                                      .toFixed(2)}`}
                                                  </div>
                                                  <div className="d-flex gap-1">
                                                    <div
                                                      style={{
                                                        fontSize: "12px"
                                                      }}
                                                    >{`${props.t(
                                                      "Total"
                                                    )}:`}</div>
                                                    <div
                                                      style={{
                                                        fontSize: "12px",
                                                        fontWeight: "bold"
                                                      }}
                                                    >
                                                      {`${
                                                        messageOrderInfo.currency ===
                                                        "EUR"
                                                          ? "€"
                                                          : "$"
                                                      }${
                                                        messageOrderInfo.total_price
                                                      }`}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                              <div
                                                className="d-flex"
                                                style={{
                                                  flexDirection: "column"
                                                }}
                                              >
                                                <div
                                                  className="font-primary mb-2"
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "12px"
                                                  }}
                                                >
                                                  {props.t("Adress (Shipping)")}
                                                </div>
                                                <div className="font-size-12">
                                                  <div
                                                    className="mb-0"
                                                    style={{
                                                      fontWeight: "bold"
                                                    }}
                                                  >{`${messageOrderInfo.billing_address.first_name} ${messageOrderInfo.billing_address.last_name}`}</div>
                                                  {
                                                    messageOrderInfo
                                                      .billing_address.address1
                                                  }
                                                  <br />{" "}
                                                  {`${
                                                    messageOrderInfo
                                                      .billing_address.city
                                                  }, ${
                                                    messageOrderInfo
                                                      .billing_address
                                                      .province_code
                                                      ? `${messageOrderInfo.billing_address.province_code} ${messageOrderInfo.billing_address.zip}`
                                                      : `${messageOrderInfo.billing_address.zip}`
                                                  }`}
                                                  <br />{" "}
                                                  {
                                                    messageOrderInfo
                                                      .billing_address.country
                                                  }
                                                </div>
                                              </div>
                                              {/* <div
                                        className="d-flex"
                                        style={{
                                          flexDirection: "column",
                                        }}>
                                        <div className="font-primary mb-2" style={{ fontWeight: "bold", fontSize: "12px" }}>
                                          {props.t("Payment Details")}
                                        </div>
                                        <div className="font-size-12">
                                          <div className="d-flex gap-1">
                                            Payment via <div style={{ fontWeight: "bold" }}>Stripe</div>
                                          </div>
                                          <div className="d-flex gap-1">
                                            Mastercard <div style={{ fontWeight: "bold" }}>6789</div>
                                          </div>
                                          13 May 2024, 09:22 AM
                                        </div>
                                      </div> */}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </Collapse>
                                </div>
                              )}

                            {alertList &&
                            selectedMessage &&
                            alertList[selectedMessage.directMessageId] &&
                            alertList[selectedMessage.directMessageId].length >
                              0 ? (
                              <div
                                className="accordion-item"
                                style={{
                                  maxHeight: "60vh",
                                  overflow: "scroll"
                                }}
                              >
                                <div
                                  className="accordion-header"
                                  id="headingFlushTwo"
                                >
                                  <button
                                    className={classnames(
                                      "accordion-button",
                                      "font-size-14 d-flex align-items-center justify-content-between gap-1",
                                      {
                                        collapsed: !detailsAccordion.alerts
                                      }
                                    )}
                                    type="button"
                                    onClick={() =>
                                      onToggleDetailsAccordion(
                                        !detailsAccordion.alerts,
                                        "alerts"
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      fontWeight: "500"
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                      }}
                                    >
                                      <img
                                        src={logo_smartas_1}
                                        alt="logo_smartas_1"
                                        style={{
                                          width: "auto",
                                          height: "24px"
                                        }}
                                      />
                                      {props.t("Attentions Requises")}
                                      {/* <span className="font-size-10 ms-auto">{detailsAccordion.alerts ? "Fermer" : "Ouvrir"}</span> */}
                                    </div>
                                  </button>
                                </div>

                                <Collapse
                                  isOpen={detailsAccordion.alerts}
                                  className="accordion-collapse"
                                >
                                  <div className="accordion-body">
                                    {alertList[
                                      selectedMessage.directMessageId
                                    ].map((alert, index) => (
                                      <div
                                        key={index}
                                        className={`font-primary font-size-12 mb-2 ${
                                          index ===
                                          alertList[
                                            selectedMessage.directMessageId
                                          ].length -
                                            1
                                            ? "mb-4"
                                            : ""
                                        }`}
                                        style={{
                                          maxWidth: "fit-content",
                                          fontWeight: "bold",
                                          color: "black"
                                        }}
                                      >
                                        {`${formatDate(
                                          props,
                                          alert.$createdAt,
                                          true
                                        )} : `}
                                        <span
                                          style={{
                                            fontWeight: "normal",
                                            fontSize: "12px"
                                          }}
                                        >
                                          {getLanguageVersion(alert.message)}
                                        </span>
                                        {alert.type === "missing_data" && (
                                          <div className="row">
                                            <div
                                              className="col-auto font-primary"
                                              style={{
                                                background: "#563BFF",
                                                marginTop: "10px",
                                                marginLeft: "20px",
                                                marginRight: "20px",
                                                paddingTop: "5px",
                                                paddingBottom: "5px",
                                                borderRadius: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                color: "white",
                                                gap: "8px",
                                                cursor: "pointer"
                                              }}
                                              onClick={() => {
                                                onSeletectAlert(alert);
                                                tog_list(alert);
                                              }}
                                            >
                                              {props.t("Valider")}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </Collapse>
                              </div>
                            ) : (
                              messageInfos &&
                              selectedMessage &&
                              messageInfos[selectedMessage.directMessageId] &&
                              (messageInfos[selectedMessage.directMessageId]
                                .failure_reason ||
                                messageInfos[selectedMessage.directMessageId]
                                  .dedicated_team_action_needed) && (
                                <div
                                  className="accordion-item"
                                  style={{
                                    maxHeight: "60vh",
                                    overflow: "scroll"
                                  }}
                                >
                                  {messageInfos[selectedMessage.directMessageId]
                                    .dedicated_team_action_needed ? (
                                    <h2
                                      className="accordion-header"
                                      id="headingFlushTwo"
                                      style={{ position: "relative" }}
                                    >
                                      <button
                                        className={classnames(
                                          "accordion-button",
                                          "font-size-16 d-flex align-items-center gap-1",
                                          {
                                            collapsed: !detailsAccordion.alerts
                                          }
                                        )}
                                        type="button"
                                        onClick={() =>
                                          onToggleDetailsAccordion(
                                            !detailsAccordion.alerts,
                                            "alerts"
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          fontWeight: "500"
                                        }}
                                      >
                                        <img
                                          src={logo_smartas_1}
                                          alt="logo_smartas_1"
                                          style={{
                                            width: "auto",
                                            height: "24px"
                                          }}
                                        />
                                        {props.t("Attentions Requises")}
                                        <span
                                          className="font-size-10 ms-auto"
                                          style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "6px"
                                          }}
                                        >
                                          {/* {detailsAccordion.alerts ? "Fermer" : "Ouvrir"} */}
                                        </span>
                                      </button>
                                    </h2>
                                  ) : (
                                    <h2
                                      className="accordion-header"
                                      id="headingFlushTwo"
                                      style={{ position: "relative" }}
                                    >
                                      <button
                                        className={classnames(
                                          "accordion-button",
                                          "font-size-16 d-flex align-items-center gap-1",
                                          {
                                            collapsed: !detailsAccordion.alerts
                                          }
                                        )}
                                        type="button"
                                        onClick={() =>
                                          onToggleDetailsAccordion(
                                            !detailsAccordion.alerts,
                                            "alerts"
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          fontWeight: "500"
                                        }}
                                      >
                                        <img
                                          src={
                                            messageInfos[
                                              selectedMessage.directMessageId
                                            ].process_state === "Treated"
                                              ? maaiaIconInfoPurple
                                              : maaiaIconInfoPink
                                          }
                                          alt="logo_smartas_1"
                                          style={{
                                            width: "auto",
                                            height: "24px"
                                          }}
                                        />
                                        {props.t(
                                          messageInfos[
                                            selectedMessage.directMessageId
                                          ].process_state
                                        )}
                                        <span
                                          className="font-size-10 ms-auto"
                                          style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "6px"
                                          }}
                                        >
                                          {/* {detailsAccordion.alerts ? "Fermer" : "Ouvrir"} */}
                                        </span>
                                      </button>
                                    </h2>
                                  )}

                                  <Collapse
                                    isOpen={detailsAccordion.alerts}
                                    className="accordion-collapse"
                                  >
                                    <div className="accordion-body">
                                      <div
                                        style={{
                                          maxWidth: "fit-content",
                                          fontWeight: "bold",
                                          color: "black"
                                        }}
                                      >
                                        {`${formatDate(
                                          props,
                                          messageInfos[
                                            selectedMessage.directMessageId
                                          ].$createdAt,
                                          true
                                        )} : `}
                                        <span
                                          style={{
                                            fontWeight: "normal",
                                            fontSize: "12px"
                                          }}
                                        >
                                          {getLanguageVersion(
                                            messageInfos[
                                              selectedMessage.directMessageId
                                            ].failure_reason ??
                                              messageInfos[
                                                selectedMessage.directMessageId
                                              ].dedicated_team_action_needed
                                          )}
                                        </span>
                                      </div>
                                      {/* {!messageInfos[selectedMessage.directMessageId].dedicated_team_action_needed &&
                                        messageInfos[selectedMessage.directMessageId].failure_reason && (
                                          <div className="row">
                                            <div
                                              className="col-auto font-primary"
                                              style={{
                                                background: "#563BFF",
                                                marginTop: "10px",
                                                marginLeft: "20px",
                                                marginRight: "20px",
                                                paddingTop: "5px",
                                                paddingBottom: "5px",
                                                borderRadius: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                color: "white",
                                                gap: "8px",
                                                cursor: "pointer"
                                              }}
                                              onClick={() => {
                                             deleteEmailProcessData(selectedMessage.directMessageId);
                                              }}>
                                              {props.t("Traiter à nouveau")}
                                            </div>
                                          </div>
                                        )} */}
                                    </div>
                                  </Collapse>
                                </div>
                              )
                            )}

                            {selectedMessage &&
                              messagesTagsList[
                                selectedMessage.directMessageId
                              ] &&
                              messagesTagsList[selectedMessage.directMessageId]
                                .length > 0 && (
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="headingFlushThree"
                                    style={{ position: "relative" }}
                                  >
                                    <button
                                      className={classnames(
                                        "accordion-button",
                                        "fw-medium font-size-16",
                                        { collapsed: !detailsAccordion.tags }
                                      )}
                                      type="button"
                                      onClick={() =>
                                        onToggleDetailsAccordion(
                                          !detailsAccordion.tags,
                                          "tags"
                                        )
                                      }
                                      style={{
                                        cursor: "pointer",
                                        fontWeight: "500"
                                      }}
                                    >
                                      {props.t("Catégories")}
                                      <span
                                        className="font-size-10 ms-auto"
                                        style={{
                                          position: "absolute",
                                          right: "20px",
                                          top: "6px"
                                        }}
                                      >
                                        {/* {detailsAccordion.tags ? "Fermer" : "Ouvrir"} */}
                                      </span>
                                    </button>
                                  </h2>
                                  <Collapse
                                    isOpen={detailsAccordion.tags}
                                    className="accordion-collapse"
                                  >
                                    <div className="accordion-body">
                                      <div
                                        className="d-flex gap-1"
                                        style={{
                                          flexWrap: "wrap"
                                        }}
                                      >
                                        {messagesTagsList[
                                          selectedMessage.directMessageId
                                        ].map((reason, index) => (
                                          <div
                                            key={index}
                                            className={`badge font-primary`}
                                            style={{
                                              backgroundColor: `${stringToColour(
                                                reason
                                              )}25`,
                                              color: stringToColour(reason),
                                              display: "flex",
                                              padding: "4px",
                                              maxWidth: "fit-content"
                                            }}
                                          >
                                            {props.t(reason)}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </Collapse>
                                </div>
                              )}
                          </div>
                        </Col>
                      )}
                    </div>
                  </div>
                </div>
                {/* <Col xl={3} className="mb-4 mb-xl-0 pe-1">
                      <div className="email-leftbar">
                        <div className="card">
                          <div className="card-body">
                            <div className="d-grid">
                              <Link
                                to="/compose-email"
                                className="btn btn-danger waves-effect waves-light w-100"
                              >
                             <i className="mdi mdi-plus me-2"></i>  
                                Nouveau message
                              </Link>
                            </div>

                            <div className="card p-0 overflow-hidden mt-4 shadow-none">
                              <div className="mail-list">
                                <div
                                  onClick={() => goToMessageReadView(undefined)}
                                  style={{ cursor: "pointer" }}
                                  className="active bg-soft-primary p-3"
                                >
                                  <div className="d-flex align-items-center">
                                    <i className="mdi mdi-email-outline font-size-20 align-middle me-3"></i>
                                    <div className="flex-grow-1">
                                      <h5 className="font-size-14 mb-0">
                                        Tous
                                      </h5>
                                      <span className="text-muted font-size-13 text-truncate">
                                        Tous les messages
                                      </span>
                                    </div>
                                    <div className="flex-shrink-0">
                                      <div className="float-end">
                                        <span className="bg-primary badge">
                                          18
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <a href="#" className="border-bottom">
                                  <div className="d-flex align-items-center">
                                    <i className="mdi mdi-star-outline font-size-20 align-middle me-3"></i>
                                    <div className="flex-grow-1">
                                      <h5 className="font-size-14 mb-0">
                                        Marqués
                                      </h5>
                                      <span className="text-muted font-size-13 text-truncate">
                                        Vos messages marqués
                                      </span>
                                    </div>
                                    <div className="flex-shrink-0"></div>
                                  </div>
                                </a>

                                                         <a href="#" className="border-bottom">
                              <div className="d-flex align-items-center">
                                <i className="mdi mdi-diamond-stone font-size-20 align-middle me-3"></i>
                                <div className="flex-grow-1">
                                  <h5 className="font-size-14 mb-0">Important</h5>
                                  <span className="text-muted font-size-13 text-truncate">
                                    Selected messages
                                  </span>
                                </div>
                                <div className="flex-shrink-0"></div>
                              </div>
                            </a> 

                                <a href="#" className="border-bottom">
                                  <div className="d-flex align-items-center">
                                    <i className="mdi mdi-file-outline font-size-20 align-middle me-3"></i>
                                    <div className="flex-grow-1">
                                      <h5 className="font-size-14 mb-0">
                                        Brouillon
                                      </h5>
                                      <span className="text-muted font-size-13 text-truncate"></span>
                                    </div>
                                    <div className="flex-shrink-0"></div>
                                  </div>
                                </a>

                                <a href="#" className="border-bottom">
                                  <div className="d-flex align-items-center">
                                    <i className="mdi mdi-email-check-outline font-size-20 align-middle me-3"></i>
                                    <div className="flex-grow-1">
                                      <h5 className="font-size-14 mb-0">
                                        Envoyés
                                      </h5>
                                      <span className="text-muted font-size-13 text-truncate"></span>
                                    </div>
                                    <div className="flex-shrink-0">
                                      <div className="float-end">
                                        <span className="bg-success badge">
                                          08
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <a href="#">
                                  <div className="d-flex align-items-center">
                                    <i className="mdi mdi-trash-can-outline font-size-20 align-middle me-3"></i>
                                    <div className="flex-grow-1">
                                      <h5 className="font-size-14 mb-0">
                                        Supprimés
                                      </h5>
                                      <span className="text-muted font-size-13 text-truncate"></span>
                                    </div>
                                    <div className="flex-shrink-0"></div>
                                  </div>
                                </a>
                              </div>
                            </div>

                                          <h5 className="mt-3 font-size-15 text-uppercase">Labels</h5>

                        <div className="card p-0 overflow-hidden mt-3 shadow-none">
                          <div className="mail-list">
                            <a href="#" className="border-bottom">
                              <span className="mdi mdi-arrow-right-drop-circle text-info float-end"></span>
                              Theme Support
                            </a>
                            <a href="#" className="border-bottom">
                              <span className="mdi mdi-arrow-right-drop-circle text-warning float-end"></span>
                              Freelance
                            </a>
                            <a href="#" className="border-bottom">
                              <span className="mdi mdi-arrow-right-drop-circle text-primary float-end"></span>
                              Social
                            </a>
                            <a href="#" className="border-bottom">
                              <span className="mdi mdi-arrow-right-drop-circle text-danger float-end"></span>
                              Friends
                            </a>
                            <a href="#">
                              <span className="mdi mdi-arrow-right-drop-circle text-success float-end"></span>
                              Family
                            </a>
                          </div>
                        </div>

                        <h5 className="mt-3 font-size-15 text-uppercase">Chat</h5>

                        <div className="card p-0 overflow-hidden mt-3 mb-1 shadow-none">
                          <div className="mail-list">
                            <a
                              href="javascript: void(0);"
                              className="d-flex align-items-start border-bottom"
                            >
                              <img
                                className="flex-shrink-0 me-3 rounded-circle"
                                src={avatar_2}
                                alt="Generic placeholder image"
                                height="36"
                              ></img>
                              <div className="flex-grow-1 chat-user-box">
                                <p className="user-title m-0">Scott Median</p>
                                <p className="text-muted mb-0">Hello</p>
                              </div>
                            </a>

                            <a
                              href="javascript: void(0);"
                              className="d-flex align-items-start border-bottom"
                            >
                              <img
                                className="flex-shrink-0 me-3 rounded-circle"
                                src={avatar_3}
                                alt="Generic placeholder image"
                                height="36"
                              ></img>
                              <div className="flex-grow-1 chat-user-box">
                                <p className="user-title m-0">Julian Rosa</p>
                                <p className="text-muted mb-0">
                                  What about our next..
                                </p>
                              </div>
                            </a>

                            <a
                              href="javascript: void(0);"
                              className="d-flex align-items-start border-bottom"
                            >
                              <img
                                className="flex-shrink-0 me-3 rounded-circle"
                                src={avatar_4}
                                alt="Generic placeholder image"
                                height="36"
                              ></img>
                              <div className="flex-grow-1 chat-user-box">
                                <p className="user-title m-0">David Medina</p>
                                <p className="text-muted mb-0">
                                  Yeah everything is fine
                                </p>
                              </div>
                            </a>

                            <a
                              href="javascript: void(0);"
                              className="d-flex align-items-start border-bottom"
                            >
                              <img
                                className="flex-shrink-0 me-3 rounded-circle"
                                src={avatar_6}
                                alt="Generic placeholder image"
                                height="36"
                              ></img>
                              <div className="flex-grow-1 chat-user-box">
                                <p className="user-title m-0">Jay Baker</p>
                                <p className="text-muted mb-0">Wow that's great</p>
                              </div>
                            </a>
                          </div>
                        </div> 
                          </div>
                        </div>
                      </div>
                    </Col> */}

                {/*  <!-- Right Sidebar --> */}

                {/* <!-- end Col-9 --> */}
              </div>
            </div>
            {/* <!-- End row --> */}

            {/* <!-- container-fluid --> */}

            {/* <!-- End Page-content --> */}

            {/* <!-- Modal --> */}
            <div
              className="modal fade"
              id="composemodal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="composemodalTitle"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5
                      className="modal-title font-primary"
                      id="composemodalTitle"
                    >
                      New Message
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="mb-3">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="To"
                        ></input>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Subject"
                        ></input>
                      </div>
                      <div className="mb-3">
                        <div id="email-editor"></div>
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary font-primary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="button" className="btn btn-primary">
                      Send{" "}
                      <i className="fab fa-telegram-plane ms-1 font-primary"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* @@include("partials/footer.html") */}
          </div>
          {/* <!-- end main content--> */}

          {/*  <!-- END layout-wrapper --> */}

          {/* @@include("partials/right-sidebar.html")

    @@include("partials/vendor-scripts.html") */}

          {/*  <!-- ckeditor --> */}
          <script src="assets/libs/@ckeditor/ckeditor5-build-classic/build/ckeditor.js"></script>

          {/* <!-- email editor init --> */}
          <script src="assets/js/pages/email-editor.init.js"></script>

          <script src="assets/js/app.js"></script>

          {/* </body> */}

          {/* </html> */}
        </Container>

        <div>
          <Modal
            isOpen={modal_backdrop}
            toggle={() => {
              togModalVisibility();
            }}
            id="firstmodal"
          >
            <div className="modal-header">
              <h5 className="modal-title" id="myModalLabel">
                Succès
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setModalVisibility(false);
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="font-primary">Votre message est envoyé !</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light "
                style={{ fontSize: "16px" }}
                onClick={() => {
                  setModalVisibility();
                }}
              >
                Okay
              </button>
            </div>
          </Modal>
        </div>
        {startCountdown && (
          <div
            className="position-fixed p-3"
            style={{ zIndex: "9999999", bottom: "10px", left: "35px" }}
          >
            <CustomToast
              isOpen={startCountdown}
              toggle={() => {
                stopDeletionCountdown();
              }}
              message={{
                title: props.t("Message"),
                body: (
                  <div className="mt-2">
                    <Button
                      className="font-primary simple-text me-2"
                      onClick={() => {
                        stopDeletionCountdown();
                      }}
                      style={{
                        fontSize: "14px",
                        borderRadius: "12px"
                      }}
                    >
                      {props.t("Annuler la suppression")}
                    </Button>
                    {decompte}s
                  </div>
                ),
                key: "danger"
              }}
            />
          </div>
        )}
        {actionPerformed && (
          <div
            className="position-fixed p-3"
            style={{ zIndex: "9999999", bottom: "10px", left: "35px" }}
          >
            <CustomToast
              isOpen={actionPerformed ? true : false}
              toggle={() => {
                setActionPerformed(false);
              }}
              message={actionPerformed}
            />
          </div>
        )}

        <div
          className="position-fixed bottom-0 end-0 p-3"
          style={{ zIndex: "9999999" }}
        >
          <CustomToast
            isOpen={toast}
            toggle={toggleToast}
            message={toastMessage}
          />
        </div>
        <div>
          <Modal
            isOpen={modal_dossier}
            toggle={() => {
              togModalDossierVisibility();
            }}
            id="firstmodal"
          >
            <div className="modal-header">
              <h5 className="modal-title font-primary" id="myModalLabel">
                {props.t("Dossiers")}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  togModalDossierVisibility(false);
                }}
              >
                {/* <span aria-hidden="true">&times;</span> */}
              </button>
            </div>
            <div className="modal-body">
              {boxes &&
                boxes[localStorage.getItem("companyId")] &&
                boxes[localStorage.getItem("companyId")].map(
                  (folder, index) => (
                    <div key={index}>
                      <Row
                        // onClick={() => {
                        //   selectedAction(
                        //     selectedMessage.messageId,
                        //     the_folder,
                        //     folder.name
                        //   );
                        // }}
                        onClick={() => {
                          if (type === "move") {
                            togModalDossierVisibility();
                            tog_Modal(folder);
                          } else {
                            selectedAction(
                              multiSelectedMessage.length > 0
                                ? multiSelectedMessage
                                : [selectedMessage.messageId],
                              getBoxFromUrl(),
                              folder.name
                            );
                          }
                        }}
                        key={index}
                        className="mb-2"
                        style={{
                          borderBottom: "solid",
                          borderBottomWidth: "1px",
                          paddingBottom: "14px",
                          paddingTop: "10px",
                          borderColor: "#80808029"
                        }}
                      >
                        <div style={{ cursor: "pointer" }} className="">
                          <div key={index} className={``}>
                            {props.t(getBoxLocalName(folder.name))}
                            <br />
                          </div>
                        </div>
                      </Row>
                    </div>
                  )
                )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  togModalDossierVisibility();
                }}
              >
                {props.t("Annuler")}
              </button>
            </div>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(GlobaleInbox);
